<template>
<v-container>
<v-container fluid pa-0 v-if="currentActionRoute === 'ReviewInformation'" class="d-flex flex-column flex-gap-16">
<v-row class="pb-0 pt-0 ml-0">
  <v-col cols="12" lg="12" md="12" class="fill-height d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pb-0 pt-0">
    <div class="header-spacing pb-0 pt-0">
      <h3
      :class="language !== '' ? 'onboarding-title text-right mb-0' : 'onboarding-title text-left mb-0'"
      :style="{
        'font-family': customCSS && customCSS['formTitle-fontFamily'],
      }"
      >
      {{ $t('reviewInformation.reviewInformation') }}
      </h3>
      <p class="content-size" style="margin-bottom: 0px !important;">{{ $t('reviewInformation.reviewInformationHelper') }}</p>
    </div>
  </v-col>
</v-row>
<!-- Product Details Section Start -->
<v-row class="pb-0 pt-0 ml-0">
  <v-col cols="12" lg="12" md="12" class="pl-4 pr-4">
    <h5 class="heading-five"><br /><br />{{ $t('reviewInformation.productChosen') }}</h5>
    <div style="display: flex; flex-direction: column; gap:32px;">
      <div class="header-spacing">
        <p
        class="reviewInformation-subSectionHeader text-capitalize mb-0"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionHelperTextColor']
        }"
        >
        <br />{{ $t('reviewInformation.productName') }}<br />
        </p>
        <p
        class="productSection-content mb-0"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionContentColor']
        }"
        >
        {{ productData.data.productDescription }}
        </p>
      </div>
      <div class="header-spacing">
        <p
        class="reviewInformation-subSectionHeader mb-0"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionHelperTextColor']
        }"
        >
        {{ $t('reviewInformation.productDetails') }}
        </p>
      </div>
    </div>
  </v-col>
  <v-col cols="12" lg="12" md="12" class="d-flex d-sm-flex flex-row flex-sm-row horizontal-spacing pt-0 pl-4 pr-4">
    <v-row>
      <v-col cols="5" class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column pb-0 pt-0 pl-1 pr-0">
        <v-col lg="4" md="6" sm="6" class="pt-0 justify-space-between pl-0 pr-0">
          <v-card flat class="pa-2 container-spacing">
            <div class="header-spacing" v-if="reviewInformation && reviewInformation.creditInterestRate.enableComponent">
              <p class="productInfo-header">{{ $t('reviewInformation.creditInterest') }}</p>
              <p :class="language !== '' ? 'product-header' : 'product-header productInfo-spacing'">{{ productData.data.creditInterestRateFixed }}</p>
            </div>
          </v-card>
        </v-col>
        <v-col lg="7" md="7" sm="6" class="pt-0 justify-space-between pl-0 pr-0">
          <v-card flat class="pa-2 container-spacing">
            <div class="header-spacing" v-if="reviewInformation && reviewInformation.debitInterestRate.enableComponent">
              <p class="productInfo-header">{{ $t('reviewInformation.debitInterest') }}</p>
              <p class="product-header">{{ productData.data.debitInterestRateFixed }}</p>
            </div>
          </v-card>
        </v-col>
      </v-col>
      <v-col  cols="5" class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column pb-0 pt-0 pl-0 pr-0">
        <v-col lg="6" md="6" sm="6" class="pt-0 pl-0 pr-0 justify-space-between">
          <v-card flat class="pa-2 container-spacing">
            <div class="header-spacing" v-if="reviewInformation && reviewInformation.minimumAccountOpeningBalance.enableComponent">
              <p
              class="productInfo-header mb-0"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                color: customCSS && customCSS['onboarding-sectionContentColor']
              }"
              >
              {{ $t('reviewInformation.minimumBalance') }}
              </p>
              <div v-if="productData && productData.data && productData.data.minimumAccountOpeningBalance && productData.data.minimumAccountOpeningBalance.value">
                <p class="product-header">£ {{ productData.data.minimumAccountOpeningBalance.value }}</p>
              </div>
              <div v-else>
                <p class="product-header">£ 0</p>
              </div>
            </div>
          </v-card>
        </v-col>
        <v-col lg="6" md="6" sm="6" class="pt-0 justify-space-between pl-0 pr-0">
          <v-card flat class="pa-2 container-spacing">
            <div class="header-spacing" v-if="reviewInformation && reviewInformation.readOnlyProductCurrency.enableComponent">
              <p class="productInfo-header">{{ $t('reviewInformation.currency') }}</p>
              <p class="product-header">
                {{ productData.data.currencyCode }}
              </p>
            </div>
          </v-card>
        </v-col>
      </v-col>
    </v-row>
  </v-col>
</v-row>
<!-- Product Details Section End -->
<!-- Account OwnerShip section Read mode start. -->
<v-row class="pb-0 pt-10 ml-0" v-if="['savings', 'termDeposit'].includes(productType) && !['SOLE', 'SINGLE'].includes(productData.data.applicableAccountOperationType)">
  <v-col cols="11" class="d-flex justify-space-between" v-if="['savings', 'termDeposit'].includes(productType)">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
    {{ $t('reviewInformation.accountOwnership') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="readOnlyAccountOwnershipDetails === true ? editAccountDetails() : editAccountDetailsCheck = false" v-if="!editAccountDetailsCheck"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="editAccountDetailsCheck">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      :style="{'font-family': customCSS['onboardingBtn-fontFamily']}"
      @click="resetAccountInformation()"
      v-if="editAccountDetailsCheck"
      >
      {{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      :style="{'font-family': customCSS['onboardingBtn-fontFamily']}"
      v-if="editAccountDetailsCheck"
      :disabled="accountOwnership === 'JOINT' && (formData.modeOfOperation === '' || formData.modeOfOperation === undefined) ? true : false"
      @click="updateAccountOwnerShipDetails()"
      >
      {{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <v-col cols= "11" class="pl-6 justify-space-between d-flex flex-column" v-if="readOnlyAccountOwnershipDetails && !editAccountDetailsCheck">
    <v-row style="" class="pt-0">
      <v-col md="5" offset-md="0" class="d-flex justify-start pl-0 container-spacing" style="disply: flex; flex-direction: row">
        <div class="text-spacing">
          <div class="header-spacing">
            <p
            class="reviewInformation-header mb-0"
            :style="{
              'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              color: customCSS['onboarding-sectionHelperTextColor'],
            }"
            >
            {{ $t('reviewInformation.accountType') }}
            </p>
            <p
            class="reviewInformation-sectionContent text-none mb-0"
            :style="{
              'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              color: customCSS['onboarding-sectionContentColor'],
            }"
            >
            {{productInformation?.accountOwnership === 'SOLE' || productData?.data?.applicableAccountOperationType === 'SINGLE' ? $t('reviewInformation.sole') : $t('reviewInformation.joint')}}
            </p>
          </div>
        </div>
      </v-col>
      <v-col md="5" offset-md="0" class="d-flex justify-start ml-2 pl-5 pr-5 container-spacing" style="disply: flex; flex-direction: row" v-if="!['SOLE', 'SINGLE'].includes(productData?.applicableAccountOperationType)">
        <div class="text-spacing">
          <div class="header-spacing" v-if="productInformation?.accountOwnership === 'JOINT'">
            <p
            class="reviewInformation-header mb-0"
            :style="{
              'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              color: customCSS['onboarding-sectionHelperTextColor'],
            }"
            >
            {{ $t('reviewInformation.readOnlyModeOfOperation') }}
            </p>
            <p
            class="reviewInformation-sectionContent mb-0"
            :style="{
              'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
              color: customCSS['onboarding-sectionContentColor'],
            }"
            v-if="productInformation?.accountOwnership === 'JOINT'"
            >
            {{ readOnlyModeOfOperation }}
            </p>
          </div>
        </div>
      </v-col>
    </v-row>
    <v-row style="display: flex; flex-direction: column;" class="py-6" v-if="accountOwnership === 'JOINT'">
      <p
      class="reviewInformation-header mb-0"
      :style="{
        'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
        color: customCSS['onboarding-sectionHelperTextColor'],
      }"
      >
      {{ $t('reviewInformation.relationshipDetails') }}
      </p>
      <div class="d-flex flex-row align-start pt-4" style="gap: 12px !important">
        <p class="account-ownership"><BaseIcon name="info_filled" size="xs" iconClass="vertical-alignment" :color="customCSS['primary']"/>
        {{ $t('reviewInformation.accountOwnershipHelper')}}</p>
      </div>
    </v-row>
  </v-col>
  <v-col cols="11" class="pl-6 d-flex justify-space-between d-flex flex-column">
  <div style="display: flex; flex-direction: column; gap: 24px;" class="pb-0 pt-0" v-if="editAccountDetailsCheck === true">
    <v-col md="11">
      <div>
        <v-row md="12" lg="12" style="" class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
          <v-row>
            <v-col cols="12" sm="12" md="8" lg="8" class="pl-0 pt-0">
              <div v-for="(components, index) in reviewInformation.accountOwershipDetails" :key="index" style="display: flex;flex-direction: column;gap: 16px !important;">
                <div v-if="components.type === 'v-html' && components.enableComponent">
                  <div v-html="components.data" :class="components.class"></div>
                </div>
                <div class="d-flex flex-wrap mt-2" v-if="components.type === 'VRadioGroup'">
                  <v-radio-group v-model="accountOwnership" :row="mobileView()" :disabled="components.disabled">
                    <template v-slot:label></template>
                    <template v-for="(item, index) in components.values">
                      <v-radio v-bind:key="index" :color="customCSS['primary']" :label="$t(`reviewInformation.item.${components.key}.${item.label}`)" :value="item.value">
                      </v-radio>
                    </template>
                  </v-radio-group>
                </div>
              </div>
              <div v-if="accountOwnership === 'JOINT'">
                <div v-for="(components, index) in reviewInformation.jointAccountDetails" :key="index" style="display: flex;flex-direction: column;gap: 16px !important;">
                  <div v-if="components.type === 'v-html' && components.enableComponent">
                    <div v-html="components.data" :class="components.class"></div>
                  </div>
                  <div class="d-flex flex-wrap mt-2" v-if="components.type === 'VRadioGroup'">
                    <v-radio-group v-model="secondaryApplicantOnboarding" :row="mobileView()" :disabled="components.disabled">
                      <template v-slot:labe></template>
                        <template v-for="(item, index) in components.values">
                          <v-radio v-bind:key="index" :color="customCSS['primary']" :label="$t(`reviewInformation.item.${components.key}.${item.label}`)" :value="item.value">
                          </v-radio>
                        </template>
                    </v-radio-group>
                  </div>
                  <div v-if="components.type !=='VCheckbox'">
                    <component
                    v-if="components.enableComponent"
                    validate-on-blur
                    :is="componentType[components.type].component"
                    :label="$t(`reviewInformation.${components.key}`)"
                    :hint="components.hint"
                    :rules="components?.required ? requiredRules : []"
                    :persistent-hint="components.persistent"
                    :filled="components.filled"
                    :key="components.key"
                    :items="productType === 'termDeposit' ? $appSettings.dcoConfigurations.modeOfOperationFD.data : $appSettings.dcoConfigurations.modeOfOperationSavings.data"
                    item-text="codeDescription"
                    item-value="codeReference"
                    :[components.iconPlacement]="components.icon"
                    :true-value="components.trueValue"
                    :false-value="components.falseValue"
                    v-model="formData[components.key]"
                    v-bind:value="formData[components.key]"
                    :class="components.class"
                    :hide-details="components.hideDetails? components.hideDetails : false"
                    :defalut="components.default"
                    @change="handleChange($event, components.key)">
                    </component>
                  </div>
                </div>
                <v-row style="display: flex; flex-direction: column;" class="py-6" v-if="accountOwnership === 'JOINT'">
                  <p
                  class="reviewInformation-header mb-0"
                  :style="{
                    'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                    color: customCSS['onboarding-sectionHelperTextColor'],
                  }"
                  >
                  {{ $t('reviewInformation.relationshipDetails') }}
                  </p>
                  <div class="d-flex flex-row align-start pt-4" style="gap: 12px !important">
                    <p class="account-ownership"><BaseIcon name="info_filled" size="xs" iconClass="vertical-alignment" :color="customCSS['primary']"/>
                    {{ $t('reviewInformation.accountOwnershipHelper1')}}</p>
                  </div>
                </v-row>
              </div>
            </v-col>
          </v-row>
        </v-row>
      </div>
    </v-col>
  </div>
</v-col>
</v-row>
<!-- Account OwnerShip section Read mode end. -->
<!-- Account OwnerShip section Edit mode start. -->
<!-- Account OwnerShip section Edit mode end. -->
<!-- Tabs for Joint account party Data -->
<v-tabs v-model="tab" v-if="productInformation?.accountOwnership === 'JOINT' && readOnlyAccountOwnership === 'JOINT'">
  <v-tab  class="text-none tab-name" :style="{ 'font-family': customCSS['tabTitle-fontFamily'], color: customCSS['primary'] }">{{$t('reviewInformation.primaryApplicant')}}</v-tab>
  <v-tab class="text-none tab-name" :style="{ 'font-family': customCSS['tabTitle-fontFamily'], color: customCSS['primary'] }">{{$t('reviewInformation.secondaryApplicant')}}</v-tab>
</v-tabs>
<div v-if="tab === 0">
<v-row class="pb-0 pt-10 ml-0">
  <v-col cols="11" class="d-flex justify-space-between">
    <h5 class="subDetails-header">{{ $t('reviewInformation.yourDetails') }}</h5>
    <v-btn text rounded :color="customCSS['secondary']" class="text-none edit-button" @click="expandCollapseDetails(0, label)">
      <div v-if="label === $t('reviewInformation.collapse')">
        <BaseIcon name="remove" size="xs" :color="customCSS['secondary']"/>
        {{ label }}
      </div>
      <div v-else>
        <BaseIcon name="add" size="xs" :color="customCSS['secondary']"/>
        {{ label }}
      </div>
    </v-btn>
  </v-col>
</v-row>
<!-- Contact Details Section Start -->
<v-row class="pb-0 pt-0 ml-0">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="readOnlyContactDetails = !readOnlyContactDetails"><div v-if="readOnlyContactDetails"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.contact') }}
    </h6>
    <p class="disabled-button">{{ $t('reviewInformation.readOnly') }}</p>
  </v-col>
  <v-col cols= "11" class="pl-6 d-flex justify-space-between" v-if="readOnlyContactDetails">
    <div class="text-spacing">
      <div class="header-spacing">
        <p class= "section-headers">{{ $t('reviewInformation.mobile') }}</p>
        <p class="section-content">{{ mobileNumber }}</p>
      </div>
      <div v-if="emailId !== ''" class="header-spacing">
        <p class="section-headers">{{ $t('reviewInformation.email') }}</p>
        <p class="section-content">{{ emailId }}</p>
      </div>
    </div>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Contact Details Section End -->
<!-- Address Details Section Start -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandAddressSection = !expandAddressSection"><div v-if="expandAddressSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.address') }}
    </h6>
    <p class="disabled-button" v-if="(productType === 'currentAccount' || productType === 'savings') && !reviewInformation.addressLookup[0].enableForCurrentSavings">{{ $t('reviewInformation.readOnly') }}</p>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandAddressSection = true,showUnsavedSnackbar('readOnlyAddressDetails', false)" v-if="readOnlyAddressDetails && ((productType !== 'currentAccount' || productType !== 'savings') || ((productType === 'currentAccount' || productType === 'savings') && reviewInformation.addressLookup[0].enableForCurrentSavings))"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyAddressDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="addressInformationData(0),showUnsavedSnackbar('readOnlyAddressDetails', true)"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('addressInformation','readOnlyAddressDetails') : editSaveChanges('addressInformation','readOnlyAddressDetails')"
      :disabled="enableSaveButton('addressDetails')">{{ $t('reviewInformation.save') }}</v-btn>
    </div>
  </v-col>
  <v-col v-if="expandAddressSection">
    <!-- Address Details with address lookup enabled start. -->
    <v-col cols= "11" class="pl-6 d-flex justify-space-between d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="readOnlyAddressDetails && ((isAddressLookupEnabled || isAddressLookupEnabled === 'true') && !addressAddedManually)">
      <v-col sm="12" md="6" lg="6" class="pl-0">
        <div class="text-spacing">
          <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
            <p class="overline-styles" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.residentialAddress') }}</p>
            <p class="text-styles">{{ primaryReview }}</p>
            <p class="sub-text mb-0 mt-1"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{$t('reviewInformation.verifiedAddress')}}</p>
            <p class="sub-text mb-0 mt-1" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.primaryAddress.isDefault"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{$t('reviewInformation.setFormCommunicationUse')}}</p>
          </div>
        </div>
      </v-col>
      <v-col sm="12" md="6" lg="6" class="pl-0">
        <div class="text-spacing">
          <div class="header-spacing" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.correspondenceAddress && contactDetails.primaryAddress.addressLine1 === contactDetails.correspondenceAddress.addressLine1">
            <p class="overline-styles">{{ $t('reviewInformation.correspondenceAddress') }}</p>
            <p class="text-styles">{{ $t('reviewInformation.sameAddress') }}</p>
            <p class="sub-text mb-0 mt-1" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.isDefault"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{$t('reviewInformation.setFormCommunicationUse')}}</p>
          </div>
          <div v-if="reviewInformation.correspondenceAddressInformation.enableComponent === true && !reviewCorresponding && contactDetails && contactDetails.primaryAddress && contactDetails.correspondenceAddress && contactDetails.primaryAddress.addressLine1 !== contactDetails.correspondenceAddress.addressLine1" class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.correspondenceAddress') }}</p>
            <p class="text-styles">{{ correspondenceReview }}</p>
            <p class="sub-text mb-0" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.isDefault"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{$t('reviewInformation.setFormCommunicationUse')}}</p>
          </div>
          <div v-if="selected && contactDetails && contactDetails.previousResidentialAddress === undefined" class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.previousAddress') }}</p>
            <p class="text-styles">{{ $t('reviewInformation.sameAddressPrevious') }}</p>
          </div>
          <div v-if="reviewInformation.previousResidentialAddress.enableComponent === true && !selected" class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.previousAddress') }}</p>
            <p class="text-styles">{{ previousReview }}</p>
          </div>
        </div>
      </v-col>
    </v-col>
    <div>
      <v-col sm="12" md="6" lg="6" class="pl-6 d-flex flex-column justify-space-between" v-if="!readOnlyAddressDetails">
        <v-switch label="Enter the Address Manually" :color="customCSS['primary']" :true-value="true" :false-value="false"
        :disabled="(isAddressLookupEnabled === 'false' || !isAddressLookupEnabled)" v-model="addressAddedManually" @click="clearAddressValues(addressAddedManually), enableSaveButton('addressDetails')">
        </v-switch>
      </v-col>
      <v-col sm="12" md="6" lg="6" class="pl-6 d-flex flex-column justify-space-between" v-if="(isAddressLookupEnabled || isAddressLookupEnabled === 'true') && !addressAddedManually && reviewInformation.addressLookup[0].enabledForPrimaryAddress.includes(getProductType) && !readOnlyAddressDetails">
        <v-text-field v-model="residentialAddress"
        filled
        clearable
        :label="$t(`reviewInformation.findAddress`)"
        :hint="reviewInformation.addressLookup[0].hint"
        persistent-hint
        :rules="reviewInformation.addressLookup[0]?.required ? [addressLookupRule, addressLookupRegex, requiredRules].flat() : [addressLookupRule, addressLookupRegex].flat()"
        @click:clear="residentialAddress ='', enableSaveButton('addressDetails')"
        >
        <template v-slot:append>
          <div class="mt-n1">
            <v-btn
            rounded
            :color="customCSS['primary']"
            class="white--text text-none"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily']}"
            @click="enableAddressLookup('residential', residentialAddress)">
            {{ $t(`reviewInformation.search`) }}
            </v-btn>
          </div>
        </template>
      </v-text-field>
      <div v-if="(isAddressLookupEnabled || isAddressLookupEnabled === 'true') && reviewInformation.addressLookup[0].enabledForCorrespondenceAddress.includes(getProductType)">
        <div v-for="(components, index) in reviewInformation.addressLookup" :key="index" style="display: flex;flex-direction: column;gap: 21px;">
          <div v-if="components.enableComponent">
            <v-switch
            :label="$t(`reviewInformation.addressLookup.corresponding`)"
            :color="customCSS['primary']"
            :true-value="true"
            :false-value="false"
            v-model="reviewCorresponding"
            @change="enableSaveButton('addressDetails')"
            >
            </v-switch>
          </div>
          <div v-if="!reviewCorresponding">
            <v-row>
              <v-col>
                <v-text-field
                v-model="correspondenceAddress"
                filled
                clearable
                :label="$t(`reviewInformation.findAddress`)"
                :hint="reviewInformation.addressLookup[0].hint"
                persistent-hint
                :rules="reviewInformation.addressLookup[0]?.required ? [addressLookupRule, addressLookupRegex, requiredRules].flat() : [addressLookupRule, addressLookupRegex].flat()"
                @click:clear="correspondenceAddress = '', enableSaveButton('addressDetails')"
                >
                <template v-slot:append>
                  <div class="mt-n1">
                    <v-btn rounded :color="customCSS['primary']" class="white--text text-none" :style="{'font-family': customCSS['onboardingBtn-fontFamily']}" @click="enableAddressLookup('correspondence', correspondenceAddress)"> {{ $t(`reviewInformation.search`) }} </v-btn>
                  </div>
                </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <p class="mb-0 mt-5">{{ $t('reviewInformation.useForCommunication') }}</p>
          <div class="d-flex flex-wrap mt-2">
            <v-radio-group v-model="isDefault" :row="mobileView()">
              <template v-for="(item, index) in communicationFlag">
                <v-radio
                v-bind:key="index"
                :color="customCSS['primary']"
                :label="$t(`reviewInformation.item.isDefault.${item.label}`)"
                :value="item.value"
                >
                </v-radio>
              </template>
            </v-radio-group>
          </div>
          <v-divider></v-divider>
        </div>
      </div>
      <div v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)">
        <p
        class="addressSection-content"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionSubTitleColor'],
        }"
        v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)"
        >
        {{ $t('reviewInformation.previousResidentialAddress')}}
        </p>
        <p
        class="kyc-description"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionContentColor'],
        }"
        v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)"
        >
        {{ $t('reviewInformation.previousResidentialAddressHelper')}}
        </p>
        <div class="d-flex flex-wrap" v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)">
          <v-radio-group v-model="selected" :row="mobileView()" @change="clearAddressData('previousResidential')">
            <template v-for="(item, index) in residenceAddress">
              <v-radio v-bind:key="index" :label="$t(`reviewInformation.item.selected.${item.label}`)" :value="item.value">
              </v-radio>
            </template>
          </v-radio-group>
        </div>
        <div v-if="selected === false && reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)">
          <div>
            <v-row>
              <v-col>
                <v-text-field
                v-model="previousResidentialAddress"
                filled
                clearable
                :label="$t(`reviewInformation.findAddress`)"
                :hint="reviewInformation.addressLookup[0].hint"
                persistent-hint
                :rules="reviewInformation.addressLookup[0]?.required ? [addressLookupRule, addressLookupRegex, requiredRules].flat() : [addressLookupRule, addressLookupRegex].flat()"
                @click:clear="previousResidentialAddress = '', enableSaveButton('addressDetails')"
                >
                <template v-slot:append>
                  <div class="mt-n1">
                    <v-btn rounded :color="customCSS['primary']" class="white--text text-none" :style="{'font-family': customCSS['onboardingBtn-fontFamily']}" @click="enableAddressLookup('previousResidential', previousResidentialAddress)"> {{ $t(`reviewInformation.search`)}} </v-btn>
                  </div>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </div>
        <v-row class="justify-space-between">
          <v-col cols="6" sm="3" md="6" lg="6">
            <v-menu
            v-model="fromMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
              :value="formatFromDate"
              :label="$t(`reviewInformation.addressFrom`)"
              filled
              append-icon="mdi-calendar"
              readonly v-bind="attrs" v-on="on"
              @keydown.tab="fromMenu = false"
              :rules="reviewInformation.addressLookup[0]?.required ? [requiredRules] : []"
              >
              </v-text-field>
            </template>
            <v-date-picker
            v-model="fromDate"
            no-title
            :max="today"
            :color="customCSS['primary']"
            :show-current="false"
            @change="enableSaveButton('addressDetails')"
            @input="fromMenu = false, toDate = null"
            >
            </v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="6" sm="3" md="6" lg="6">
            <v-menu
            v-model="toMenu"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            min-width="auto"
            >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
              v-model="formatToDate"
              :label="$t(`reviewInformation.addressTo`)"
              filled
              append-icon="mdi-calendar"
              readonly v-bind="attrs" v-on="on"
              @keydown.tab="toMenu = false"
              :rules="reviewInformation.addressLookup[0]?.required ? [requiredRules] : []"
              >
              </v-text-field>
            </template>
            <v-date-picker
            v-model="toDate"
            no-title
            @input="toMenu = false"
            :min="fromDate"
            :max="today"
            :color="customCSS['primary']"
            :show-current="false"
            @change="enableSaveButton('addressDetails')"
            >
            </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-col>
  </div>
  <!-- Address Details with address lookup enabled end. -->
  <!-- Address Details with address lookup disabled start. -->
  <v-col cols= "11" class="pl-6 d-flex flex-column flex-gap-16 justify-space-between" style="gap:64px !important;" v-if="readOnlyAddressDetails && ((!isAddressLookupEnabled || isAddressLookupEnabled === 'false') || addressAddedManually)">
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column">
    <v-row :class="language === '' ? 'pl-7 pb-3' : 'pr-7 pb-3'">
      <p class="sectional-headers mt-4" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.residentialAddressManual') }}</p>
    </v-row>
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
          <div class="text-spacing">
          <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyPostCode') }}</p>
            <p class="text-styles">{{ contactDetails.primaryAddress.postCode }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.primaryAddress.countryName !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyCountry') }}</p>
            <p class="text-styles">{{ contactDetails.primaryAddress.countryName }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.primaryAddress.stateOrprovinceName !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyState') }}</p>
            <p class="text-styles">{{ contactDetails.primaryAddress.stateOrprovinceName }}</p>
          </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
          <div class="text-spacing">
          <div class="header-spacing" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.primaryAddress.city !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
            <p class="text-styles">{{ contactDetails.primaryAddress.city }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.primaryAddress.addressLine1 !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine1') }}</p>
            <p class="text-styles">{{ contactDetails.primaryAddress.addressLine1 }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.primaryAddress.addressLine2 !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine2') }}</p>
            <p class="text-styles">{{ contactDetails.primaryAddress.addressLine2 }}</p>
          </div>
        </div>
      </div>
      </div>
    </v-col>
    </v-row>
    <v-row :class="language === '' ? 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pl-7 mt-1' : 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pr-7 mt-1'">
      <p class="sub-text mb-0 mt-4"><BaseIcon name="info_filled" iconClass="vertical-alignment pr-2" :color="customCSS['primary']"/>{{ $t('reviewInformation.manualAddress') }}</p>
      <p class="sub-text mb-0" v-if="contactDetails && contactDetails.primaryAddress && (contactDetails.primaryAddress.isDefault === true || contactDetails.primaryAddress.isDefault === 'true')"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{ $t('reviewInformation.communicationUse') }}</p>
    </v-row>
    </v-row>
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column" v-if="((productType !== 'currentAccount' || productType !== 'savings')) || ((productType === 'currentAccount' || productType === 'savings') && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress !== undefined && contactDetails.correspondenceAddress.postCode !== '')">
      <v-row :class="language === '' ? 'pl-7 pb-3' : 'pr-7 pb-3'">
        <p class="sectional-headers" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.correspondenceAddressManual') }}</p>
      </v-row>
      <v-row v-if="contactDetails && contactDetails.primaryAddress && contactDetails.correspondenceAddress && contactDetails.primaryAddress.postCode === contactDetails.correspondenceAddress.postCode" :class="language === '' ? 'pl-7' : 'pr-7'">
        <p class="text-styles">{{ $t('reviewInformation.sameAddress') }}</p>
      </v-row>
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="contactDetails && contactDetails.primaryAddress && contactDetails.correspondenceAddress && contactDetails.primaryAddress.postCode !== contactDetails.correspondenceAddress.postCode">
        <v-col sm="12" md="12" lg="6" :class="language  === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
              <div class="text-spacing">
                <div class="header-spacing">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyPostCode') }}</p>
                  <p class="text-styles">{{ contactDetails.correspondenceAddress.postCode }}</p>
                </div>
                <div class="header-spacing" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.countryName !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyCountry') }}</p>
                  <p class="text-styles">{{ contactDetails.correspondenceAddress.countryName }}</p>
                </div>
                <div class="header-spacing" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.stateOrprovinceName !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyState') }}</p>
                  <p class="text-styles">{{ contactDetails.correspondenceAddress.stateOrprovinceName }}</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
              <div class="text-spacing">
                <div class="header-spacing" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.city !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                  <p class="text-styles">{{ contactDetails.correspondenceAddress.city }}</p>
                </div>
                <div class="header-spacing" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.addressLine1 !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine1') }}</p>
                  <p class="text-styles">{{ contactDetails.correspondenceAddress.addressLine1 }}</p>
                </div>
                <div class="header-spacing" v-if="contactDetails && contactDetails.correspondenceAddress && contactDetails.correspondenceAddress.addressLine2 !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine2') }}</p>
                  <p class="text-styles">{{ contactDetails.correspondenceAddress.addressLine2 }}</p>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row :class="language === '' ? 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pl-7 mt-4' : 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pr-7 mt-4'" v-if="contactDetails && contactDetails.correspondenceAddress && (contactDetails.correspondenceAddress.isDefault === true || contactDetails.correspondenceAddress.isDefault === 'true')">
        <p class="sub-text mb-0"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/>{{ $t('reviewInformation.communicationUse') }}</p>
      </v-row>
    </v-row>
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column">
    <v-row :class="language === '' ? 'pl-7 pb-3' : 'pr-7 pb-3'">
      <p class="sectional-headers" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.previousAddressManual') }}</p>
    </v-row>
    <v-row v-if="!contactDetails?.previousResidentialAddress" :class="language === '' ? 'pl-7' : 'pr-7'">
      <p class="text-styles">{{ $t('reviewInformation.sameAddressPrevious') }}</p>
    </v-row>
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="contactDetails?.previousResidentialAddress">
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true && contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress !== undefined" class="header-spacing">
          <div class="text-spacing">
          <div class="header-spacing" v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.addressLine1 !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyPostCode') }}</p>
            <p class="text-styles">{{ contactDetails.previousResidentialAddress.postCode }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.countryName !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyCountry') }}</p>
            <p class="text-styles">{{ contactDetails.previousResidentialAddress.countryName }}</p>
          </div>
          <v-row v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.stateOrprovinceName && contactDetails.previousResidentialAddress.stateOrprovinceName !== ''">
            <v-col cols="6">
              <div class="header-spacing" v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.stateOrprovinceName !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyState') }}</p>
            <p class="text-styles">{{ contactDetails.previousResidentialAddress.stateOrprovinceName }}</p>
          </div>
            </v-col>
            <v-col cols="6">
              <div class="header-spacing" v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.city !== ''">
                <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                <p class="text-styles">{{ contactDetails.previousResidentialAddress.city }}</p>
              </div>
            </v-col>
          </v-row>
          <div class="header-spacing" v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.city && contactDetails.previousResidentialAddress.city !== ''">
                <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                <p class="text-styles">{{ contactDetails.previousResidentialAddress.city }}</p>
              </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true && contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress !== undefined" class="header-spacing">
          <div class="text-spacing">
          <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine1') }}</p>
            <p class="text-styles">{{ contactDetails.previousResidentialAddress.addressLine1 }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.previousResidentialAddress && contactDetails.previousResidentialAddress.addressLine2 !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine2') }}</p>
            <p class="text-styles">{{ contactDetails.previousResidentialAddress.addressLine2 }}</p>
          </div>
          <v-row>
            <v-col cols="6">
              <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressFrom') }}</p>
            <p class="text-styles">{{ readOnlyFromDate }}</p>
          </div>
            </v-col>
            <v-col cols="6">
              <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressTo') }}</p>
            <p class="text-styles">{{ readOnlyToDate }}</p>
          </div>
            </v-col>
          </v-row>
        </div>
      </div>
      </div>
    </v-col>
    </v-row>
    </v-row>
  </v-col>
  <v-col cols= "11" class="d-flex flex-column justify-space-between" v-if="!readOnlyAddressDetails && ((!isAddressLookupEnabled || isAddressLookupEnabled === 'false')|| addressAddedManually)">
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between">
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'primaryAddress' && j <= 3 && components.enabledProducts.includes(getProductType)">
                <component
                v-if="components.enableComponent && components.type !== 'VCheckbox' && (components && components.dependent ? addPrimaryAddressLine3 === true || addPrimaryAddressLine4 === true ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                :hint="components.hint"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? primaryStatesDropdown : undefined"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="formData[i][components.key]"
                :class="components.class"
                @click="components.key === 'stateOrprovince' ? statesloader(formData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary, 'addressDetails')">
                </component>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'primaryAddress' && j > 3 && components.enabledProducts.includes(getProductType)">
              <component
              v-if="components.enableComponent && components.type !== 'VCheckbox'"
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="components.key"
              :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? primaryStatesDropdown : undefined"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="formData[i][components.key]"
              :class="components.class"
              @click="components.key === 'stateOrprovince' ? statesloader(formData[i].country) : ''"
              @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
              </component>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div v-if="(contactDetails.correspondenceAddress && contactDetails.correspondenceAddress !== undefined && contactDetails.correspondenceAddress.postCode !== '')">
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between">
    <v-col cols="12">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'correspondenceAddress' && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'switch'">
                <v-switch
                :label="$t(`reviewInformation.${components.key}`)"
                :color="customCSS['primary']"
                :true-value="true"
                :false-value="false"
                v-model="manualInputCorresponding"
                @click="correspondenceAddress = '', corrAddressresponse = '', enableSaveButton('addressDetails')"
                >
                </v-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" v-if="!manualInputCorresponding">
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'correspondenceAddress' && j <= 4 && components.enabledProducts.includes(getProductType)">
              <component
              v-if="components.type !== 'switch'"
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="components.key"
              :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? corrStatesDropdown : undefined"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="formData[i][components.key]"
              :class="components.class"
              @click="components.key === 'stateOrprovince' ? corrStatesloader(formData[i].country) : ''"
              @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
              </component>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'correspondenceAddress' && j > 4 && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'switch'">
                <v-switch
                :label="$t(`reviewInformation.${components.key}`)"
                :color="customCSS['primary']"
                :true-value="true"
                :false-value="false"
                v-model="manualInputCorresponding"
                @click="correspondenceAddress = '', corrAddressresponse = '', enableSaveButton('addressDetails')"
                >
                </v-switch>
              </div>
              <div v-else-if="components.type !== 'switch' && components.type !== 'VCheckbox' && components.dependent && components.dependent.componentKey === 'manualInputCorresponding'">
                <component
                v-if="components.enableComponent && (components && components.dependent && (components.dependent.componentKey !== 'addcorrAddressLine3' && components.dependent.componentKey !== 'addcorrAddressLine4') ? components.dependent.componentKey === 'manualInputCorresponding' && manualInputCorresponding === false ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? corrStatesDropdown : undefined"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="formData[i][components.key]"
                :class="components.class"
                @click="components.key === 'stateOrprovince' ? corrStatesloader(formData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
                </component>
              </div>
              <div v-else-if="components.dependent && components.dependent.componentKey !== 'manualInputCorresponding' && manualInputCorresponding === false">
                <component
                v-if="components.enableComponent && components.type !== 'VCheckbox' && (components.dependent.componentKey === 'addcorrAddressLine3' && addcorrAddressLine3 === true ? true : components.dependent.componentKey === 'addcorrAddressLine4' && addcorrAddressLine4 === true && addcorrAddressLine3 === true ? true : false )"
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :class="components.class"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                v-model="formData[i][components.key]"
                @click="components.key === 'stateOrprovince' ? corrStatesloader(formData[i].country) : ''"
                @change="handleChange($event, components.key, components.primary,'addressDetails')">
                </component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between">
    <v-col sm="12" md="12" lg="12">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'useForCommunication' && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'v-html' && components.enableComponent">
                <div v-html="components.data" :class="components.class"></div>
                </div>
                <div v-else-if="components.type === 'VRadioGroup' && components.enableComponent">
                  <p class="field-labels">Use for Communication</p>
                  <div class="d-flex flex-wrap">
                    <v-radio-group v-model="isDefaultManual" :row="mobileView()">
                      <template v-slot:label>
                      </template>
                      <template v-for="(item, index) in components.values">
                        <v-radio
                        v-bind:key="index"
                        :label="$t(`reviewInformation.item.isDefaultManual.${item.label}`)"
                        :value="item.value">
                        </v-radio>
                      </template>
                    </v-radio-group>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    </div>
    <div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column justify-space-between">
      <p class="pl-3 field-labels mb-0"> Previous Residential Address</p>
      <v-col cols="12">
        <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
          <div v-for="(obj, i) in data" :key="i">
            <div v-for="(components, j) in obj" :key="j">
              <div v-if="i === 'previousResidentialAddress' && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'v-html' && components.enableComponent">
                <div v-html="components.data" :class="components.class"></div>
              </div>
              <div v-else-if="components.type === 'VRadioGroup' && components.enableComponent">
                <div class="d-flex flex-wrap pt-5">
                  <v-radio-group v-model="prevManualAddress" :row="mobileView()">
                    <template v-slot:label></template>
                      <template v-for="(item, index) in components.values">
                        <v-radio
                        v-bind:key="index"
                        :label="$t(`reviewInformation.item.previousResidential.${item.label}`)"
                        :value="item.value"
                        @change="clearAddressData('previousResidential')"
                        >
                        </v-radio>
                      </template>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" v-if="!prevManualAddress">
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'previousResidentialAddress' && j>1 && j <= 5 && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type !== 'VRadioGroup' && components.type !== 'VCheckbox'">
                <component
                v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'prevManualAddress' && prevManualAddress === false ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? prevStatesDropdown : undefined"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :class="components.class"
                v-model="formData[i][components.key]"
                @click="components.key === 'stateOrprovince' ? prevstatesloader(formData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
                </component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'previousResidentialAddress' && j > 5 && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'datePicker'">
                <div v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'prevManualAddress' && prevManualAddress === false ? true : false : true)">
                  <v-menu
                  v-if="components.key === 'fromDate'"
                  v-model="fromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="formatFromDate"
                    :label="$t(`reviewInformation.${components.key}`)"
                    :filled="components.filled"
                    :hide-details="components.hideDetails"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @keydown.tab="fromMenu = false"
                    :rules="components?.required ? [requiredRules] : []"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                  :max="today"
                  v-model="fromDate"
                  no-title
                  @input="fromMenu = false, toDate = null"
                  :color="customCSS['primary']"
                  :show-current="false"
                  >
                  </v-date-picker>
                  </v-menu>
                  <v-menu v-if="components.key === 'toDate'"
                  v-model="toMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formatToDate"
                      :label="$t(`reviewInformation.${components.key}`)"
                      :filled="components.filled"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="components?.required ? [requiredRules] : []"
                      @keydown.tab="toMenu = false">
                    </v-text-field>
                  </template>
                  <v-date-picker
                  v-model="toDate"
                  no-title
                  @input="toMenu = false"
                  :min="fromDate"
                  :max="today"
                  :color="customCSS['primary']"
                  :show-current="false"
                  >
                  </v-date-picker>
                  </v-menu>
                  </div>
                </div>
                <div v-else-if="components.type !== 'VRadioGroup' && components.type !== 'VCheckbox'">
                  <component
                  v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'prevManualAddress' && prevManualAddress === false ? true : false : true)"
                  validate-on-blur
                  :is="componentType[components.type].component"
                  :label="$t(`reviewInformation.${components.key}`)"
                  :hint="components.hint"
                  :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                  :persistent-hint="components.persistent"
                  :filled="components.filled"
                  :key="components.key"
                  :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? prevStatesDropdown : undefined"
                  :item-text="components.displayText ? components.displayText : codeDescription"
                  :item-value="components.displayValue ? components.displayValue : codeReference"
                  :[components.iconPlacement]="components.icon"
                  :class="components.class"
                  v-model="formData[i][components.key]"
                  @click="components.key === 'stateOrprovince' ? prevstatesloader(formData[i].country) : ''"
                  @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
                  </component>
                </div>
                <div v-else-if="components.dependent && components.dependent.componentKey !== 'prevManualAddress' && !prevManualAddress">
                  <component
                  v-if="components.enableComponent && components.type !== 'VCheckbox' && (components.dependent.componentKey === 'addprevAddressLine3' && addprevAddressLine3 === true ? true : components.dependent.componentKey === 'addprevAddressLine4' && addprevAddressLine4 === true && addprevAddressLine3 === true ? true : false )"
                  :is="componentType[components.type].component"
                  :label="$t(`reviewInformation.${components.key}`)"
                  :hint="components.hint"
                  :persistent-hint="components.persistent"
                  :filled="components.filled"
                  :key="components.key"
                  :class="components.class"
                  :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                  v-model="formData[i][components.key]"
                  @click="components.key === 'stateOrprovince' ? prevstatesloader(formData[i].country) : ''"
                  @change="handleChange($event, components.key, components.primary,'addressDetails')">
                  </component>
                </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    </div>
  </v-col>
  </v-col>
  <!-- Address Details with address lookup disabled end. -->
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Personal Details Section Start -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.personalReadOnlyDetails.enableComponent">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandPersonalDetailsSection = !expandPersonalDetailsSection"><div v-if="expandPersonalDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.personal') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandPersonalDetailsSection = true,showUnsavedSnackbar('readOnlyPersonalDetails', false)" v-if="readOnlyPersonalDetails && reviewInformation.personalEditDetails.enableComponent"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyPersonalDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="personalInformationData(0), showUnsavedSnackbar('readOnlyPersonalDetails', true)"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('personalInformation','readOnlyPersonalDetails') : editSaveChanges('personalInformation','readOnlyPersonalDetails')"
      :disabled="enableSaveButton('personalDetails')">{{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <v-col v-if="expandPersonalDetailsSection">
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.personalReadOnlyDetails.enableComponent && readOnlyPersonalDetails">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.titleDescription && personalReviewData.titleDescription !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.titleDescription') }}</p>
              <p class="text-styles">{{ personalReviewData.titleDescription }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.firstName && personalReviewData.firstName !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyFirstName') }}</p>
              <p class="text-styles">{{ personalReviewData.firstName }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.middleName && personalReviewData.middleName !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyMiddleName') }}</p>
              <p class="text-styles">{{ personalReviewData.middleName }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.lastName && personalReviewData.lastName !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyLastName') }}</p>
              <p class="text-styles">{{ personalReviewData.lastName }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.gender && personalReviewData.gender !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyGender') }}</p>
              <p class="text-styles">{{ reviewReadOnlyGender }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.primaryNationalityDescription && personalReviewData.primaryNationalityDescription !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyNationality') }}</p>
              <p class="text-styles">{{ personalReviewData.primaryNationalityDescription }}</p>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.dateOfBirth && personalReviewData.dateOfBirth !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyDateOfBirth') }}</p>
              <p class="text-styles">{{ dateOfBirth }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.birthCountryName && personalReviewData.birthCountryName !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyBirthCountry') }}</p>
              <p class="text-styles">{{ personalReviewData.birthCountryName }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.residentCountryCode && personalReviewData.residentCountryCode !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.readOnlyUKResident') }}</p>
              <p class="text-styles">{{ ukResident }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.nationalIdTypeCode && personalReviewData.nationalIdTypeCode !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.nationalIdType') }}</p>
              <p class="text-styles">{{ personalReviewData.nationalIdTypeCode }}</p>
            </div>
            <div class="header-spacing" v-if="personalReviewData && personalReviewData.nationalIdNumber && personalReviewData.nationalIdNumber !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewNationalIdNumber') }}</p>
              <p class="text-styles">{{ personalReviewData.nationalIdNumber }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols="11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.personalEditDetails.enableComponent && !readOnlyPersonalDetails">
      <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:15px;">
        <v-col sm="12" md="6" lg="6">
          <div v-for="(components, index) in reviewInformation.personalDetails" :key="index">
            <div v-if="index <=8">
              <div v-if="components.type === 'v-html'&& components.enableComponent && components.enabledProducts.includes(getProductType)">
                <div v-html="components.data" :class="components.class"></div>
              </div>
              <div v-else-if="components.type === 'VRadioGroup' && components.enableComponent && formData[components.key] !== '' && (components.key === 'gender' || components.enabledProducts.includes(getProductType))">
                <p
                class="kyc-description pt-3"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                  color: customCSS['onboarding-sectionContentColor'],
                }"
                v-if="components.key === 'gender'"
                >
                Gender
                </p>
                <div class="d-flex flex-wrap">
                  <v-radio-group v-model="formData[components.key]" :row="mobileView()" :disabled="components.disabled">
                    <template v-slot:label></template>
                    <template v-for="(item, index) in components.values">
                      <v-radio
                      v-bind:key="index"
                      :label="$t(`reviewInformation.item.${components.key}.${item.label}`)"
                      :value="item.value"
                      >
                      </v-radio>
                    </template>
                  </v-radio-group>
                </div>
              </div>
              <div v-else-if="components.type === 'VCheckbox' && components.enableComponent === true && components.enabledProducts.includes(getProductType)">
                <v-checkbox v-if="components.key === 'reviewMiddleNameCheckbox' && components.enabledProducts.includes(getProductType)"
                :label="$t(`reviewInformation.${components.key}`)"
                :true-value="true"
                :false-value="false"
                :key="components.key"
                v-model="reviewMiddleNameCheckbox"
                @click="!reviewMiddleNameCheckbox ? formData.middleName = '' : formData.middleName"
                >
                </v-checkbox>
                <v-checkbox v-else-if="components.key === 'reviewAnotherNationality'"
                :label="$t(`reviewInformation.${components.key}`)"
                :true-value="true"
                :false-value="false"
                :key="components.key"
                v-model="reviewAnotherNationality"
                >
                </v-checkbox>
              </div>
              <div v-else-if="components.type !=='VCheckbox'" class="pb-2">
                <component
                v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && (components && components.dependent ? components.dependent.componentKey === 'reviewMiddleNameCheckbox' && reviewMiddleNameCheckbox ? true : components.dependent.componentKey === 'reviewAnotherNationality' && reviewAnotherNationality ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.required ? componentType[components.type].component !== 'v-select' ? [requiredRules, personalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : requiredRules : formData[components.key] !== '' ? [personalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : []"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'titleCode' ? items : components.key === 'primaryNationality' || components.key === 'secondaryNationality' ? reviewNationality : components.key === 'birthCountryCode' ? reviewCountry : null"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="formData[components.key]"
                v-bind:value="formData[components.key]"
                :class="components.class"
                :hide-details="components.hideDetails? components.hideDetails : false"
                :defalut="components.default"
                @change="handleChange($event, components.key,'personalDetails')">
                </component>
              </div>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6" class="d-flex flex-column flex-gap-3">
          <p
          class="kyc-description mb-1"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            color: customCSS['onboarding-sectionContentColor']
          }"
          >
          Date Of Birth
          </p>
          <div class="d-flex d-md-flex flex-row flex-md-row flex-wrap">
            <v-col cols="12" md="12" lg="12" class="pl-0 pr-0">
              <div style="display: flex;">
                <div v-for="(components, index) in reviewInformation.personalDetails" :key="index">
                  <div v-if="index > 8 && index <=11">
                  <div :class="index === 11 ? '' : mobileViewScreen() ? language!== '' ? 'pl-5' : 'pr-5' : 'pr-1'">
                    <component v-if="components.enableComponent"
                    validate-on-blur
                    :is="componentType[components.type].component"
                    :label="$t(`reviewInformation.${components.key}`)"
                    :hint="components.hint"
                    :rules="components?.required ? componentType[components.type].component !== 'v-select' ? [requiredRules, personalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : requiredRules : formData[components.key] !== '' ? [personalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : []"
                    :persistent-hint="components.persistent"
                    :filled="components.filled"
                    :key="components.key"
                    :items="components.key === 'year' ? yearsDropdown : components.key === 'month' ? monthsDropdown : components.key === 'date' ? daysDropdown : null"
                    :item-text="components.displayText ? components.displayText : 'codeDescription'"
                    :item-value="components.displayValue ? components.displayValue : 'codeReference'"
                    :[components.iconPlacement]="components.icon"
                    :true-value="components.trueValue"
                    :false-value="components.falseValue"
                    v-model="formData[components.key]"
                    v-bind:value="formData[components.key]"
                    :class="components.class"
                    :hide-details="components.hideDetails? components.hideDetails : false"
                    :defalut="components.default"
                    @change="handleChange($event, components.key,'personalDetails')">
                    </component>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </div>
      <v-row class="d-flex d-md-flex flex-column flex-md-column flex-wrap mobile-columnAlignment ma-0">
        <v-col cols="12" md="12" lg="12" class="pl-0 pr-0">
        <div v-for="(components, index) in reviewInformation.personalDetails" :key="index">
          <div v-if="index >11">
            <div v-if="components.type === 'v-html'&& components.enableComponent && components.enabledProducts.includes(getProductType)">
              <div v-html="components.data" :class="components.class"></div>
            </div>
            <div v-else-if="components.type === 'VCheckbox' && components.enableComponent === true">
              <v-checkbox v-if="components.key === 'reviewAnotherNationality'"
              label="$t(`reviewInformation.${components.key}`)"
              :true-value="true"
              :false-value="false"
              :key="components.key"
              v-model="reviewAnotherNationality"
              >
              </v-checkbox>
            </div>
            <div v-else-if="components.type !=='VCheckbox'">
              <component
              v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && (components && components.dependent ? components.dependent.componentKey === 'reviewMiddleNameCheckbox' && reviewMiddleNameCheckbox ? true : components.dependent.componentKey === 'reviewAnotherNationality' && reviewAnotherNationality ? true : false : true)"
              validate-on-blur
              lazy-rules
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? componentType[components.type].component !== 'v-select' ? [requiredRules, personalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : requiredRules : formData[components.key] !== '' ? [personalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="components.key"
              :items="components.key === 'titleCode' ? items : components.key === 'primaryNationality' || components.key === 'secondaryNationality' ? reviewNationality : components.key === 'birthCountryCode' ? reviewCountry : components.key === 'nationalIdTypeId' ? nationalIdentities : null"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="formData[components.key]"
              v-bind:value="formData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              @change="handleChange($event, components.key,'personalDetails')">
              </component>
            </div>
          </div>
        </div>
        </v-col>
      </v-row>
        </v-col>
      </div>
    </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
      <v-divider></v-divider>
    </v-col>
</v-row>
<!-- Personal Details Section End -->
<!-- Tax Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.taxInformation.enableComponent">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandTaxDetailsSection = !expandTaxDetailsSection"><div v-if="expandTaxDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.taxInformation') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandTaxDetailsSection = true,showUnsavedSnackbar('readOnlyTaxDetails', false)" v-if="readOnlyTaxDetails && reviewInformation.taxEditDetails.enableComponent"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyTaxDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="taxInformationData(0), showUnsavedSnackbar('readOnlyTaxDetails', true)"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('taxInformation','readOnlyTaxDetails') : editSaveChanges('taxInformation','readOnlyTaxDetails')"
      :disabled="enableSaveButton('taxDetails')">{{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <v-col v-if="expandTaxDetailsSection">
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="readOnlyTaxDetails">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="(taxReviewData && (taxReviewData.taxPayerFlag === 'true' || taxReviewData.taxPayerFlag === true))">
        <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="taxReviewData.countryOfTaxResidentName && taxReviewData.countryOfTaxResidentName !== ''">
              <p class="overline-styles mb-0">{{ $t('reviewInformation.taxCountry') }}</p>
              <p class="text-styles mb-0">{{ taxReviewData.countryOfTaxResidentName }}</p>
            </div>
            <div class="header-spacing" v-if="taxReviewData.taxIdentificationNumber && taxReviewData.taxIdentificationNumber !== ''">
              <p class="overline-styles mb-0">{{ $t('reviewInformation.taxNumber') }}</p>
              <p class="text-styles mb-0">{{ taxReviewData.taxIdentificationNumber }}</p>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="taxReviewData.taxResidentInOtherCountry && taxReviewData.foreignCountryOfTaxResidenceName && taxReviewData.foreignCountryOfTaxResidenceName !== ''">
              <p class="overline-styles mb-0">{{ $t('reviewInformation.reviewForeignCountryOfTaxResidence') }}</p>
              <p class="text-styles mb-0">{{ taxReviewData.foreignCountryOfTaxResidenceName }}</p>
            </div>
            <div class="header-spacing" v-if="taxReviewData.taxResidentInOtherCountry === 'false' || taxReviewData.taxResidentInOtherCountry === false">
              <p class="overline-styles mb-0">{{ $t('reviewInformation.reviewForeignCountryOfTaxResidence') }}</p>
              <p class="text-styles mb-0">Not Applicable</p>
            </div>
            <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
              <v-col sm="12" md="6" lg="6">
                <div class="d-flex header-spacing" v-if="(taxReviewData.taxResidentInOtherCountry === true || taxReviewData.taxResidentInOtherCountry === 'true')  && usResident !== ''">
                  <p class="overline-styles mb-0">{{ $t('reviewInformation.usResident') }}</p>
                  <p class="text-styles mb-0">{{ usResident }}</p>
                </div>
              </v-col>
              <v-col sm="12" md="3" lg="3">
                <div class="d-flex header-spacing" v-if="taxReviewData.taxResidentInOtherCountry && taxReviewData.tinNumberInOtherCountry && taxReviewData.tinNumberInOtherCountry !== ''">
                  <p class="overline-styles mb-0">{{ $t('reviewInformation.tinNumber') }}</p>
                  <p class="text-styles mb-0">{{ taxReviewData.tinNumberInOtherCountry }}</p>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-else-if="((taxReviewData && (!taxReviewData.taxPayerFlag || taxReviewData.taxPayerFlag === 'false'))) && taxReviewData.taxExemptionReasonName !== ''">
        <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="taxReviewData.taxExemptionReasonName !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.taxExemptionReasonReadOnly') }}</p>
              <p class="text-styles taxDetails-display">{{ taxReviewData.taxExemptionReasonName }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-else-if="taxReviewData && (!taxReviewData.taxPayerFlag || taxReviewData.taxPayerFlag === 'false') && taxReviewData.taxExemptionReasonName === ''">
        <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing">
              <p class="text-styles taxDetails-display">{{ $t('reviewInformation.notATaxPayer') }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols= "11" class="d-flex flex-column justify-space-between" v-if="!readOnlyTaxDetails">
      <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column justify-space-between" style="column-gap:21px;">
        <v-row>
          <v-col cols="12" v-if="getProductType !== 'lifetimeISA'">
            <div v-for="(components, index) in reviewInformation.taxDetails" :key="index">
              <div v-if="components.type === 'VButtonToggle' && components.enableComponent === true && reviewInformation && reviewInformation.taxInformation && reviewInformation.taxInformation.isToggleSwitchEnabled">
                <div v-on="on" :style="reviewInformation && reviewInformation.taxInformation && reviewInformation.taxInformation.isToggleSwitchEnabled ? 'position: relative; bottom:30px;' : ''" v-if="productType !== 'lifetimeISA'">
                  <v-btn-toggle
                  tile
                  color="deep-purple accent-3"
                  :class="isLisa ? 'toggle-switch-group toggle-switch-disable' : 'toggle-switch-group'"
                  group
                  mandatory
                  v-model="taxValue"
                  @change="handleChange(taxValue,'taxDetails')"
                  >
                  <v-btn class="mr-0 text-none" :value="true" active-class="toggle-switch-button">{{ $t(`reviewInformation.taxValue.${components.firstItemlabel}`)}}</v-btn>
                  <v-btn class="ml-0 text-none" :value="false" active-class="toggle-switch-button"
                  >{{ $t(`reviewInformation.taxValue.${components.secondItemlabel}`)}}
                  </v-btn>
                  </v-btn-toggle>
                </div>
                <p v-if="taxValue === false && !components.enabledProducts.includes(getProductType)"><BaseIcon name="check" iconClass="vertical-alignment" :color="customCSS['primary']"/>{{$t(`reviewInformation.secondItemDescription`)}}</p>
              </div>
            </div>
          </v-col>
        </v-row>
        <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column pt-4" style="column-gap: 21px;">
          <v-col sm="12" md="6" lg="6">
            <div v-for="(components, index) in reviewInformation.taxDetails" :key="index">
              <div v-if="index >=1" :style="taxValue ? taxResidentInOtherCountry ? 'display: flex; flex-direction: column; gap: 16px; padding-left: 0px !important' : 'display: flex; flex-direction: column; gap: 12px; padding-left: 0px !important;padding-top: 0px !important;' : 'display: flex; flex-direction: column; padding-left: 0px !important; padding-top: 0px !important;'">
                <div v-if="components.type === 'v-html' && components.enabledProducts.includes(getProductType) && ((components.enableComponent && taxValue && components.key === 'taxPayerContent') || (components.enableComponent && taxValue && taxResidentInOtherCountry && components.key === 'usResidentContent'))">
                  <div v-html="components.data" :class="components.class"></div>
                  </div>
                  <div v-else-if="components.type === 'VRadioGroup'&& components.enableComponent && components.enabledProducts.includes(getProductType)">
                    <div class="d-flex flex-wrap" v-if="components.key === 'taxResidentInOtherCountry' && taxValue">
                      <v-radio-group v-model="taxResidentInOtherCountry" :row="mobileView()" :disabled="components.disabled">
                        <template v-slot:label></template>
                        <template v-for="(item, index) in components.values">
                          <v-radio
                          v-bind:key="index"
                          :label="$t(`reviewInformation.item.${components.key}.${item.label}`)"
                          :value="item.value"
                          >
                          </v-radio>
                        </template>
                      </v-radio-group>
                    </div>
                    <div class="d-flex flex-wrap pt-4" v-else-if="components.key === 'areYouUSResident' && taxValue && taxResidentInOtherCountry && components.enabledProducts.includes(getProductType)">
                      <v-radio-group v-model="areYouUSResident" :row="mobileView()" :disabled="components.disabled">
                        <template v-slot:label></template>
                        <template v-for="(item, index) in components.values">
                          <v-radio
                          v-bind:key="index"
                          :label="$t(`reviewInformation.item.${components.key}.${item.label}`)"
                          :value="item.value"
                          >
                          </v-radio>
                        </template>
                      </v-radio-group>
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="((!components.enabledProducts.includes(getProductType)) && components.key !== 'taxExemptionReason') || (productType === 'lifetimeISA' && components.key !== 'taxExemptionReason') || (components.enabledProducts.includes(getProductType)) || productsAllowedWithAccountDetails">
                      <component
                      v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'taxValue' ? taxValue === components.dependent.value : components.dependent.componentKey === 'taxResidentInOtherCountry' ? taxResidentInOtherCountry === components.dependent.value && taxValue : formData[components.dependent.componentKey] === components.dependent.value : components.key === 'taxIdentificationNumber')"
                      validate-on-blur
                      :is="componentType[components.type].component"
                      :label="$t(`reviewInformation.${components.key}`)"
                      :hint="components.hint"
                      :rules="components?.required ? components.key === 'taxIdentificationNumber' ? [requiredRules, taxRules].flat() : requiredRules : []"
                      :persistent-hint="components.persistent"
                      :filled="components.filled"
                      :key="components.key"
                      :items="components.key === 'taxExemptionReason' ? taxExemptionDropDown : reviewCountry"
                      :item-text="components.displayText ? components.displayText : 'codeDescription'"
                      :item-value="components.displayValue ? components.displayValue : 'codeReference'"
                      :[components.iconPlacement]="components.icon"
                      :true-value="components.trueValue"
                      :false-value="components.falseValue"
                      v-model="formData[components.key]"
                      v-bind:value="formData[components.key]"
                      :class="components.class"
                      :hide-details="components.hideDetails? components.hideDetails : false"
                      :defalut="components.default"
                      :disabled="components.disabled"
                      @change="handleChange($event, components.key,'taxDetails')">
                      </component>
                    </div>
                  </div>
                </div>
              </div>
            </v-col>
          </div>
        </div>
    </v-col>
  </v-col>
  <!-- Tax Details Section End. -->
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Identity Document Section Start. -->
<v-row class="pb-0 pt-0 ml-0" v-if="image !== '' && image !== undefined">
  <v-col  cols= "11" class="pl-0 pb-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="readOnlyIdentityDetails = !readOnlyIdentityDetails"><div v-if="readOnlyIdentityDetails"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.identityDocuments') }}
    </h6>
    <p class="disabled-button">{{ $t('reviewInformation.readOnly') }}</p>
  </v-col>
  <v-col cols= "11" class="pl-6 d-flex flex-column justify-space-between" v-if="readOnlyIdentityDetails">
    <p class="account-ownership"> <BaseIcon name="info_filled" size="xs" iconClass="vertical-alignment" :color="customCSS['primary']"/> Manual upload </p>
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column pt-1">
      <v-col sm="6" md="6" lg="6" class="d-flex flex-column">
        <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ image.documentName }} <br>
          <span
          class="d-flex identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }"
          >{{image.size}}<v-icon>mdi-circle-small</v-icon>
          <span style="color: rgba(0, 135, 68, 1);">
            <BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/>
            {{ $t('reviewInformation.attachedDocument') }}
          </span>
          </span>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" iconClass="vertical-alignment" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ pictures[0].documentName }} <br><span class="d-flex identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }">{{pictures[0].size}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
        </p>
      </v-col>
    </v-row>
      </v-col>
      <v-col sm="6" md="6" lg="6" class="d-flex flex-column">
        <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" iconClass="vertical-alignment" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ pictures[1].documentName }} <br><span class="identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }">{{pictures[1].size}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ pictures[2].documentName }} <br><span class="identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }">{{pictures[2].size}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
        </p>
      </v-col>
    </v-row>
      </v-col>
    </v-row>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Identity Document Section End. -->
<!-- Employment Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyEmploymentDetails.enableComponent">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandEmploymentDetailsSection = !expandEmploymentDetailsSection"><div v-if="expandEmploymentDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.currentEmploymentDetails') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandEmploymentDetailsSection = true,showUnsavedSnackbar('readOnlyEmploymentDetails', false)" v-if="readOnlyEmploymentDetails && reviewInformation.employmentEditDetails.enableComponent"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyEmploymentDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="showUnsavedSnackbar('readOnlyEmploymentDetails', true), employmentInformationData(0)"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('employmentInformation','readOnlyEmploymentDetails') : editSaveChanges('employmentInformation','readOnlyEmploymentDetails')"
      :disabled="enableSaveButton('employmentDetails')">{{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <v-col v-if="expandEmploymentDetailsSection">
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyEmploymentDetails.enableComponent && readOnlyEmploymentDetails">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="otherInformation.employmentDetails.employmentStatus !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewEmploymentStatus') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.employmentStatusDescription }}</p>
            </div>
            <div class="header-spacing" v-if="otherInformation.employmentDetails.nameOfTheEmployer != ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewNameOfTheEmployer') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.nameOfTheEmployer }}</p>
            </div>
            <div class="header-spacing" v-if="otherInformation.employmentDetails.employmentType !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewEmploymentType') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.employmentTypeDescription }}</p>
            </div>
            <div class="header-spacing" v-if="otherInformation.employmentDetails.businessType !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewBusinessType') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.businessTypeDescription }}</p>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="otherInformation.employmentDetails.jobTitle !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewJobTitle') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.jobTitleDescription }}</p>
            </div>
            <div class="header-spacing" v-if="otherInformation.employmentDetails.paymentMethod !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewPaymentMethod') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.paymentMethodDescription }}</p>
            </div>
            <div class="header-spacing" v-if="otherInformation.employmentDetails.paymentFrequency !== ''">
              <p class="overline-styles">{{ $t('reviewInformation.reviewPaymentFrequency') }}</p>
              <p class="text-styles">{{ otherInformation.employmentDetails.paymentFrequencyDescription }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.employmentEditDetails.enableComponent && !readOnlyEmploymentDetails">
      <v-col class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:21px;">
        <v-col sm="12" md="6" lg="6" class="flex-alignment">
          <div v-for="(components, index) in reviewInformation.employmentDetails" :key="index">
            <div v-if="index <=3">
              <div v-if="components.enableComponent && components.key === 'employmentStatus' && components.enabledProducts.includes(getProductType)">
                <component
                v-if="components.enableComponent && components.key === 'employmentStatus'"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.required ? requiredRules : []"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'employmentStatus' ? employmentDetails.employmentStatusList : ''"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                :class="components.class"
                :hide-details="components.hideDetails? components.hideDetails : false"
                :defalut="components.default"
                :disabled="components.disabled"
                v-model="formData[components.key]"
                @change="handleChange($event, components.key, 'employmentDetails')">
                </component>
              </div>
              <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && $appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(updatedEmploymentStatus) && components.key !== 'employmentStatus'">
                <component
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.required ? components.key === 'nameOfTheEmployer' ? [requiredRules, employerNameRule].flat() : requiredRules : []"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'employmentType' ? employmentDetails.employmentTypeList : components.key === 'businessType' ? employmentDetails.businessTypeList : components.key === 'jobTitle' ? employmentDetails.jobTitleList : components.key === 'paymentMethod' ? employmentDetails.paymentMethodList : components.key === 'paymentFrequency' ? employmentDetails.paymentFrequencyList : ''"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                :class="components.class"
                :hide-details="components.hideDetails? components.hideDetails : false"
                :defalut="components.default"
                :disabled="components.disabled"
                :style="!$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(updatedEmploymentStatus) ? 'display: none;' : ''"
                v-model="formData[components.key]"
                v-bind:value="formData[components.key]"
                @change="handleChange($event, components.key, 'employmentDetails')">
                </component>
              </div>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6">
          <div v-for="(components, index) in reviewInformation.employmentDetails" :key="index">
            <div v-if="index >3">
              <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && $appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(updatedEmploymentStatus) && components.key !== 'employmentStatus'">
                <component
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.required ? components.key === 'nameOfTheEmployer' ? [requiredRules, employerNameRule].flat() : requiredRules : []"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="components.key"
                :items="components.key === 'employmentType' ? employmentDetails.employmentTypeList : components.key === 'businessType' ? employmentDetails.businessTypeList : components.key === 'jobTitle' ? employmentDetails.jobTitleList : components.key === 'paymentMethod' ? employmentDetails.paymentMethodList : components.key === 'paymentFrequency' ? employmentDetails.paymentFrequencyList : ''"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="formData[components.key]"
                v-bind:value="formData[components.key]"
                :class="components.class"
                :hide-details="components.hideDetails? components.hideDetails : false"
                :defalut="components.default"
                :disabled="components.disabled"
                :style="!$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(updatedEmploymentStatus) ? 'display: none;' : ''"
                @change="handleChange($event, components.key, 'employmentDetails')">
                </component>
              </div>
            </div>
          </div>
        </v-col>
      </v-col>
    </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Employment Details Section End. -->
<!-- Account Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyAccountDetails.enableComponent">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandAccountDetailsSection = !expandAccountDetailsSection"><div v-if="expandAccountDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.nominatedAccount') }}
    </h6>
    <p class="disabled-button" v-if="(productType === 'currentAccount' || productType === 'savings') && !reviewInformation.accountDetails.enableForCurrentSavings">{{ $t('reviewInformation.readOnly') }}</p>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandAccountDetailsSection = true,showUnsavedSnackbar('readOnlyAccountDetails', false)" v-if="readOnlyAccountDetails && ((productType !== 'currentAccount' || productType !== 'savings') || ((productType === 'currentAccount' || productType === 'savings') && reviewInformation.accountDetails.enableForCurrentSavings))"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyAccountDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="showUnsavedSnackbar('readOnlyAccountDetails', true), resetNominatedAccountData()"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('accountInformation','readOnlyAccountDetails') : editSaveChanges('accountInformation','readOnlyAccountDetails')"
      :disabled="enableSaveButton('accountDetails')">{{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <v-col v-if="expandAccountDetailsSection">
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyAccountDetails.enableComponent && readOnlyAccountDetails && accountInfoData !== null">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="d-flex flex-column" style="gap: 24px !important">
            <div v-if="(accountInfoData.isIBANAvailable === true || accountInfoData.isIBANAvailable === 'true') && accountInfoData.iban !== '' && accountInfoData.iban !== undefined">
              <div class="container-spacing">
                <div class="text-spacing">
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.iban') }}</p>
                    <p class="text-styles">{{ accountInfoData.iban }}</p>
                  </div>
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.bicCode') }}</p>
                    <p class="text-styles">{{ accountInfoData.bicCode }}</p>
                  </div>
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.capsCurrency') }}</p>
                    <p class="text-styles">{{ accountInfoData.bankName }}</p>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="(accountInfoData.isIBANAvailable === false || accountInfoData.isIBANAvailable === 'false') && accountInfoData.accountNumber !== '' && accountInfoData.accountNumber !== undefined">
              <div v-if="accountInfoData.accountNumber !== ''" class="container-spacing">
                <div class="text-spacing">
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.accountNumber') }}</p>
                    <p class="text-styles">{{ accountInfoData.accountNumber }}</p>
                  </div>
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.sortCode') }}</p>
                    <p class="text-styles">{{ accountInfoData.sortCode }}</p>
                  </div>
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.bankName') }}</p>
                    <p class="text-styles">{{ accountInfoData.bankName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'" v-if="accountInfoData !== null">
          <div class="text-spacing" v-if="accountInfoData !== null">
            <div class="header-spacing">
              <p class="overline-styles">{{ $t('reviewInformation.capsCurrency') }}</p>
              <p class="text-styles">{{ accountInfoData.currency }}</p>
            </div>
          </div>
          <v-row class="align-center" v-if="filename !== 'Upload Statement Proof'">
            <v-col cols="1">
              <BaseIcon name="attach_file" size="xs" color="#000000;"/>
            </v-col>
          <v-col>
            <div v-if="filename !== 'Upload Statement Proof'" class="pt-8">
              <p class="file-name">
                {{ filename }} <br><span class="d-flex identityDocuments-content"
                :style="{
                  'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                }">{{fileSize}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass=" vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
              </p>
            </div>
          </v-col>
        </v-row>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.accountDetails.enableComponent && !readOnlyAccountDetails">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div v-if="reviewInformation.accountDetails.enableComponent === true && (((productType === 'currentAccount' || productType === 'savings') && additionalNominatedData === true && reviewInformation.accountDetails.enableForCurrentSavings === true) || (productType === 'termDeposit' && reviewInformation.accountDetails.enableForTermDeposit === true) || productsAllowedWithAccountDetails)">
            <div v-on="on" v-if="reviewInformation && reviewInformation.readOnlyAccountDetails && reviewInformation.readOnlyAccountDetails.isToggleSwitchEnabled">
              <v-btn-toggle
              tile
              group
              mandatory
              color="deep-purple accent-3"
              class="toggle-switch-group"
              v-model="ibanValue"
              @change="clearValues(ibanValue)"
              >
              <v-btn class="mr-0 text-none" :value="true" active-class="toggle-switch-button">
                {{$t(`reviewInformation.ibanValue.iban`)}}
              </v-btn>
              <v-btn class="ml-0 text-none" :value="false" active-class="toggle-switch-button">
                {{$t(`reviewInformation.ibanValue.accountNumber`)}}
              </v-btn>
              </v-btn-toggle>
            </div>
            <div v-if="ibanValue">
              <v-text-field :label="$t(`reviewInformation.iban`)" class="pt-8" filled :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []" :color="customCSS['primary']" @change="ibanValidation" v-model="ibanNumber">
              </v-text-field>
              <v-text-field :label="$t(`reviewInformation.bicCode`)" class="pt-4" filled :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []" v-model="bicCode"></v-text-field>
            </div>
            <div v-if="!ibanValue">
              <v-text-field validate-on-blur :label="$t(`reviewInformation.accountNumberText`)" class="pt-8" filled :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? [requiredRules,rules].flat() : rules" :minlength="minValue" :maxlength="maxValue" v-model="accountNumber">
              </v-text-field>
              <v-row class="pt-4">
                <v-col cols="6">
                  <v-text-field :label="$t(`reviewInformation.sortCodeEdit`)" filled disabled v-model="sortCodeFinal" :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []"></v-text-field>
                </v-col>
                <v-col cols="2">
                  <v-btn rounded small :color="customCSS['secondary']" class="text-none white--text" :disabled="sortCode === true ? true : false" @click="findSortCode()">
                    <div v-if="sortCodeFinal !== ''">{{$t(`reviewInformation.changeSortCodeEdit`)}}</div>
                    <div v-else>{{$t(`reviewInformation.findSortCodeEdit`)}}</div>
                  </v-btn>
                </v-col>
              </v-row>
              <div v-if="sortCode === true" class="grid-address">
                <p class="secondary--text">Search code validation search By</p>
                <div class="ma-2">
                  <v-text-field :label="$t(`reviewInformation.sortCodeEdit`)" class="pt-4" filled :disabled=" reviewBankName !== '' && reviewBranchName !== ''? sortResults.data?.status === 400 || sortCodeSearch !== '' ? false : true : false" :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []"
                  v-model="sortCodeSearch">
                  </v-text-field>
                  <h4 class="secondary--text" style="width: 100%;text-align: center;border-bottom: 1px solid rgba(193, 55, 162, 1);line-height: 0.1em;margin: 10px 0 20px;background: #fff;padding: 0 10px;color: secondary;">
                    <span style="background: #fff; padding: 0 10px; color: secondary">OR</span>
                  </h4>
                  <v-text-field :label="$t(`reviewInformation.bankNameEdit`)" class="pt-4" filled :disabled=" sortCodeSearch !== '' ? reviewBankName !== '' ? false : true : false" :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []"
                  v-model="reviewBankName">
                  </v-text-field>
                  <v-text-field
                  :label="$t(`reviewInformation.branchNameEdit`)"
                  filled
                  :disabled="sortCodeSearch !== '' ? reviewBranchName !== '' ? false : true : false"
                  v-model="reviewBranchName"
                  class="pt-4"
                  :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []"
                  >
                  </v-text-field>
                  <div v-if="sortResults.data?.status === 400">
                    <v-alert class="rounded-xl myClass" height="100px" prominent dismissible outlined text color="orange" icon="mdi-alert">
                      <h4 class="black--text">No Sort Code Available</h4>
                      <h5 class="message-content mt-1">
                        There is no search results matching with provided data.<br /> Please try again!.
                      </h5>
                    </v-alert>
                  </div>
                  <v-flex style="justify-content: flex-end !important; display: flex !important">
                    <v-btn small rounded outlined :color="customCSS['secondary']" class="save" @click="sortCode = false" style="language !== '' ? position: relative; right: -11px : position: relative; right: 15px">
                      {{ $t('reviewInformation.cancel') }}
                    </v-btn>
                    <div v-if="sortCodeSearch === '' || (reviewBankName === '' && reviewBranchName === '')">
                      <v-btn small rounded :color="customCSS['secondary']" class="save text-none" :disabled="sortCodeSearch !== '' || (reviewBankName !== '' && reviewBranchName !== '') ? false : true" @click="searchBicCode()">
                        {{$t(`reviewInformation.search`)}}
                      </v-btn>
                    </div>
                    <div v-else-if="sortResults !== '' && sortResults.data?.status !== 400">
                      <v-btn small rounded :color="customCSS['secondary']" class="save text-none" @click="closeBicCode()">
                        {{$t(`reviewInformation.confirm`)}}
                      </v-btn>
                    </div>
                  </v-flex>
                </div>
              </div>
            </div>
            <v-text-field :label="$t(`reviewInformation.bankNameEdit`)" class="pt-4" filled v-model="finalBankName" :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? requiredRules : []"></v-text-field>
            <v-select
            v-if="reviewInformation && reviewInformation.nominatedCurrenyField && reviewInformation.nominatedCurrenyField.enableComponent === true"
            validate-on-blur
            :label="$t(`reviewInformation.currency`)"
            class="pt-4"
            :items="reviewCurrency"
            item-text="codeReference"
            item-value="codeReference"
            filled
            v-model="finalCurrency"
            :rules="reviewInformation && reviewInformation.accountDetails && reviewInformation.accountDetails.required.includes(this.getProductType) ? [validation,requiredRules].flat() : validation"
            :disabled="!ibanValue ? true : false"
            @change="accountValidationRules()">
            </v-select>
            <div v-if="reviewInformation.fileUpload.enableComponent && ((productType !== 'currentAccount' && productType !== 'savings' && additionalNominatedData === true && reviewInformation.accountDetails.enableForCurrentSavings === true) || (productType === 'termDeposit' && reviewInformation.accountDetails.enableForTermDeposit === true) || productsAllowedWithAccountDetails)">
              <v-file-input v-if="fileComponent === true"
              show-size
              clearable
              :label="$t(`reviewInformation.fileName`)"
              prepend-icon="mdi-plus"
              solo
              flat
              class="file-mobileView"
              @change="onFileChanged"
              >
              </v-file-input>
              <p v-if="fileComponent === false" class="pr-3 file-name">{{filename}} <v-btn text @click="deleteUploadedFile"><BaseIcon name="delete" size="xs"/></v-btn></p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyAccountDetails.enableComponent && readOnlyAccountDetails && (accountInfoData === null || accountInfoData === '' || accountInfoData === undefined)">
    <div class="container-spacing">
      <div class="text-spacing">
        <div class="header-spacing">
          <p class="overline-styles">{{ $t('reviewInformation.noAccountDetails') }}</p>
        </div>
      </div>
    </div>
  </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Account Details Section End. -->
<!-- Compliance Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
:class="language ? '' : ''" :style="(expectedTurnover === '' || expectedTurnover === null || expectedTurnOver === undefined) &&
(sourceOfFunds === '' || sourceOfFunds === null || sourceOfFunds === undefined) && (jobReadOnly === '' || jobReadOnly === null || jobReadOnly === undefined) &&
(udfBusinessTypeReadOnly === '' || udfBusinessTypeReadOnly === null || udfBusinessTypeReadOnly === undefined) ? ' display: none !important;' : ''"
 v-if="reviewInformation.reviewComplianceDetails.enableComponent === true">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandComplianceDetailsSection = !expandComplianceDetailsSection">
        <div v-if="expandComplianceDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/>
        </div>
        <div v-else>
          <BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/>
        </div>
      </v-btn>
      {{ $t('reviewInformation.complianceDetails') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandComplianceDetailsSection = true,showUnsavedSnackbar('readOnlyComplianceDetails', false)" v-if="readOnlyComplianceDetails && reviewInformation.complianceEditDetails.enableComponent"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyComplianceDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="showUnsavedSnackbar('readOnlyComplianceDetails', true), udfInformationData(0, 'complianceDetails', false)"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('complianceInformation','readOnlyComplianceDetails') : editSaveChanges('complianceInformation','readOnlyComplianceDetails')"
      :disabled="enableSaveButton('complianceDetails')">{{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <v-col v-if="expandComplianceDetailsSection">
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.reviewComplianceDetails.enableComponent && readOnlyComplianceDetails">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="expectedTurnover !== '' && expectedTurnover !== null && expectedTurnover !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewExpectedTurnOver') }}</p>
              <p class="text-styles">{{ expectedTurnover }}</p>
            </div>
            <div class="header-spacing" v-if="sourceOfFunds != '' && sourceOfFunds !== null && sourceOfFunds !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewSourceOfFunds') }}</p>
              <p class="text-styles">{{ sourceOfFunds }}</p>
            </div>
            <div class="header-spacing" v-if="jobReadOnly != '' && jobReadOnly !== null && jobReadOnly !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewJobDescription') }}</p>
              <p class="text-styles">{{ jobReadOnly }}</p>
            </div>
            <div class="header-spacing" v-if="udfBusinessTypeReadOnly != '' && udfBusinessTypeReadOnly !== null && udfBusinessTypeReadOnly !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewUdfBusinessTypeDescription') }}</p>
              <p class="text-styles">{{ udfBusinessTypeReadOnly }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.complianceEditDetails.enableComponent && !readOnlyComplianceDetails">
      <v-col class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:21px;">
        <v-col sm="12" md="6" lg="6" class="flex-alignment">
          <div v-for="(components, index) in reviewInformation.complianceDetails" :key="index">
            <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType)">
              <component
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required === true ? components.key === 'expectedTurnover' ? [requiredRules, complianceRules].flat() : requiredRules : components.key === 'expectedTurnover' ? formData[components.key] !== '' && formData[components.key] !== null ? [complianceRules].flat() : [] : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="components.key"
              :items="components.key === 'sourceCountryOfFunds' ? sourceCountryOfFunds : components.key === 'job' ? jobDropDown : components.key === 'udfBusinessType' ? udfBusinessTypeDropdown : ''"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="formData[components.key]"
              v-bind:value="formData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              @change="handleChange($event, components.key, 'complianceDetails')">
              </component>
            </div>
          </div>
        </v-col>
      </v-col>
    </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Compliance Details Section End. -->
<!-- Product Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
:style="(purposeOfAccount === '' || purposeOfAccount === null || purposeOfAccount === undefined) && (expectedUsage === '' || expectedUsage === null || expectedUsage === undefined) ? 'display: none;' : ''"
 v-if="reviewInformation.productOtherDetails.enableComponent === true">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between" v-if="!['', null, undefined].includes(purposeOfAccount) || !['', null, undefined].includes(purposeOfAccountOthers) || !['', null, undefined].includes(expectedUsage)">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="expandUdfProductDetailsSection = !expandUdfProductDetailsSection">
        <div v-if="expandUdfProductDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/>
        </div>
        <div v-else>
          <BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/>
        </div>
      </v-btn>
      {{ $t('reviewInformation.productSectionTitle') }}
    </h6>
    <div v-if="$appSettings.dcoConfigurations.productLevelUdfConfiguration.includes(getProductType)">
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="expandUdfProductDetailsSection = true,showUnsavedSnackbar('readOnlyUdfProductDetails', false)" v-if="reviewInformation.productOtherDetails.enableComponent && readOnlyUdfProductDetails"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!readOnlyUdfProductDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="showUnsavedSnackbar('readOnlyUdfProductDetails', true),udfInformationData(0, 'udfProductDetails', false)"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="['savings', 'termDeposit'].includes(productType) && productInformation?.accountOwnership === 'JOINT' ? updateChangesWithSecondaryDetails('productInformation','readOnlyUdfProductDetails') : editSaveChanges('productInformation','readOnlyUdfProductDetails')"
      :disabled="enableSaveButton('udfProductDetails')">{{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
    </div>
  </v-col>
  <v-col v-if="expandUdfProductDetailsSection">
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.reviewProductDetails.enableComponent && readOnlyUdfProductDetails">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
        <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div class="header-spacing" v-if="purposeOfAccount !== '' && purposeOfAccount !== null && purposeOfAccount !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewPurposeOfAccount') }}</p>
              <p class="text-styles">{{ purposeOfAccount }}</p>
            </div>
            <div class="header-spacing" v-if="purposeOfAccountOthers !== '' && purposeOfAccountOthers !== null && purposeOfAccountOthers !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewPurposeOfAccountOthers') }}</p>
              <p class="text-styles">{{ purposeOfAccountOthers }}</p>
            </div>
            <div class="header-spacing" v-if="expectedUsage !== '' && expectedUsage !== null && expectedUsage !== undefined">
              <p class="overline-styles">{{ $t('reviewInformation.reviewExpectedUsage') }}</p>
              <p class="text-styles">{{ expectedUsage }}</p>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-col>
    <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.productOtherDetails.enableComponent === true && !readOnlyUdfProductDetails && $appSettings.dcoConfigurations.productLevelUdfConfiguration.includes(getProductType)">
      <v-col class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:21px;">
        <v-col sm="12" md="6" lg="6" class="flex-alignment">
          <div v-for="(components, index) in reviewInformation.productEditDetails" :key="index">
            <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && components.key !== 'purposeOfAccountOthers'">
              <component
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="components.key"
              :items="components.key === 'purposeOfAccount' ? purposeOfAccountDropdown : components.key === 'expectedUsage' ? expectedUsageDropdown : ''"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="formData[components.key]"
              v-bind:value="formData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              :rules="components?.required ? requiredRules : []"
              @change="handleChange($event, components.key, 'udfProductDetails')">
              </component>
            </div>
            <div v-if="components.key === 'purposeOfAccountOthers' && components.enabledProducts.includes(getProductType) && updatedPurposeOfAccountOther">
              <component
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="components.key"
              :items="components.key === 'purposeOfAccount' ? purposeOfAccountDropdown : components.key === 'expectedUsage' ? expectedUsageDropdown : ''"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="formData[components.key]"
              v-bind:value="formData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              :rules="components?.required ? [requiredRules, purposeOfAccountRules].flat() : []"
              @change="handleChange($event, components.key, 'udfProductDetails')">
              </component>
            </div>
          </div>
        </v-col>
      </v-col>
    </v-col>
  </v-col>
  <v-col cols="11" class="pt-6" v-if="!['', null, undefined].includes(purposeOfAccount) || !['', null, undefined].includes(purposeOfAccountOthers) || !['', null, undefined].includes(expectedUsage)">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Product Details Section End. -->
</div>
<!-- applicant 2 -->
<div v-if="tab === 1">
<v-row class="pb-0 pt-10 ml-0">
  <v-col cols="11" class="d-flex justify-space-between">
    <h5 class="subDetails-header">{{ $t('reviewInformation.secondaryDetails') }}</h5>
    <v-btn text rounded :color="customCSS['secondary']" class="text-none edit-button" @click="expandCollapseDetails(1, secondaryLabel)">
      <div v-if="secondaryLabel === $t('reviewInformation.collapse')">
        <BaseIcon name="remove" size="xs" :color="customCSS['secondary']"/>
        {{ secondaryLabel }}
      </div>
      <div v-else>
        <BaseIcon name="add" size="xs" :color="customCSS['secondary']"/>
        {{ secondaryLabel }}
      </div>
    </v-btn>
  </v-col>
</v-row>
<!-- Contact Details Section Start -->
<v-row class="pb-0 pt-0 ml-0">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.readOnlyContactDetails = !secondaryApplicantsData.readOnlyContactDetails"><div v-if="secondaryApplicantsData.readOnlyContactDetails"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.contact') }}
    </h6>
    <p class="disabled-button">{{ $t('reviewInformation.readOnly') }}</p>
  </v-col>
  <v-col cols= "11" class="pl-6 d-flex justify-space-between" v-if="secondaryApplicantsData.readOnlyContactDetails">
    <div class="text-spacing">
      <div class="header-spacing">
        <p class= "section-headers">{{ $t('reviewInformation.mobile') }}</p>
        <p class="section-content">{{ secondaryApplicantsData.mobileNumber }}</p>
      </div>
      <div v-if="emailId !== ''" class="header-spacing">
        <p class="section-headers">{{ $t('reviewInformation.email') }}</p>
        <p class="section-content">{{ secondaryApplicantsData.emailId }}</p>
      </div>
    </div>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Contact Details Section End -->
<!-- Address Details Section Start -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.expandAddressSection = !secondaryApplicantsData.expandAddressSection"><div v-if="secondaryApplicantsData.expandAddressSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.address') }}
    </h6>
    <p class="disabled-button" v-if="(productType === 'currentAccount' || productType === 'savings') && !reviewInformation.addressLookup[0].enableForCurrentSavings">{{ $t('reviewInformation.readOnly') }}</p>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryApplicantsData.expandAddressSection = true,showUnsavedSnackbar('readOnlyAddressDetails', false, 'secondary')" v-if="secondaryApplicantsData.readOnlyAddressDetails && ((productType !== 'currentAccount' || productType !== 'savings') || ((productType === 'currentAccount' || productType === 'savings') && reviewInformation.addressLookup[0].enableForCurrentSavings))"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!secondaryApplicantsData.readOnlyAddressDetails">
      <v-btn
      small
      rounded
      text
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="addressInformationData(1),showUnsavedSnackbar('readOnlyAddressDetails', true, 'secondary')"
      >{{ $t('reviewInformation.cancel') }}
      </v-btn>
      <v-btn
      small
      rounded
      outlined
      class="disabled-button text-none"
      :color="customCSS['secondary']"
      @click="updateChangesWithPrimaryDetails('addressInformation','readOnlyAddressDetails')"
      :disabled="enableSaveButton('addressDetails')">
      {{ $t('reviewInformation.save') }}
      </v-btn>
    </div>
  </v-col>
  <!-- Address Details with address lookup enabled start. -->
  <v-col v-if="secondaryApplicantsData.expandAddressSection">
    <v-col cols= "11" class="pl-6 d-flex justify-space-between d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="secondaryApplicantsData.readOnlyAddressDetails && ((isAddressLookupEnabled || isAddressLookupEnabled === 'true') && !secondaryAddressAddedManually)">
      <v-col sm="12" md="6" lg="6" class="pl-0">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true && addressSameAsPrimary" class="header-spacing">
          <div class="header-spacing">
            <p class="overline-styles" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.residentialAddress') }}</p>
            <p class="text-styles"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']"/>{{$t('reviewInformation.addressMatchesWithPrimaryApplicant')}}</p>
          </div>
        </div>
        <div class="text-spacing" v-if="addressSameAsPrimary === false">
          <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
            <p class="overline-styles" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.residentialAddress') }}</p>
            <p class="text-styles">{{ secondaryApplicantsData.primaryReview }}</p>
            <p class="sub-text mb-0 mt-1"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{$t('reviewInformation.verifiedAddress')}}</p>
            <p class="sub-text mb-0 mt-1" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation && contactDetails.secondaryApplicantsContactInformation[0] && contactDetails.secondaryApplicantsContactInformation[0].primaryAddress && contactDetails.secondaryApplicantsContactInformation[0].primaryAddress.isDefault"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>Set for communication use</p>
          </div>
        </div>
      </v-col>
      <v-col sm="12" md="6" lg="6" class="pl-0" v-if="addressSameAsPrimary === false">
        <div class="text-spacing">
          <div class="header-spacing" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation && contactDetails.secondaryApplicantsContactInformation[0] && contactDetails.secondaryApplicantsContactInformation[0].primaryAddress && contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress && contactDetails.secondaryApplicantsContactInformation[0].primaryAddress.addressLine1 === contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress.addressLine1">
            <p class="overline-styles">{{ $t('reviewInformation.correspondenceAddress') }}</p>
            <p class="text-styles">{{ $t('reviewInformation.sameAddress') }}</p>
            <p class="sub-text mb-0 mt-1" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0] && contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress && contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress.isDefault"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>Set for communication use</p>
          </div>
          <div v-if="reviewInformation.correspondenceAddressInformation.enableComponent === true && !secondaryReviewCorresponding && contactDetails && contactDetails.secondaryApplicantsContactInformation[0].primaryAddress && contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress && contactDetails.secondaryApplicantsContactInformation[0].primaryAddress.addressLine1 !== contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress.addressLine1" class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.correspondenceAddress') }}</p>
            <p class="text-styles">{{ secondaryApplicantsData.correspondenceReview }}</p>
            <p class="sub-text mb-0" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress && contactDetails.secondaryApplicantsContactInformation[0].correspondenceAddress.isDefault"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>Set for communication use</p>
          </div>
          <div v-if="secondarySelected && contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress === undefined" class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.previousAddress') }}</p>
            <p class="text-styles">{{ $t('reviewInformation.sameAddressPrevious') }}</p>
          </div>
          <div v-if="reviewInformation.previousResidentialAddress.enableComponent === true && !secondarySelected" class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.previousAddress') }}</p>
            <p class="text-styles">{{ secondaryApplicantsData.previousReview }}</p>
          </div>
        </div>
      </v-col>
    </v-col>
    <div>
      <v-col sm="12" md="6" lg="6" class="pl-6 d-flex flex-column justify-space-between" v-if="!secondaryApplicantsData.readOnlyAddressDetails">
        <v-switch label="Address Matches With Primary Applicant" :color="customCSS['primary']" :true-value="true" :false-value="false" v-model="addressSameAsPrimary">
        </v-switch>
        <v-switch v-if="!addressSameAsPrimary" label="Enter the Address Manually" :color="customCSS['primary']" :true-value="true" :false-value="false"
        :disabled="(isAddressLookupEnabled === 'false' || !isAddressLookupEnabled)" v-model="secondaryAddressAddedManually" @click="clearAddressValues(secondaryAddressAddedManually), enableSaveButton('addressDetails')">
        </v-switch>
      </v-col>
      <v-col sm="12" md="6" lg="6" class="pl-6 d-flex flex-column justify-space-between" v-if="(isAddressLookupEnabled || isAddressLookupEnabled === 'true') && !secondaryAddressAddedManually && !addressSameAsPrimary && reviewInformation.addressLookup[0].enabledForPrimaryAddress.includes(getProductType) && !secondaryApplicantsData.readOnlyAddressDetails">
        <v-text-field v-model="secondaryResidentialAddress"
        filled
        clearable
        :label="$t(`reviewInformation.findAddress`)"
        :hint="reviewInformation.addressLookup[0].hint"
        persistent-hint
        :rules="reviewInformation.addressLookup[0]?.required ? [addressLookupRule, addressLookupRegex, requiredRules].flat() : [addressLookupRule, addressLookupRegex].flat()"
        @click:clear="secondaryResidentialAddress ='', enableSaveButton('addressDetails')"
        >
        <template v-slot:append>
          <div class="mt-n1">
            <v-btn
            rounded
            :color="customCSS['primary']"
            class="white--text text-none"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily']}"
            @click="enableAddressLookup('residential', secondaryResidentialAddress)">
            {{ $t(`reviewInformation.search`) }}
            </v-btn>
          </div>
        </template>
      </v-text-field>
      <div v-if="(isAddressLookupEnabled || isAddressLookupEnabled === 'true') && reviewInformation.addressLookup[0].enabledForCorrespondenceAddress.includes(getProductType)">
        <div v-for="(components, index) in reviewInformation.addressLookup" :key="index" style="display: flex;flex-direction: column;gap: 21px;">
          <div v-if="components.enableComponent">
            <v-switch
            :label="$t(`reviewInformation.addressLookup.corresponding`)"
            :color="customCSS['primary']"
            :true-value="true"
            :false-value="false"
            v-model="secondaryReviewCorresponding"
            @change="enableSaveButton('addressDetails')"
            >
            </v-switch>
          </div>
          <div v-if="!secondaryReviewCorresponding">
            <v-row>
              <v-col>
                <v-text-field
                v-model="secondaryCorrespondenceAddress"
                filled
                clearable
                :label="$t(`reviewInformation.findAddress`)"
                :hint="reviewInformation.addressLookup[0].hint"
                persistent-hint
                :rules="reviewInformation.addressLookup[0]?.required ? [addressLookupRule, addressLookupRegex, requiredRules].flat() : [addressLookupRule, addressLookupRegex].flat()"
                @click:clear="secondaryCorrespondenceAddress = '', enableSaveButton('addressDetails')"
                >
                <template v-slot:append>
                  <div class="mt-n1">
                    <v-btn rounded :color="customCSS['primary']" class="white--text text-none" :style="{'font-family': customCSS['onboardingBtn-fontFamily']}" @click="enableAddressLookup('correspondence', correspondenceAddress)"> {{ $t(`reviewInformation.search`) }} </v-btn>
                  </div>
                </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-divider></v-divider>
          <p class="mb-0 mt-5">{{ $t('reviewInformation.useForCommunication') }}</p>
          <div class="d-flex flex-wrap mt-2">
            <v-radio-group v-model="isDefaultSecondary" :row="mobileView()">
              <template v-for="(item, index) in communicationFlag">
                <v-radio v-bind:key="index" :color="customCSS['primary']" :label="$t(`reviewInformation.item.isDefault.${item.label}`)" :value="item.value">
                </v-radio>
              </template>
            </v-radio-group>
          </div>
          <v-divider></v-divider>
        </div>
      </div>
      <div v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)">
        <p
        class="addressSection-content"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionSubTitleColor'],
        }"
        v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)"
        >
        {{ $t('reviewInformation.previousResidentialAddress')}}
        </p>
        <p
        class="kyc-description"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionContentColor'],
        }"
        v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)"
        >
        {{ $t('reviewInformation.previousResidentialAddressHelper')}}
        </p>
        <div class="d-flex flex-wrap" v-if="reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)">
          <v-radio-group v-model="secondarySelected" :row="mobileView()" @change="clearAddressData('previousResidential')">
            <template v-for="(item, index) in residenceAddress">
              <v-radio v-bind:key="index" :label="$t(`reviewInformation.item.selected.${item.label}`)" :value="item.value">
              </v-radio>
            </template>
          </v-radio-group>
        </div>
        <div v-if="secondarySelected === false && reviewInformation.addressLookup[0].enabledForPreviousResidentialAddress.includes(getProductType)">
          <div>
            <v-row>
              <v-col>
                <v-text-field
                v-model="secondaryPreviousResidentialAddress"
                filled
                clearable
                :label="$t(`reviewInformation.findAddress`)"
                :hint="reviewInformation.addressLookup[0].hint"
                persistent-hint
                :rules="reviewInformation.addressLookup[0]?.required ? [addressLookupRule, addressLookupRegex, requiredRules].flat() : [addressLookupRule, addressLookupRegex].flat()"
                @click:clear="secondaryPreviousResidentialAddress = '', enableSaveButton('addressDetails')"
                >
                <template v-slot:append>
                  <div class="mt-n1">
                    <v-btn rounded :color="customCSS['primary']" class="white--text text-none" :style="{'font-family': customCSS['onboardingBtn-fontFamily']}" @click="enableAddressLookup('previousResidential', previousResidentialAddress)"> {{ $t(`reviewInformation.search`)}} </v-btn>
                  </div>
                </template>
                </v-text-field>
              </v-col>
            </v-row>
          </div>
          <v-row class="justify-space-between">
            <v-col cols="6" sm="3" md="6" lg="6">
              <v-menu
              v-model="fromMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                :value="formatFromDate"
                :label="$t(`reviewInformation.addressFrom`)"
                filled
                append-icon="mdi-calendar"
                readonly v-bind="attrs" v-on="on"
                @keydown.tab="fromMenu = false"
                :rules="reviewInformation.addressLookup[0]?.required ? [requiredRules] : []"
                >
                </v-text-field>
              </template>
              <v-date-picker
              v-model="formatSecondaryFromDate"
              no-title
              :max="today"
              :color="customCSS['primary']"
              :show-current="false"
              @change="enableSaveButton('addressDetails')"
              @input="fromMenu = false, secondaryToDate = null"
              >
              </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="6" sm="3" md="6" lg="6">
              <v-menu
              v-model="toMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
              >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                v-model="formatSecondaryToDate"
                :label="$t(`reviewInformation.addressTo`)"
                filled
                append-icon="mdi-calendar"
                readonly v-bind="attrs" v-on="on"
                @keydown.tab="toMenu = false"
                :rules="reviewInformation.addressLookup[0]?.required ? [requiredRules] : []"
                >
                </v-text-field>
              </template>
              <v-date-picker
              v-model="secondaryToDate"
              no-title
              @input="toMenu = false"
              :min="secondaryFromDate"
              :max="today"
              :color="customCSS['primary']"
              :show-current="false"
              @change="enableSaveButton('addressDetails')"
              >
              </v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </div>
      </div>
      </v-col>
    </div>
    <!-- Address Details with address lookup enabled end. -->
    <!-- Address Details with address lookup disabled start. -->
    <v-col cols= "11" class="pl-6 d-flex flex-column flex-gap-16 justify-space-between" style="gap:64px !important;" v-if="secondaryApplicantsData.readOnlyAddressDetails && ((!isAddressLookupEnabled || isAddressLookupEnabled === 'false') || secondaryAddressAddedManually)">
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column">
        <v-row :class="language === '' ? 'pl-7 pb-3' : 'pr-7 pb-3'">
          <p class="sectional-headers mt-4" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.residentialAddressManual') }}</p>
        </v-row>
        <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
          <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true && addressSameAsPrimary" class="header-spacing">
            <div class="header-spacing">
              <p class="overline-styles" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.residentialAddress') }}</p>
              <p class="text-styles"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']"/>{{$t('reviewInformation.addressMatchesWithPrimaryApplicant')}}</p>
            </div>
          </div>
          <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'" v-if="addressSameAsPrimary === false">
            <div class="text-spacing">
              <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
                <div class="text-spacing">
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyPostCode') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.postCode }}</p>
                  </div>
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.countryName !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyCountry') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.countryName }}</p>
                  </div>
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.stateOrprovinceName !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyState') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.stateOrprovinceName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'" v-if="addressSameAsPrimary === false">
            <div class="text-spacing">
              <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
                <div class="text-spacing">
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.city !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.city }}</p>
                  </div>
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.addressLine1 !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine1') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.addressLine1 }}</p>
                  </div>
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress?.addressLine2 !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine2') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.addressLine2 }}</p>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row :class="language === '' ? 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pl-7 mt-1' : 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pr-7 mt-1'">
          <p class="sub-text mb-0 mt-4"><BaseIcon name="info_filled" iconClass="vertical-alignment pr-2" :color="customCSS['primary']"/>{{ $t('reviewInformation.manualAddress') }}</p>
          <p class="sub-text mb-0" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && (contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.isDefault === true || contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.isDefault === 'true')"><BaseIcon name="check_circle_filled" iconClass="vertical-alignment pr-2" :color="customCSS['success']"/>{{ $t('reviewInformation.communicationUse') }}</p>
        </v-row>
      </v-row>
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column" v-if="((productType !== 'currentAccount' || productType !== 'savings')) || ((productType === 'currentAccount' || productType === 'savings') && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress !== undefined && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.postCode !== '')">
        <v-row :class="language === '' ? 'pl-7 pb-3' : 'pr-7 pb-3'">
          <p class="sectional-headers" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.correspondenceAddressManual') }}</p>
        </v-row>
        <v-row v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.postCode === contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.postCode" :class="language === '' ? 'pl-7' : 'pr-7'">
          <p class="text-styles">{{ $t('reviewInformation.sameAddress') }}</p>
        </v-row>
        <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.primaryAddress.postCode !== contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.postCode">
          <v-col sm="12" md="12" lg="6" :class="language  === '' ? 'pl-7' : 'pr-7'">
            <div class="text-spacing">
              <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
                <div class="text-spacing">
                  <div class="header-spacing">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyPostCode') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.postCode }}</p>
                  </div>
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.countryName !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyCountry') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.countryName }}</p>
                  </div>
                  <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.stateOrprovinceName !== ''">
                    <p class="overline-styles">{{ $t('reviewInformation.readOnlyState') }}</p>
                    <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.stateOrprovinceName }}</p>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
          <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
          <div class="text-spacing">
            <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true" class="header-spacing">
              <div class="text-spacing">
                <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.city !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                  <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.city }}</p>
                </div>
                <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.addressLine1 !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine1') }}</p>
                  <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.addressLine1 }}</p>
                </div>
                <div class="header-spacing" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress?.addressLine2 !== ''">
                  <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine2') }}</p>
                  <p class="text-styles">{{ contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress?.addressLine2 }}</p>
                </div>
              </div>
            </div>
          </div>
          </v-col>
        </v-row>
        <v-row :class="language === '' ? 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pl-7 mt-4' : 'd-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column pr-7 mt-4'" v-if="contactDetails && contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress && (contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.isDefault === true || contactDetails?.secondaryApplicantsContactInformation[0]?.correspondenceAddress.isDefault === 'true')">
        <p class="sub-text mb-0"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/>{{ $t('reviewInformation.communicationUse') }}</p>
        </v-row>
      </v-row>
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column">
      <v-row :class="language === '' ? 'pl-7 pb-3' : 'pr-7 pb-3'">
      <p class="sectional-headers" v-if="reviewInformation.residentialAddressInformation.enableComponent === true">{{ $t('reviewInformation.previousAddressManual') }}</p>
      </v-row>
      <v-row v-if="!contactDetails?.secondaryApplicantsContactInformation[0]?.previousResidentialAddress" :class="language === '' ? 'pl-7' : 'pr-7'">
      <p class="text-styles">{{ $t('reviewInformation.sameAddressPrevious') }}</p>
      </v-row>
      <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="contactDetails?.secondaryApplicantsContactInformation[0]?.previousResidentialAddress">
      <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true && contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress !== undefined" class="header-spacing">
          <div class="text-spacing">
          <div class="header-spacing" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.addressLine1 !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyPostCode') }}</p>
            <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.postCode }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.countryName !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyCountry') }}</p>
            <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.countryName }}</p>
          </div>
          <v-row v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.stateOrprovinceName && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.stateOrprovinceName !== ''">
            <v-col cols="6">
              <div class="header-spacing" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.stateOrprovinceName !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyState') }}</p>
            <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.stateOrprovinceName }}</p>
          </div>
            </v-col>
            <v-col cols="6">
              <div class="header-spacing" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.city !== ''">
                <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.city }}</p>
              </div>
            </v-col>
          </v-row>
          <div class="header-spacing" v-if="contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.city && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.city !== ''">
                <p class="overline-styles">{{ $t('reviewInformation.readOnlyCity') }}</p>
                <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.city }}</p>
              </div>
          </div>
        </div>
      </div>
      </v-col>
      <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div v-if="reviewInformation.residentialAddressInformation.enableComponent === true && contactDetails && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress !== undefined" class="header-spacing">
          <div class="text-spacing">
          <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine1') }}</p>
            <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.addressLine1 }}</p>
          </div>
          <div class="header-spacing" v-if="contactDetails?.secondaryApplicantsContactInformation[0] && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress && contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.addressLine2 !== ''">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressLine2') }}</p>
            <p class="text-styles">{{ contactDetails.secondaryApplicantsContactInformation[0].previousResidentialAddress.addressLine2 }}</p>
          </div>
          <v-row>
            <v-col cols="6">
              <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressFrom') }}</p>
            <p class="text-styles">{{ secondaryApplicantsData.readOnlyFromDate }}</p>
          </div>
            </v-col>
            <v-col cols="6">
              <div class="header-spacing">
            <p class="overline-styles">{{ $t('reviewInformation.readOnlyAddressTo') }}</p>
            <p class="text-styles">{{ secondaryApplicantsData.readOnlyToDate }}</p>
          </div>
            </v-col>
          </v-row>
        </div>
      </div>
      </div>
      </v-col>
      </v-row>
      </v-row>
    </v-col>
  <v-col cols= "11" class="d-flex flex-column justify-space-between" v-if="!addressSameAsPrimary && !secondaryApplicantsData.readOnlyAddressDetails && ((!isAddressLookupEnabled || isAddressLookupEnabled === 'false')|| secondaryAddressAddedManually)">
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between">
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'primaryAddress' && j <= 3 && components.enabledProducts.includes(getProductType)">
                <component
                v-if="components.enableComponent && components.type !== 'VCheckbox' && (components && components.dependent ? addPrimaryAddressLine3 === true || addPrimaryAddressLine4 === true ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                :hint="components.hint"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="'secondary-' + components.key"
                :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? primaryStatesDropdown : undefined"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="secondaryFormData[i][components.key]"
                :class="components.class"
                @click="components.key === 'stateOrprovince' ? statesloader(secondaryFormData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary, 'addressDetails')">
                </component>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'primaryAddress' && j > 3 && components.enabledProducts.includes(getProductType)">
              <component
              v-if="components.enableComponent && components.type !== 'VCheckbox'"
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? secondaryApplicantsData.primaryStatesDropdown : undefined"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="secondaryFormData[i][components.key]"
              :class="components.class"
              @click="components.key === 'stateOrprovince' ? statesloader(secondaryFormData[i].country) : ''"
              @change="handleChange($event, components.key, components.nestedValue, components.primary, 'addressDetails')">
              </component>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div v-if="(contactDetails.secondaryApplicantsContactInformation[0]?.correspondenceAddress && contactDetails.secondaryApplicantsContactInformation[0]?.correspondenceAddress !== undefined && contactDetails.secondaryApplicantsContactInformation[0]?.correspondenceAddress.postCode !== '')">
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between">
    <v-col cols="12">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'correspondenceAddress' && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'switch'">
                <v-switch
                :label="$t(`reviewInformation.${components.key}`)"
                :color="customCSS['primary']"
                :true-value="true"
                :false-value="false"
                v-model="secondaryManualInputCorresponding"
                @click="correspondenceAddress = '', corrAddressresponse = '', enableSaveButton('addressDetails')"
                >
                </v-switch>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" v-if="!secondaryManualInputCorresponding">
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'correspondenceAddress' && j <= 4 && components.enabledProducts.includes(getProductType)">
              <component
              v-if="components.type !== 'switch'"
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? secondaryApplicantsData.corrStatesDropdown : undefined"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="secondaryFormData[i][components.key]"
              :class="components.class"
              @click="components.key === 'stateOrprovince' ? corrStatesloader(secondaryFormData[i].country) : ''"
              @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
              </component>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'correspondenceAddress' && j > 4 && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'switch'">
                <v-switch
                :label="$t(`reviewInformation.${components.key}`)"
                :color="customCSS['primary']"
                :true-value="true"
                :false-value="false"
                v-model="secondaryManualInputCorresponding"
                @click="correspondenceAddress = '', corrAddressresponse = '', enableSaveButton('addressDetails')"
                >
                </v-switch>
              </div>
              <div v-else-if="components.type !== 'switch' && components.type !== 'VCheckbox' && components.dependent && components.dependent.componentKey === 'manualInputCorresponding'">
                <component
                v-if="components.enableComponent && (components && components.dependent && (components.dependent.componentKey !== 'addcorrAddressLine3' && components.dependent.componentKey !== 'addcorrAddressLine4') ? components.dependent.componentKey === 'manualInputCorresponding' && secondaryManualInputCorresponding === false ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="'secondary-' + components.key"
                :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? secondaryApplicantsData.corrStatesDropdown : undefined"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="secondaryFormData[i][components.key]"
                :class="components.class"
                @click="components.key === 'stateOrprovince' ? corrStatesloader(secondaryFormData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
                </component>
              </div>
              <div v-else-if="components.dependent && components.dependent.componentKey !== 'manualInputCorresponding' && secondaryManualInputCorresponding === false">
                <component
                v-if="components.enableComponent && components.type !== 'VCheckbox' && (components.dependent.componentKey === 'addcorrAddressLine3' && addcorrAddressLine3 === true ? true : components.dependent.componentKey === 'addcorrAddressLine4' && addcorrAddressLine4 === true && addcorrAddressLine3 === true ? true : false )"
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="'secondary-' + components.key"
                :class="components.class"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                v-model="secondaryFormData[i][components.key]"
                @click="components.key === 'stateOrprovince' ? corrStatesloader(secondaryFormData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary, 'addressDetails')">
                </component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between">
    <v-col sm="12" md="12" lg="12">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'useForCommunication' && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'v-html' && components.enableComponent">
                <div v-html="components.data" :class="components.class"></div>
                </div>
                <div v-else-if="components.type === 'VRadioGroup' && components.enableComponent">
                  <p class="field-labels">Use for Communication</p>
                  <div class="d-flex flex-wrap">
                    <v-radio-group v-model="isDefaultManualSecondary" :row="mobileView()">
                      <template v-slot:label>
                      </template>
                      <template v-for="(item, index) in components.values">
                        <v-radio
                        v-bind:key="index"
                        :label="$t(`reviewInformation.item.isDefaultManual.${item.label}`)"
                        :value="item.value">
                        </v-radio>
                      </template>
                    </v-radio-group>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    </div>
    <div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column justify-space-between">
      <p class="pl-3 field-labels mb-0"> Previous Residential Address</p>
      <v-col cols="12">
        <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
          <div v-for="(obj, i) in data" :key="i">
            <div v-for="(components, j) in obj" :key="j">
              <div v-if="i === 'previousResidentialAddress' && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'v-html' && components.enableComponent">
                <div v-html="components.data" :class="components.class"></div>
              </div>
              <div v-else-if="components.type === 'VRadioGroup' && components.enableComponent">
                <div class="d-flex flex-wrap pt-5">
                  <v-radio-group v-model="secondaryPrevManualAddress" :row="mobileView()">
                    <template v-slot:label></template>
                      <template v-for="(item, index) in components.values">
                        <v-radio
                        v-bind:key="index"
                        :label="$t(`reviewInformation.item.previousResidential.${item.label}`)"
                        :value="item.value"
                        @change="clearAddressData('previousResidential')"
                        >
                        </v-radio>
                      </template>
                  </v-radio-group>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" v-if="!secondaryPrevManualAddress">
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'previousResidentialAddress' && j>1 && j <= 5 && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type !== 'VRadioGroup' && components.type !== 'VCheckbox'">
                <component
                v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'prevManualAddress' && secondaryPrevManualAddress === false ? true : false : true)"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="'secondary-' + components.key"
                :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? secondaryApplicantsData.prevStatesDropdown : undefined"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :class="components.class"
                v-model="secondaryFormData[i][components.key]"
                @click="components.key === 'stateOrprovince' ? prevstatesloader(secondaryFormData[i].country) : ''"
                @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
                </component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6">
      <div v-for="(data, index) in reviewInformation.manualInputOfAddress" :key="index">
        <div v-for="(obj, i) in data" :key="i">
          <div v-for="(components, j) in obj" :key="j">
            <div v-if="i === 'previousResidentialAddress' && j > 5 && components.enabledProducts.includes(getProductType)">
              <div v-if="components.type === 'datePicker'">
                <div v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'prevManualAddress' && secondaryPrevManualAddress === false ? true : false : true)">
                  <v-menu
                  v-if="components.key === 'fromDate'"
                  v-model="fromMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                    v-model="formatSecondaryFromDate"
                    :label="$t(`reviewInformation.${components.key}`)"
                    :filled="components.filled"
                    :hide-details="components.hideDetails"
                    append-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    @keydown.tab="fromMenu = false"
                    :rules="components?.required ? [requiredRules] : []"
                    >
                    </v-text-field>
                  </template>
                  <v-date-picker
                  :max="today"
                  v-model="secondaryFromDate"
                  no-title
                  @input="fromMenu = false, secondaryToDate = null"
                  :color="customCSS['primary']"
                  :show-current="false"
                  >
                  </v-date-picker>
                  </v-menu>
                  <v-menu v-if="components.key === 'toDate'"
                  v-model="toMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="auto">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formatSecondaryToDate"
                      :label="$t(`reviewInformation.${components.key}`)"
                      :filled="components.filled"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      :rules="components?.required ? [requiredRules] : []"
                      @keydown.tab="toMenu = false">
                    </v-text-field>
                  </template>
                  <v-date-picker
                  v-model="secondaryToDate"
                  no-title
                  @input="toMenu = false"
                  :min="secondaryFromDate"
                  :max="today"
                  :color="customCSS['primary']"
                  :show-current="false"
                  >
                  </v-date-picker>
                  </v-menu>
                  </div>
                </div>
                <div v-else-if="components.type !== 'VRadioGroup' && components.type !== 'VCheckbox'">
                  <component
                  v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'prevManualAddress' && secondaryPrevManualAddress === false ? true : false : true)"
                  validate-on-blur
                  :is="componentType[components.type].component"
                  :label="$t(`reviewInformation.${components.key}`)"
                  :hint="components.hint"
                  :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                  :persistent-hint="components.persistent"
                  :filled="components.filled"
                  :key="'secondary-' + components.key"
                  :items="components.key === 'country' ? reviewCountry : components.key === 'stateOrprovince' ? secondaryApplicantsData.prevStatesDropdown : undefined"
                  :item-text="components.displayText ? components.displayText : codeDescription"
                  :item-value="components.displayValue ? components.displayValue : codeReference"
                  :[components.iconPlacement]="components.icon"
                  :class="components.class"
                  v-model="secondaryFormData[i][components.key]"
                  @click="components.key === 'stateOrprovince' ? prevstatesloader(secondaryFormData[i].country) : ''"
                  @change="handleChange($event, components.key, components.nestedValue, components.primary,'addressDetails')">
                  </component>
                </div>
                <div v-else-if="components.dependent && components.dependent.componentKey !== 'prevManualAddress' && !secondaryPrevManualAddress">
                  <component
                  v-if="components.enableComponent && components.type !== 'VCheckbox' && (components.dependent.componentKey === 'addprevAddressLine3' && addprevAddressLine3 === true ? true : components.dependent.componentKey === 'addprevAddressLine4' && addprevAddressLine4 === true && addprevAddressLine3 === true ? true : false )"
                  :is="componentType[components.type].component"
                  :label="$t(`reviewInformation.${components.key}`)"
                  :hint="components.hint"
                  :persistent-hint="components.persistent"
                  :filled="components.filled"
                  :key="'secondary-' + components.key"
                  :class="components.class"
                  :rules="components?.key === 'stateOrprovince' && components.required ? requiredRules : components?.key === 'addressLine2' ? components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex] : components?.key === 'city' ? components.required ? [requiredRules, cityRules].flat() : [cityRules] : components?.key === 'postCode' ? components.required ? [requiredRules, addressRules, postCodeLengthRule].flat() : [addressRules, postCodeLengthRule].flat() : components.required ? [requiredRules, addressLookupRegex].flat() : [addressLookupRegex]"
                  v-model="secondaryFormData[i][components.key]"
                  @click="components.key === 'stateOrprovince' ? prevstatesloader(secondaryFormData[i].country) : ''"
                  @change="handleChange($event, components.key, components.nestedValue, components.primary, 'addressDetails')">
                  </component>
                </div>
            </div>
          </div>
        </div>
      </div>
    </v-col>
    </div>
    </div>
  </v-col>
  </v-col>
  <!-- Address Details with address lookup disabled end. -->
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Personal Details Section Start -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.personalReadOnlyDetails.enableComponent">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.expandPersonalDetailsSection = !secondaryApplicantsData.expandPersonalDetailsSection"><div v-if="secondaryApplicantsData.expandPersonalDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.personal') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryApplicantsData.expandPersonalDetailsSection = true,showUnsavedSnackbar('readOnlyPersonalDetails', false, 'secondary')" v-if="reviewInformation.personalEditDetails.enableComponent && secondaryApplicantsData.readOnlyPersonalDetails"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!secondaryApplicantsData.readOnlyPersonalDetails">
      <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="personalInformationData(1), showUnsavedSnackbar('readOnlyPersonalDetails', true, 'secondary')">{{ $t('reviewInformation.cancel') }}</v-btn>
      <v-btn small rounded outlined class="disabled-button text-none" :color="customCSS['secondary']" @click="updateChangesWithPrimaryDetails('personalInformation','readOnlyPersonalDetails')" :disabled="enableSaveButton('personalDetails')">{{ $t('reviewInformation.save') }}</v-btn>
    </div>
  </v-col>
  <v-col v-if="secondaryApplicantsData.expandPersonalDetailsSection">
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.personalReadOnlyDetails.enableComponent && secondaryApplicantsData.readOnlyPersonalDetails">
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
    <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="secondaryApplicantsData?.titleDescription && secondaryApplicantsData?.titleDescription !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.titleDescription') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.titleDescription }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.firstName && secondaryApplicantsData?.firstName !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyFirstName') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.firstName }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.middleName && secondaryApplicantsData?.middleName !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyMiddleName') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.middleName }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.lastName && secondaryApplicantsData?.lastName !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyLastName') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.lastName }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.reviewReadOnlyGender && secondaryApplicantsData?.reviewReadOnlyGender !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyGender') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.reviewReadOnlyGender }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.primaryNationalityDescription && secondaryApplicantsData?.primaryNationalityDescription !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyNationality') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.primaryNationalityDescription }}</p>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="secondaryApplicantsData?.dateOfBirth && secondaryApplicantsData?.dateOfBirth !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyDateOfBirth') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.dateOfBirth }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.birthCountryName && secondaryApplicantsData?.birthCountryName !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyBirthCountry') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.birthCountryName }}</p>
        </div>
        <div class="header-spacing" v-if="personalReviewData?.secondaryApplicantsPersonalInformation[0]?.residentCountryCode && personalReviewData?.secondaryApplicantsPersonalInformation[0]?.residentCountryCode !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyUKResident') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.ukResident }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.nationalIdTypeCode && secondaryApplicantsData?.nationalIdTypeCode !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.nationalIdType') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.nationalIdTypeCode }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData?.nationalIdNumber && secondaryApplicantsData?.nationalIdNumber !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.reviewNationalIdNumber') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData?.nationalIdNumber }}</p>
        </div>
      </div>
    </v-col>
    </v-row>
  </v-col>
  <v-col cols="11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.personalEditDetails.enableComponent && !secondaryApplicantsData.readOnlyPersonalDetails">
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:15px;">
      <v-col sm="12" md="6" lg="6">
        <div v-for="(components, index) in reviewInformation.personalDetails" :key="index">
          <div v-if="index <=8">
            <div v-if="components.type === 'v-html'&& components.enableComponent && components.enabledProducts.includes(getProductType)">
              <div v-html="components.data" :class="components.class"></div>
            </div>
            <div v-else-if="components.type === 'VRadioGroup' && components.enableComponent && secondaryFormData[components.key] !== '' && (components.key === 'gender' || components.enabledProducts.includes(getProductType))">
              <p
              class="kyc-description pt-3"
              :style="{
                'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
                color: customCSS['onboarding-sectionContentColor'],
              }"
              v-if="components.key === 'gender'"
              >Gender
              </p>
              <div class="d-flex flex-wrap">
                <v-radio-group v-model="secondaryFormData[components.key]" :row="mobileView()" :disabled="components.disabled">
                  <template v-slot:labe></template>
                  <template v-for="(item, index) in components.values">
                    <v-radio v-bind:key="index" :label="$t(`reviewInformation.item.${components.key}.${item.label}`)" :value="item.value">
                    </v-radio>
                  </template>
                </v-radio-group>
              </div>
            </div>
            <div v-else-if="components.type === 'VCheckbox' && components.enableComponent === true && components.enabledProducts.includes(getProductType)">
              <v-checkbox v-if="components.key === 'reviewMiddleNameCheckbox' && components.enabledProducts.includes(getProductType)"
              :label="$t(`reviewInformation.${components.key}`)"
              :true-value="true"
              :false-value="false"
              :key="'secondary-' + components.key"
              v-model="secondaryFormData.reviewMiddleNameCheckbox"
              @click="!secondaryFormData.reviewMiddleNameCheckbox ? secondaryFormData.middleName = '' : secondaryFormData.middleName"
              >
              </v-checkbox>
              <v-checkbox v-else-if="components.key === 'reviewAnotherNationality'"
              :label="$t(`reviewInformation.${components.key}`)"
              :true-value="true"
              :false-value="false"
              :key="'secondary-' + components.key"
              v-model="secondaryFormData.reviewAnotherNationality">
              </v-checkbox>
            </div>
            <div v-else-if="components.type !=='VCheckbox'" class="pb-2">
              <component
              v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && (components && components.dependent ? components.dependent.componentKey === 'reviewMiddleNameCheckbox' && secondaryFormData.reviewMiddleNameCheckbox ? true : components.dependent.componentKey === 'reviewAnotherNationality' && secondaryFormData.reviewAnotherNationality ? true : false : true)"
              validate-on-blur
              lazy-rules
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? componentType[components.type].component !== 'v-select' ? [requiredRules, secondaryPersonalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : requiredRules : secondaryFormData[components.key] !== '' ? [secondaryPersonalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'titleCode' ? items : components.key === 'primaryNationality' || components.key === 'secondaryNationality' ? reviewNationality : components.key === 'birthCountryCode' ? reviewCountry : null"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="secondaryFormData[components.key]"
              v-bind:value="secondaryFormData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              @change="handleChange($event, components.key,'personalDetails')">
              </component>
            </div>
          </div>
        </div>
      </v-col>
      <v-col sm="12" md="6" lg="6" class="d-flex flex-column flex-gap-3">
        <p
        class="kyc-description mb-1"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionContentColor']
        }"
        >
        Date Of Birth
        </p>
        <div class="d-flex d-md-flex flex-row flex-md-row flex-wrap">
          <v-col cols="12" md="12" lg="12" class="pl-0 pr-0">
            <div style="display: flex;">
          <div v-for="(components, index) in reviewInformation.personalDetails" :key="index">
            <div v-if="index > 8 && index <=11">
            <div :class="index === 11 ? '' : mobileViewScreen() ? language!== '' ? 'pl-5' : 'pr-5' : 'pr-1'">
              <component v-if="components.enableComponent"
              validate-on-blur
              lazy-rules
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? componentType[components.type].component !== 'v-select' ? [requiredRules, secondaryPersonalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : requiredRules : secondaryFormData[components.key] !== '' ? [secondaryPersonalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'year' ? yearsDropdown : components.key === 'month' ? monthsDropdown : components.key === 'date' ? daysDropdown : null"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="secondaryFormData[components.key]"
              v-bind:value="secondaryFormData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              @change="handleChange($event, components.key,'personalDetails')">
              </component>
            </div>
          </div>
        </div>
            </div>
          </v-col>
      </div>
      <v-row class="d-flex d-md-flex flex-column flex-md-column flex-wrap mobile-columnAlignment ma-0">
        <v-col cols="12" md="12" lg="12" class="pl-0 pr-0">
        <div v-for="(components, index) in reviewInformation.personalDetails" :key="index">
          <div v-if="index >11">
            <div v-if="components.type === 'v-html'&& components.enableComponent && components.enabledProducts.includes(getProductType)">
              <div v-html="components.data" :class="components.class"></div>
            </div>
            <div v-else-if="components.type === 'VCheckbox' && components.enableComponent === true">
              <v-checkbox v-if="components.key === 'reviewAnotherNationality'"
              label="$t(`reviewInformation.${components.key}`)"
              :true-value="true"
              :false-value="false"
              :key="'secondary-' + components.key"
              v-model="secondaryFormData.reviewAnotherNationality"
              >
              </v-checkbox>
            </div>
            <div v-else-if="components.type !=='VCheckbox'">
              <component
              v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && (components && components.dependent ? components.dependent.componentKey === 'reviewMiddleNameCheckbox' && secondaryFormData.reviewMiddleNameCheckbox ? true : components.dependent.componentKey === 'reviewAnotherNationality' && secondaryFormData.reviewAnotherNationality ? true : false : true)"
              validate-on-blur
              lazy-rules
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? componentType[components.type].component !== 'v-select' ? [requiredRules, secondaryPersonalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : requiredRules : secondaryFormData[components.key] !== '' ? [secondaryPersonalRules, (v => v.length <= components.maxLength || components.maxLengthErrorMessage)].flat() : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'titleCode' ? items : components.key === 'primaryNationality' || components.key === 'secondaryNationality' ? reviewNationality : components.key === 'birthCountryCode' ? reviewCountry : components.key === 'nationalIdTypeId' ? nationalIdentities : null"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="secondaryFormData[components.key]"
              v-bind:value="secondaryFormData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              @change="handleChange($event, components.key,'personalDetails')">
              </component>
            </div>
          </div>
        </div>
        </v-col>
      </v-row>
      </v-col>
    </div>
  </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Personal Details Section End -->
<!-- Tax Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.taxInformation.enableComponent">
  <v-col  cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.expandTaxDetailsSection = !secondaryApplicantsData.expandTaxDetailsSection"><div v-if="secondaryApplicantsData.expandTaxDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.taxInformation') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryApplicantsData.expandTaxDetailsSection = true,showUnsavedSnackbar('readOnlyTaxDetails', false, 'secondary')" v-if="reviewInformation.taxEditDetails.enableComponent && secondaryApplicantsData.readOnlyTaxDetails"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!secondaryApplicantsData.readOnlyTaxDetails">
      <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="taxInformationData(1),showUnsavedSnackbar('readOnlyTaxDetails', true, 'secondary')" v-if="!secondaryApplicantsData.readOnlyTaxDetails">{{ $t('reviewInformation.cancel') }}</v-btn>
      <v-btn small rounded outlined class="disabled-button text-none" :color="customCSS['secondary']" @click="updateChangesWithPrimaryDetails('taxInformation','readOnlyTaxDetails')" :disabled="enableSaveButton('taxDetails')">{{ $t('reviewInformation.save') }}</v-btn>
    </div>
  </v-col>
  <v-col v-if="secondaryApplicantsData.expandTaxDetailsSection">
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="secondaryApplicantsData.readOnlyTaxDetails">
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="(taxReviewData && (taxReviewData.taxPayerFlag === 'true' || taxReviewData.taxPayerFlag === true))">
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="taxReviewData?.secondaryApplicantsTaxInformation[0]?.countryOfTaxResidentName && taxReviewData?.secondaryApplicantsTaxInformation[0]?.countryOfTaxResidentName !== ''">
          <p class="overline-styles mb-0">{{ $t('reviewInformation.taxCountry') }}</p>
          <p class="text-styles mb-0">{{ taxReviewData?.secondaryApplicantsTaxInformation[0].countryOfTaxResidentName }}</p>
        </div>
        <div class="header-spacing" v-if="taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxIdentificationNumber && taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxIdentificationNumber !== ''">
          <p class="overline-styles mb-0">{{ $t('reviewInformation.taxNumber') }}</p>
          <p class="text-styles mb-0">{{ taxReviewData?.secondaryApplicantsTaxInformation[0].taxIdentificationNumber }}</p>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxResidentInOtherCountry && taxReviewData?.secondaryApplicantsTaxInformation[0]?.foreignCountryOfTaxResidenceName && taxReviewData?.secondaryApplicantsTaxInformation[0]?.foreignCountryOfTaxResidenceName !== ''">
          <p class="overline-styles mb-0">{{ $t('reviewInformation.reviewForeignCountryOfTaxResidence') }}</p>
          <p class="text-styles mb-0">{{ taxReviewData?.secondaryApplicantsTaxInformation[0].foreignCountryOfTaxResidenceName }}</p>
        </div>
        <div class="header-spacing" v-if="taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxResidentInOtherCountry === 'false' || taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxResidentInOtherCountry === false">
          <p class="overline-styles mb-0">{{ $t('reviewInformation.reviewForeignCountryOfTaxResidence') }}</p>
          <p class="text-styles mb-0">Not Applicable</p>
        </div>
        <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
            <v-col sm="12" md="6" lg="6">
              <div class="d-flex header-spacing" v-if="(taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxResidentInOtherCountry === true || taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxResidentInOtherCountry === 'true')  && usResident !== ''">
          <p class="overline-styles mb-0">{{ $t('reviewInformation.usResident') }}</p>
          <p class="text-styles mb-0">{{ usResident }}</p>
        </div>
            </v-col>
            <v-col sm="12" md="3" lg="3">
              <div class="d-flex header-spacing" v-if="taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxResidentInOtherCountry && taxReviewData?.secondaryApplicantsTaxInformation[0]?.tinNumberInOtherCountry && taxReviewData?.secondaryApplicantsTaxInformation[0]?.tinNumberInOtherCountry !== ''">
          <p class="overline-styles mb-0">{{ $t('reviewInformation.tinNumber') }}</p>
          <p class="text-styles mb-0">{{ taxReviewData?.secondaryApplicantsTaxInformation[0].tinNumberInOtherCountry }}</p>
        </div>
            </v-col>
          </v-row>

      </div>
    </v-col>
  </v-row>
  <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-else-if="((taxReviewData?.secondaryApplicantsTaxInformation[0] && (!taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxPayerFlag || taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxPayerFlag === 'false'))) && taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxExemptionReasonName !== ''">
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxExemptionReasonName !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.taxExemptionReasonReadOnly') }}</p>
          <p class="text-styles taxDetails-display">{{ taxReviewData?.secondaryApplicantsTaxInformation[0].taxExemptionReasonName }}</p>
        </div>
      </div>
    </v-col>
  </v-row>
  <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-else-if="taxReviewData?.secondaryApplicantsTaxInformation[0] && (!taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxPayerFlag || taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxPayerFlag === 'false') && taxReviewData?.secondaryApplicantsTaxInformation[0]?.taxExemptionReasonName === ''">
    <v-col sm="12" md="12" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing">
          <p class="text-styles taxDetails-display">{{ $t('reviewInformation.notATaxPayer') }}</p>
        </div>
      </div>
    </v-col>
  </v-row>
  </v-col>
  <v-col cols= "11" class="d-flex flex-column justify-space-between" v-if="!secondaryApplicantsData.readOnlyTaxDetails">
    <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-column flex-sm-column justify-space-between" style="column-gap:21px;">
      <v-row>
      <v-col cols="12" v-if="getProductType !== 'lifetimeISA'">
        <div v-for="(components, index) in reviewInformation.taxDetails" :key="index">
          <div v-if="components.type === 'VButtonToggle' && components.enableComponent === true && reviewInformation && reviewInformation.taxInformation && reviewInformation.taxInformation.isToggleSwitchEnabled">
              <div v-on="on" :style="reviewInformation && reviewInformation.taxInformation && reviewInformation.taxInformation.isToggleSwitchEnabled ? 'position: relative; bottom:30px;' : ''" v-if="productType !== 'lifetimeISA'">
                <v-btn-toggle
                tile
                color="deep-purple accent-3"
                :class="isLisa ? 'toggle-switch-group toggle-switch-disable' : 'toggle-switch-group'"
                group
                mandatory
                v-model="secondaryTaxValue"
                @change="handleChange(taxValue,'taxDetails')"
                >
                <v-btn class="mr-0 text-none" :value="true" active-class="toggle-switch-button">{{ $t(`reviewInformation.taxValue.${components.firstItemlabel}`)}}</v-btn>
                <v-btn class="ml-0 text-none" :value="false" active-class="toggle-switch-button"
                >{{ $t(`reviewInformation.taxValue.${components.secondItemlabel}`)}}
                </v-btn>
                </v-btn-toggle>
              </div>
              <p v-if="secondaryTaxValue === false && !components.enabledProducts.includes(getProductType)"><BaseIcon name="check" iconClass="vertical-alignment" :color="customCSS['primary']"/>{{$t(`reviewInformation.secondItemDescription`)}}</p>
            </div>
        </div>
      </v-col>
      </v-row>
      <div class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column pt-4" style="column-gap: 21px;">
      <v-col sm="12" md="6" lg="6">
        <div v-for="(components, index) in reviewInformation.taxDetails" :key="index">
            <div v-if="index >=1" :style="secondaryTaxValue ? secondaryTaxResidentInOtherCountry ? 'display: flex; flex-direction: column; gap: 16px; padding-left: 0px !important' : 'display: flex; flex-direction: column; gap: 12px; padding-left: 0px !important;padding-top: 0px !important;' : 'display: flex; flex-direction: column; padding-left: 0px !important; padding-top: 0px !important;'">
            <div v-if="components.type === 'v-html' && components.enabledProducts.includes(getProductType) && ((components.enableComponent && secondaryTaxValue && components.key === 'taxPayerContent') || (components.enableComponent && secondaryTaxValue && secondaryTaxResidentInOtherCountry && components.key === 'usResidentContent'))">
              <div v-html="components.data" :class="components.class"></div>
            </div>
            <div v-else-if="components.type === 'VRadioGroup'&& components.enableComponent && components.enabledProducts.includes(getProductType)">
              <div class="d-flex flex-wrap" v-if="components.key === 'taxResidentInOtherCountry' && secondaryTaxValue">
                <v-radio-group v-model="secondaryTaxResidentInOtherCountry" :row="mobileView()" :disabled="components.disabled">
                  <template v-slot:label></template>
                  <template v-for="(item, index) in components.values">
                    <v-radio v-bind:key="index" :label="$t(`reviewInformation.item.${components.key}.${item.label}`)" :value="item.value">
                    </v-radio>
                  </template>
                </v-radio-group>
              </div>
              <div class="d-flex flex-wrap pt-4" v-else-if="components.key === 'areYouUSResident' && secondaryTaxValue && secondaryTaxResidentInOtherCountry && components.enabledProducts.includes(getProductType)">
                        <v-radio-group v-model="secondaryAreYouUSResident" :row="mobileView()" :disabled="components.disabled">
                          <template v-slot:label></template>
                          <template v-for="(item, index) in components.values">
                            <v-radio v-bind:key="index" :label="$t(`reviewInformation.item.${components.key}.${item.label}`)" :value="item.value">
                            </v-radio>
                          </template>
                        </v-radio-group>
                      </div>
            </div>
            <div v-else>
              <div v-if="((!components.enabledProducts.includes(getProductType)) && components.key !== 'taxExemptionReason') || (productType === 'lifetimeISA' && components.key !== 'taxExemptionReason') || (components.enabledProducts.includes(getProductType)) || productsAllowedWithAccountDetails">
                <component
                v-if="components.enableComponent && (components && components.dependent ? components.dependent.componentKey === 'taxValue' ? secondaryTaxValue === components.dependent.value : components.dependent.componentKey === 'taxResidentInOtherCountry' ? secondaryTaxResidentInOtherCountry === components.dependent.value && secondaryTaxValue : secondaryFormData[components.dependent.componentKey] === components.dependent.value : components.key === 'taxIdentificationNumber')"
                validate-on-blur
                :is="componentType[components.type].component"
                :label="$t(`reviewInformation.${components.key}`)"
                :hint="components.hint"
                :rules="components?.required ? components.key === 'taxIdentificationNumber' ? [requiredRules, taxRules].flat() : requiredRules : []"
                :persistent-hint="components.persistent"
                :filled="components.filled"
                :key="'secondary-' + components.key"
                :items="components.key === 'taxExemptionReason' ? taxExemptionDropDown : reviewCountry"
                :item-text="components.displayText ? components.displayText : codeDescription"
                :item-value="components.displayValue ? components.displayValue : codeReference"
                :[components.iconPlacement]="components.icon"
                :true-value="components.trueValue"
                :false-value="components.falseValue"
                v-model="secondaryFormData[components.key]"
                v-bind:value="secondaryFormData[components.key]"
                :class="components.class"
                :hide-details="components.hideDetails? components.hideDetails : false"
                :defalut="components.default"
                :disabled="components.disabled"
                @change="handleChange($event, components.key,'taxDetails')">
                </component>
              </div>
            </div>
          </div>
          </div>
      </v-col>
      </div>
    </div>
  </v-col>
  </v-col>
  <!-- Tax Details Section End. -->
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Identity Document Section Start. -->
<v-row class="pb-0 pt-0 ml-0" v-if="secondaryApplicantsImage !== '' && secondaryApplicantsImage !== undefined">
  <v-col  cols= "11" class="pl-0 pb-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.readOnlyIdentityDetails = !secondaryApplicantsData.readOnlyIdentityDetails"><div v-if="secondaryApplicantsData.readOnlyIdentityDetails"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.identityDocuments') }}
    </h6>
    <p class="disabled-button">{{ $t('reviewInformation.readOnly') }}</p>
  </v-col>
  <v-col cols= "11" class="pl-6 d-flex flex-column justify-space-between" v-if="secondaryApplicantsData.readOnlyIdentityDetails">
    <p class="account-ownership"> <BaseIcon name="info_filled" size="xs" iconClass="vertical-alignment" :color="customCSS['primary']"/> Manual upload </p>
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column pt-1">
      <v-col sm="6" md="6" lg="6" class="d-flex flex-column">
        <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ secondaryApplicantsImage.documentName }} <br>
          <span
          class="d-flex identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }"
          >{{secondaryApplicantsImage.size}}<v-icon>mdi-circle-small</v-icon>
          <span style="color: rgba(0, 135, 68, 1);">
            <BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/>
            {{ $t('reviewInformation.attachedDocument') }}
          </span>
          </span>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" iconClass="vertical-alignment" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ secondaryApplicantsPictures[0].documentName }} <br><span class="d-flex identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }">{{secondaryApplicantsPictures[0].size}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
        </p>
      </v-col>
    </v-row>
      </v-col>
      <v-col sm="6" md="6" lg="6" class="d-flex flex-column">
        <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" iconClass="vertical-alignment" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ secondaryApplicantsPictures[1].documentName }} <br><span class="identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }">{{secondaryApplicantsPictures[1].size}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
        </p>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="1">
        <BaseIcon name="attach_file" size="xs" color="#000000;"/>
      </v-col>
      <v-col cols="11">
        <p class="file-name" style="word-wrap: break-word;">
          {{ secondaryApplicantsPictures[2].documentName }} <br><span class="identityDocuments-content"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          }">{{secondaryApplicantsPictures[2].size}} <v-icon>mdi-circle-small</v-icon><span style="color: rgba(0, 135, 68, 1);"><BaseIcon name="check_circle_filled" size="xs" :color="customCSS['success']" iconClass="vertical-alignment pr-2"/> {{ $t('reviewInformation.attachedDocument') }} </span></span>
        </p>
      </v-col>
    </v-row>
      </v-col>
    </v-row>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Identity Document Section End. -->
<!-- Relationship Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
:class="language ? '' : ''">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.expandRelationshipDetailsSection = !secondaryApplicantsData.expandRelationshipDetailsSection"><div v-if="secondaryApplicantsData.expandRelationshipDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.relationshipSectionTitle')}}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryApplicantsData.expandRelationshipDetailsSection = true,showUnsavedSnackbar('readOnlyRelationshipTypeDetails', false, 'secondary')" v-if="secondaryApplicantsData.readOnlyRelationshipTypeDetails"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!secondaryApplicantsData.readOnlyRelationshipTypeDetails">
      <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryFormData.relationshipType = secondaryApplicantsData.relationshipType,showUnsavedSnackbar('readOnlyRelationshipTypeDetails', true, 'secondary')">{{ $t('reviewInformation.cancel') }}</v-btn>
      <v-btn small rounded outlined class="disabled-button text-none" :color="customCSS['secondary']" @click="updateChangesWithPrimaryDetails('relationshipTypeInformation','readOnlyRelationshipTypeDetails')" :disabled="enableSaveButton('relationshipTypeDetails')">{{ $t('reviewInformation.save') }}</v-btn>
    </div>
  </v-col>
  <v-col v-if="secondaryApplicantsData.expandRelationshipDetailsSection">
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="secondaryApplicantsData.relationshipTypeDescription && secondaryApplicantsData.readOnlyRelationshipTypeDetails">
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
    <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="secondaryApplicantsData.relationshipTypeDescription !== '' && secondaryApplicantsData.relationshipTypeDescription !== null && secondaryApplicantsData.relationshipTypeDescription !== undefined">
          <p class="overline-styles">{{ $t('reviewInformation.readOnlyRelationshipType') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData.relationshipTypeDescription }}</p>
        </div>
      </div>
    </v-col>
    </v-row>
  </v-col>
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="!secondaryApplicantsData.readOnlyRelationshipTypeDetails">
    <v-col class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:21px;">
      <v-col sm="12" md="6" lg="6" class="flex-alignment">
        <div v-for="(components, index) in reviewInformation.relationshipDetails" :key="index">
          <div v-if="components.enableComponent && components.key === 'relationshipType' && ['termDeposit', 'savings'].includes(getProductType)">
            <component
            validate-on-blur
            :is="componentType[components.type].component"
            :label="$t(`reviewInformation.${components.key}`)"
            :hint="components.hint"
            :rules="components?.required ? requiredRules : []"
            :persistent-hint="components.persistent"
            :filled="components.filled"
            :key="'secondary-' + components.key"
            :items="components.key === 'relationshipType' ? relationshipTypeDropDown : ''"
            item-text="relationshipTypeDescription"
            item-value="relationshipType"
            :[components.iconPlacement]="components.icon"
            :true-value="components.trueValue"
            :false-value="components.falseValue"
            v-model="secondaryFormData[components.key]"
            :class="components.class"
            :hide-details="components.hideDetails? components.hideDetails : false"
            :defalut="components.default"
            :disabled="components.disabled"
            @change="handleChange($event, components.key, 'relationshipTypeDetails')">
            </component>
          </div>
        </div>
      </v-col>
    </v-col>
  </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Relationship Details Section End. -->
<!-- Employment Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyEmploymentDetails.enableComponent">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.expandEmploymentDetailsSection = !secondaryApplicantsData.expandEmploymentDetailsSection"><div v-if="secondaryApplicantsData.expandEmploymentDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/></div><div v-else><BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/></div></v-btn>{{ $t('reviewInformation.currentEmploymentDetails') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryApplicantsData.expandEmploymentDetailsSection = true,showUnsavedSnackbar('readOnlyEmploymentDetails', false, 'secondary')" v-if="reviewInformation.employmentEditDetails.enableComponent && secondaryApplicantsData.readOnlyEmploymentDetails"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!secondaryApplicantsData.readOnlyEmploymentDetails">
      <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="employmentInformationData(1), showUnsavedSnackbar('readOnlyEmploymentDetails', true, 'secondary')">{{ $t('reviewInformation.cancel') }}</v-btn>
      <v-btn small rounded outlined class="disabled-button text-none" :color="customCSS['secondary']" @click="updateChangesWithPrimaryDetails('employmentInformation','readOnlyEmploymentDetails')" :disabled="enableSaveButton('employmentDetails')">{{ $t('reviewInformation.save') }}</v-btn>
    </div>
  </v-col>
  <v-col v-if="secondaryApplicantsData.expandEmploymentDetailsSection">
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.readOnlyEmploymentDetails.enableComponent && secondaryApplicantsData.readOnlyEmploymentDetails">
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
    <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="this.secondaryFormData?.employmentStatus !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.reviewEmploymentStatus') }}</p>
          <p class="text-styles">{{ this.secondaryFormData.employmentStatusDescription }}</p>
        </div>
        <div class="header-spacing" v-if="this.secondaryFormData?.nameOfTheEmployer != ''">
          <p class="overline-styles">{{ $t('reviewInformation.reviewNameOfTheEmployer') }}</p>
          <p class="text-styles">{{ this.secondaryFormData.nameOfTheEmployer }}</p>
        </div>
        <div class="header-spacing" v-if="this.secondaryFormData?.employmentType !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.reviewEmploymentType') }}</p>
          <p class="text-styles">{{ this.secondaryFormData.employmentTypeDescription }}</p>
        </div>
        <div class="header-spacing" v-if="this.secondaryFormData?.businessType !== ''">
          <p class="overline-styles">{{ $t('reviewInformation.reviewBusinessType') }}</p>
          <p class="text-styles">{{ this.secondaryFormData.businessTypeDescription }}</p>
        </div>
      </div>
    </v-col>
    <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
      <div class="header-spacing" v-if="this.secondaryFormData?.jobTitle !== ''">
        <p class="overline-styles">{{ $t('reviewInformation.reviewJobTitle') }}</p>
        <p class="text-styles">{{ this.secondaryFormData.jobTitleDescription }}</p>
      </div>
      <div class="header-spacing" v-if="this.secondaryFormData?.paymentMethod !== ''">
        <p class="overline-styles">{{ $t('reviewInformation.reviewPaymentMethod') }}</p>
        <p class="text-styles">{{ this.secondaryFormData.paymentMethodDescription }}</p>
      </div>
      <div class="header-spacing" v-if="this.secondaryFormData?.paymentFrequency !== ''">
        <p class="overline-styles">{{ $t('reviewInformation.reviewPaymentFrequency') }}</p>
        <p class="text-styles">{{ this.secondaryFormData.paymentFrequencyDescription }}</p>
      </div>
      </div>
    </v-col>
    </v-row>
  </v-col>
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.employmentEditDetails.enableComponent && !secondaryApplicantsData.readOnlyEmploymentDetails">
    <v-col class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:21px;">
      <v-col sm="12" md="6" lg="6" class="flex-alignment">
        <div v-for="(components, index) in reviewInformation.employmentDetails" :key="index">
          <div v-if="index <=3">
            <div v-if="components.enableComponent && components.key === 'employmentStatus' && components.enabledProducts.includes(getProductType)">
              <component
              v-if="components.enableComponent && components.key === 'employmentStatus'"
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? requiredRules : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'employmentStatus' ? employmentDetails.employmentStatusList : ''"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              v-model="secondaryFormData[components.key]"
              @change="handleChange($event, components.key, 'employmentDetails')">
              </component>
            </div>
            <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && $appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(secondaryApplicantsData.updatedEmploymentStatus) && components.key !== 'employmentStatus'">
              <component
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? components.key === 'nameOfTheEmployer' ? [requiredRules, employerNameRule].flat() : requiredRules : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'employmentType' ? employmentDetails.employmentTypeList : components.key === 'businessType' ? employmentDetails.businessTypeList : components.key === 'jobTitle' ? employmentDetails.jobTitleList : components.key === 'paymentMethod' ? employmentDetails.paymentMethodList : components.key === 'paymentFrequency' ? employmentDetails.paymentFrequencyList : ''"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              :style="!$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(secondaryApplicantsData.updatedEmploymentStatus) ? 'display: none;' : ''"
              v-model="secondaryFormData[components.key]"
              v-bind:value="secondaryFormData[components.key]"
              @change="handleChange($event, components.key, 'employmentDetails')">
              </component>
            </div>
          </div>
        </div>
      </v-col>
      <v-col sm="12" md="6" lg="6">
        <div v-for="(components, index) in reviewInformation.employmentDetails" :key="index">
          <div v-if="index >3">
            <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType) && $appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(secondaryApplicantsData.updatedEmploymentStatus) && components.key !== 'employmentStatus'">
              <component
              validate-on-blur
              :is="componentType[components.type].component"
              :label="$t(`reviewInformation.${components.key}`)"
              :hint="components.hint"
              :rules="components?.required ? components.key === 'nameOfTheEmployer' ? [requiredRules, employerNameRule].flat() : requiredRules : []"
              :persistent-hint="components.persistent"
              :filled="components.filled"
              :key="'secondary-' + components.key"
              :items="components.key === 'employmentType' ? employmentDetails.employmentTypeList : components.key === 'businessType' ? employmentDetails.businessTypeList : components.key === 'jobTitle' ? employmentDetails.jobTitleList : components.key === 'paymentMethod' ? employmentDetails.paymentMethodList : components.key === 'paymentFrequency' ? employmentDetails.paymentFrequencyList : ''"
              :item-text="components.displayText ? components.displayText : codeDescription"
              :item-value="components.displayValue ? components.displayValue : codeReference"
              :[components.iconPlacement]="components.icon"
              :true-value="components.trueValue"
              :false-value="components.falseValue"
              v-model="secondaryFormData[components.key]"
              v-bind:value="secondaryFormData[components.key]"
              :class="components.class"
              :hide-details="components.hideDetails? components.hideDetails : false"
              :defalut="components.default"
              :disabled="components.disabled"
              :style="!$appSettings.dcoConfigurations.allowedEmploymentStatusReference.includes(secondaryApplicantsData.updatedEmploymentStatus) ? 'display: none;' : ''"
              @change="handleChange($event, components.key, 'employmentDetails')">
              </component>
            </div>
          </div>
        </div>
      </v-col>
    </v-col>
  </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Employment Details Section End. -->
<!-- Compliance Details Section Start. -->
<v-row class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column"
:class="language ? '' : ''" :style="(secondaryApplicantsData?.expectedTurnover === '' || secondaryApplicantsData?.expectedTurnover === null || secondaryApplicantsData?.expectedTurnOver === undefined) &&
(secondaryApplicantsData?.sourceOfFunds === '' || secondaryApplicantsData?.sourceOfFunds === null || secondaryApplicantsData?.sourceOfFunds === undefined) && (secondaryApplicantsData?.jobReadOnly === '' || secondaryApplicantsData?.jobReadOnly === null || secondaryApplicantsData?.jobReadOnly === undefined) &&
(secondaryApplicantsData?.udfBusinessTypeReadOnly === '' || secondaryApplicantsData?.udfBusinessTypeReadOnly === null || secondaryApplicantsData?.udfBusinessTypeReadOnly === undefined) ? ' display: none !important;' : ''"
 v-if="reviewInformation.reviewComplianceDetails.enableComponent === true">
  <v-col cols= "11" class="pl-0 d-flex justify-space-between">
    <h6
    class="reviewInformation-subSectionTitle mb-0"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily']
    }"
    >
      <v-btn icon text rounded elevation="0" small @click="secondaryApplicantsData.expandComplianceDetailsSection = !secondaryApplicantsData.expandComplianceDetailsSection">
        <div v-if="secondaryApplicantsData.expandComplianceDetailsSection"><BaseIcon name="keyboard_arrow_down" size="xs" :color="customCSS['grey']"/>
        </div>
        <div v-else>
          <BaseIcon name="chevron_right" size="xs" :color="customCSS['grey']"/>
        </div>
      </v-btn>
      {{ $t('reviewInformation.complianceDetails') }}
    </h6>
    <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="secondaryApplicantsData.expandComplianceDetailsSection = true,showUnsavedSnackbar('readOnlyComplianceDetails', false, 'secondary')" v-if="reviewInformation.complianceEditDetails.enableComponent && secondaryApplicantsData.readOnlyComplianceDetails"><BaseIcon name="edit" size="xs" :color="customCSS['secondary']"/>{{ $t('reviewInformation.edit') }}</v-btn>
    <div v-if="!secondaryApplicantsData.readOnlyComplianceDetails">
      <v-btn small rounded text class="disabled-button text-none" :color="customCSS['secondary']" @click="udfInformationData(1), showUnsavedSnackbar('readOnlyComplianceDetails', true, 'secondary')">{{ $t('reviewInformation.cancel') }}</v-btn>
      <v-btn small rounded outlined class="disabled-button text-none" :color="customCSS['secondary']" @click="updateChangesWithPrimaryDetails('complianceInformation','readOnlyComplianceDetails')" :disabled="enableSaveButton('complianceDetails')">{{ $t('reviewInformation.save') }}</v-btn>
    </div>
  </v-col>
  <v-col v-if="secondaryApplicantsData.expandComplianceDetailsSection">
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.reviewComplianceDetails.enableComponent && secondaryApplicantsData.readOnlyComplianceDetails">
    <v-row class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column">
    <v-col sm="12" md="6" lg="6" :class="language === '' ? 'pl-7' : 'pr-7'">
      <div class="text-spacing">
        <div class="header-spacing" v-if="secondaryApplicantsData.expectedTurnover !== '' && secondaryApplicantsData.expectedTurnover !== null && secondaryApplicantsData.expectedTurnover !== undefined">
          <p class="overline-styles">{{ $t('reviewInformation.reviewExpectedTurnOver') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData.expectedTurnover }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData.sourceOfFunds != '' && secondaryApplicantsData.sourceOfFunds !== null && secondaryApplicantsData.sourceOfFunds !== undefined">
          <p class="overline-styles">{{ $t('reviewInformation.reviewSourceOfFunds') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData.sourceOfFunds }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData.jobReadOnly != '' && secondaryApplicantsData.jobReadOnly !== null && secondaryApplicantsData.jobReadOnly !== undefined">
          <p class="overline-styles">{{ $t('reviewInformation.reviewJobDescription') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData.jobReadOnly }}</p>
        </div>
        <div class="header-spacing" v-if="secondaryApplicantsData.udfBusinessTypeReadOnly != '' && secondaryApplicantsData.udfBusinessTypeReadOnly !== null && secondaryApplicantsData.udfBusinessTypeReadOnly !== undefined">
          <p class="overline-styles">{{ $t('reviewInformation.reviewUdfBusinessTypeDescription') }}</p>
          <p class="text-styles">{{ secondaryApplicantsData.udfBusinessTypeReadOnly }}</p>
        </div>
      </div>
    </v-col>
    </v-row>
  </v-col>
  <v-col cols= "11" class="pb-0 pt-0 ml-0 d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column" v-if="reviewInformation.complianceEditDetails.enableComponent && !secondaryApplicantsData.readOnlyComplianceDetails">
    <v-col class="d-flex d-md-flex d-sm-flex flex-column flex-md-row flex-sm-column justify-space-between" style="column-gap:21px;">
      <v-col sm="12" md="6" lg="6" class="flex-alignment">
        <div v-for="(components, index) in reviewInformation.complianceDetails" :key="index">
          <div v-if="components.enableComponent && components.enabledProducts.includes(getProductType)">
            <component
            validate-on-blur
            :is="componentType[components.type].component"
            :label="$t(`reviewInformation.${components.key}`)"
            :hint="components.hint"
            :rules="components?.required === true ? components.key === 'expectedTurnover' ? [requiredRules, complianceRules].flat() : requiredRules : components.key === 'expectedTurnover' ? secondaryFormData[components.key] !== '' && secondaryFormData[components.key] !== null ? [complianceRules].flat() : [] : []"
            :persistent-hint="components.persistent"
            :filled="components.filled"
            :key="'secondary-' + components.key"
            :items="components.key === 'sourceCountryOfFunds' ? sourceCountryOfFunds : components.key === 'job' ? jobDropDown : components.key === 'udfBusinessType' ? udfBusinessTypeDropdown : ''"
            :item-text="components.displayText ? components.displayText : codeDescription"
            :item-value="components.displayValue ? components.displayValue : codeReference"
            :[components.iconPlacement]="components.icon"
            :true-value="components.trueValue"
            :false-value="components.falseValue"
            v-model="secondaryFormData[components.key]"
            v-bind:value="secondaryFormData[components.key]"
            :class="components.class"
            :hide-details="components.hideDetails? components.hideDetails : false"
            :defalut="components.default"
            :disabled="components.disabled"
            @change="handleChange($event, components.key, 'complianceDetails')">
            </component>
          </div>
        </div>
      </v-col>
    </v-col>
  </v-col>
  </v-col>
  <v-col cols="11" class="pt-6">
    <v-divider></v-divider>
  </v-col>
</v-row>
<!-- Compliance Details Section End. -->
</div>
<!-- Read Only Text Preferences and consent section Start. -->
<v-col cols="11" class="pt-16 mt-16">
  <v-row class="d-flex d-md-flex flex-column flex-md-row flex-wrap" style="gap:16px">
    <v-col md="12" class="pl-3">
      <h5
      class="reviewInformation-editSectionTitle mb-4"
      :style="{
        'font-family': customCSS && customCSS['formTitle-fontFamily'],
        color: customCSS['onboarding-sectionContentColor'],
      }"
      v-if="reviewInformation.pushNotification.enableComponent === true || reviewInformation.smsNotification.enableComponent === true || reviewInformation.marketingNotification.enableComponent === true">{{$t(`reviewInformation.preferences`)}}</h5>
      <v-switch v-if="reviewInformation.pushNotification.enableComponent === true"
      :label="$t(`reviewInformation.pushNotifications`)"
      :true-value="true"
      :false-value="false"
      v-model="activatePushNotificationsFlag"
      :color="customCSS['primary']"
      hint="No Costs associated with the service regardless of the traded amounts"
      persistent-hint
      >
      </v-switch>
      <v-switch v-if="reviewInformation.smsNotification.enableComponent === true"
      :label="$t(`reviewInformation.smsNotifications`)"
      :true-value="true"
      :false-value="false"
      v-model="activateSMSNotificationsFlag"
      :color="customCSS['primary']"
      hint="£ 2/month for all transactions grater than £10"
      persistent-hint
      >
      </v-switch>
      <v-switch v-if="reviewInformation.marketingNotification.enableComponent === true"
      :label="$t(`reviewInformation.marketingNotification`)"
      :true-value="true"
      :false-value="false"
      v-model="activateMarketingCommunicationsFlag"
      :color="customCSS['primary']"
      style="background: white !important;"
      >
      </v-switch>
      <v-col cols="8" offset="2" :class="language !== '' ? 'arabic-alignment' : ''">
        <div v-if="activateMarketingCommunicationsFlag" style=" display: flex;gap: 8px;">
          <v-btn
          v-if="reviewInformation.marketingSMSNotification.enableComponent === true"
          rounded
          outlined
          small
          class="text-none"
          :color="activateSMSNotificationsFlag ? customCSS['toggleBtn-primaryColor'] : ''"
          :style="{
            'font-family': customCSS['onboardingBtn-fontFamily'],
            backgroundColor : activateSMSNotificationsFlag ? customCSS['toggleBtn-customColor'] : '',
            color: activateSMSNotificationsFlag ? customCSS['toggleBtn-primaryColor'] : ''
          }"
          :value="activateSMSNotificationsFlag"
          @click="activateSMSNotificationsFlag = !activateSMSNotificationsFlag"
          >
          <BaseIcon name="check" size="xs" :color="customCSS['toggleBtn-primaryColor']" v-if="activateSMSNotificationsFlag"/>
          {{$t(`reviewInformation.sms`)}}
          </v-btn>
          <v-btn v-if="reviewInformation.marketingEmailNotification.enableComponent === true" rounded outlined small class="text-none" :color="activateEmailNotificationsFlag ? customCSS['toggleBtn-primaryColor'] : ''"
          :style="{
            'font-family': customCSS['onboardingBtn-fontFamily'],
            backgroundColor : activateEmailNotificationsFlag ? customCSS['toggleBtn-customColor'] : '',
            color: activateEmailNotificationsFlag ? customCSS['toggleBtn-primaryColor'] : ''
          }"
          :value="activateEmailNotificationsFlag"
          @click="activateEmailNotificationsFlag = !activateEmailNotificationsFlag"
          >
            <BaseIcon name="check" size="xs" :color="customCSS['toggleBtn-primaryColor']" v-if="activateEmailNotificationsFlag"/>
            {{$t(`reviewInformation.emailToggle`)}}
          </v-btn>
          <v-btn v-if="reviewInformation.marketingPostNotification.enableComponent === true" rounded outlined small class="text-none" :color="activatePostNotificationsFlag ? customCSS['toggleBtn-primaryColor'] : ''"
          :style="{
            'font-family': customCSS['onboardingBtn-fontFamily'],
            backgroundColor : activatePostNotificationsFlag ? customCSS['toggleBtn-customColor'] : '',
            color: activatePostNotificationsFlag ? customCSS['toggleBtn-primaryColor'] : ''
            }"
            :value="activatePostNotificationsFlag"
            @click="activatePostNotificationsFlag = !activatePostNotificationsFlag"
            >
            <BaseIcon name="check" size="xs" :color="customCSS['toggleBtn-primaryColor']" v-if="activatePostNotificationsFlag"/>
            {{$t(`reviewInformation.postToggle`)}}
            </v-btn>
        </div>
      </v-col>
    </v-col>
    <v-col md="12" v-if="reviewInformation.kycInformation.enableComponent === true" class="pl-3">
      <v-alert
      text
      outlined
      icon="mdi-information-outline"
      :color="customCSS['primary']"
      style="border-radius: 20px"
      >
      <p>
        <span
        class="kyc-title"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionContentColor']
        }"
        >{{$t(`reviewInformation.kyc`)}}
        </span>
        <br />
        <span
        class="kyc-description"
        :style="{
          'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
          color: customCSS['onboarding-sectionHelperTextColor']
        }"
        >{{$t(`reviewInformation.kycDescription`)}}
        </span>
      </p>
    </v-alert>
    </v-col>
    <v-col md="12" style="display:flex; flex-direction:column; gap:16px;" v-if="reviewInformation.termsAndConditions.enableComponent === true" class="pl-3">
    <h5
    class="reviewInformation-editSectionTitle"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily'],
      color: customCSS['onboarding-sectionContentColor'],
    }"
    >{{$t(`reviewInformation.important`)}}
    </h5>
    <p
    class="consent-title"
    :style="{
      'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
      color: customCSS['onboarding-sectionContentColor']
    }"
    >
    {{$t(`reviewInformation.termsAndConditionsHelper`)}}
    </p>
    <div>
      <p class="d-flex flex-row justify-space-between terms-and-conditions mb-2">{{$t(`reviewInformation.onboardingTermsAndConditionsTitle`)}}
        <v-btn
        text
        rounded
        :color="onBoardingConsentsAccepted ? customCSS['success'] : customCSS['primary']"
        class="text-none"
        :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
        @click="enableConsentDailog('PARTY')"
        >
        <BaseIcon name="check" size="xs" :color="customCSS['success']" v-if="onBoardingConsentsAccepted"/>
        {{ onBoardingConsentsAccepted ? $t(`reviewInformation.accepted`) : $t(`reviewInformation.viewMore`) }}
        <BaseIcon name="chevron_right" size="xs" :color="onBoardingConsentsAccepted ? customCSS['success'] : customCSS['primary']"/>
        </v-btn>
      </p>
      <p class="terms-and-conditions-helper"> {{$t(`reviewInformation.onboardingTermsAndConditionsHelper`)}} </p>
    </div>
    <div v-if="$appSettings.dcoConfigurations.isAccountOpeningConsentsEnabled && $appSettings.dcoConfigurations.accountOpeningConsentsEnabledProducts.includes(productType)">
      <p class="d-flex flex-row justify-space-between terms-and-conditions mb-2">{{$t(`reviewInformation.accountTermsAndConditionsTitle`)}}
        <v-btn
        text
        rounded
        :color="accountOpeningConsentAccepted ? customCSS['success'] : customCSS['primary']"
        class="text-none"
        :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
        @click="enableConsentDailog('ACCOUNT')"
        >
        <BaseIcon name="check" size="xs" :color="customCSS['success']" v-if="accountOpeningConsentAccepted"/>
        {{ accountOpeningConsentAccepted ? $t(`reviewInformation.accepted`) : $t(`reviewInformation.viewMore`) }}
        <BaseIcon name="chevron_right" size="xs" :color="accountOpeningConsentAccepted ? customCSS['success'] : customCSS['primary']"/>
        </v-btn>
      </p>
      <p class="terms-and-conditions-helper"> {{$t(`reviewInformation.accountTermsAndConditionsHelper`)}} </p>
    </div>
    <h5
    class="reviewInformation-editSectionTitle mb-4"
    :style="{
      'font-family': customCSS && customCSS['formTitle-fontFamily'],
      color: customCSS['onboarding-sectionContentColor'],
    }"
    >
    {{$t(`reviewInformation.consent`)}} <br />
    </h5>
    <v-checkbox
    :label="$t(`reviewInformation.consentHelper`)"
    :true-value="true"
    :false-value="false"
    v-model="consentAcceptedFlag"
    :color="customCSS['primary']"
    style="background: white !important;"
    >
    </v-checkbox>
    </v-col>
  </v-row>
  <v-flex class="final-button">
    <v-btn
    medium
    rounded
    :color="customCSS['primary']"
    class="text-none white--text"
    :disabled="enableConfirmDetailsButton()"
    @click="productType !== 'lifetimeISA' ? image !== undefined ? finalSubmit() : identityVerificationQuery = true : lisaValidationChecks()"
    >
    <span :style="customCSS['white']">
      {{$t(`reviewInformation.confirmDetailBtn`)}}
    </span>
    </v-btn>
    <v-btn
    medium
    rounded
    outlined
    :color="customCSS['primary']"
    :class="language !== '' ? 'text-none review-exitButtonRtl' : 'text-none review-exitButton'"
    :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
    @click="reviewExitButton = true"
    >
    {{$t(`reviewInformation.exitBtn`)}}
    </v-btn>
  </v-flex>
</v-col>
<!-- Read Only Text Preferences and consent section Start. -->
  <!-- Terms and Conditions Start Pop up -->
  <v-dialog persistent v-model="toggleEnabled" width="100vh" content-class="consent-dialog">
    <div>
      <v-card class="consent-details-card pa-3 pa-md-8 pa-sm-3 mx-lg-auto" align-center justify-center elevation="0">
        <div class="d-flex flex-row justify-space-between">
          <p class="lisa-card-title word-wrap"><v-btn text @click="scrollBack(specificConsentIndex, currentEntityType)" ><BaseIcon name="chevron_left" size="xs" /></v-btn>
          {{consentCodeDescription}}
          </p>
        </div>
        <p class="title-class word-wrap">{{$t(`reviewInformation.importantDialog`)}}</p>
        <p class="terms-and-conditions-helper word-wrap"> {{currentEntityType === 'PARTY' ? $t(`reviewInformation.onboardingTermsHelper`) : $t(`reviewInformation.accountOpeningTermsHelper`)}}</p>
        <v-card class="consent-document-card" outlined shaped tile elevation="0">
          <v-card-text class="consent-popup" ref="scrollBox" @scroll="handleScroll(specificConsentIndex, currentEntityType)">
            <vue-pdf-embed :source="consentDocuments"/>
          </v-card-text>
        </v-card>
        <v-card consent-actions-card class="pt-3 pb-1" elevation="0">
          <v-card-actions>
            <v-btn
            rounded
            text
            :color="customCSS['secondary']"
            class="text-none"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
            @click="downloadPdf(consentDocuments, currentEntityType)"
            ><BaseIcon name="download" size="xs" :color="customCSS['secondary']" />
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!(currentEntityType === 'PARTY' && consentAccepted[specificConsentIndex] === true) && !(currentEntityType === 'ACCOUNT' && accountConsentAccepted[specificConsentIndex] === true)"
              rounded
              outlined
              :color="customCSS['primary']"
              :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              @click="scrollBack(specificConsentIndex, currentEntityType)">
              {{$t(`reviewInformation.cancel`) }}
            </v-btn>
            <v-btn
            rounded
            :disabled="$appSettings && $appSettings.dcoConfigurations.isForceReadEnabled ? (currentEntityType === 'PARTY' && partyDocumentRead[specificConsentIndex] === true) || (currentEntityType === 'ACCOUNT' && accountDocumentRead[specificConsentIndex] === true) ? false : true : false"
            @click="handleClick(specificConsentIndex, currentEntityType)"
            :color="currentEntityType === 'PARTY' && consentAccepted[specificConsentIndex] === true ? customCSS['success'] : currentEntityType === 'ACCOUNT' && accountConsentAccepted[specificConsentIndex] === true ? customCSS['success'] : customCSS['primary']"
            :text="currentEntityType === 'PARTY' && consentAccepted[specificConsentIndex] === true ? true : currentEntityType === 'ACCOUNT' && accountConsentAccepted[specificConsentIndex] === true ? true : false"
            :class="{'active': (currentEntityType === 'PARTY' && consentAccepted[specificConsentIndex] === true) || (currentEntityType === 'ACCOUNT' && accountConsentAccepted[specificConsentIndex] === true)}"
            class="toggle-button text-none"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
            >
            <BaseIcon name="check" size="xs" :color="customCSS['success']" v-if="(currentEntityType === 'PARTY' && consentAccepted[specificConsentIndex] === true) || (currentEntityType === 'ACCOUNT' && accountConsentAccepted[specificConsentIndex] === true)"/>
              <span v-if="(currentEntityType === 'PARTY' && consentAccepted[specificConsentIndex] === true) || (currentEntityType === 'ACCOUNT' && accountConsentAccepted[specificConsentIndex] === true)">
                {{$t(`reviewInformation.accepted`)}}
              </span>
              <span v-else :style="{ color: customCSS['white']}">
                {{$t(`reviewInformation.agree`) }}
              </span>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-card>
    </div>
  </v-dialog>
  <v-dialog persistent v-model="tandC" width="100vh" height="100%" content-class="tandc-dialog">
    <div>
      <v-card class="pa-md-8 mx-lg-auto" align-center justify-center>
        <p class="d-flex flex-row justify-space-between lisa-card-title word-wrap ml-3">
          {{ onboardingTandC ? $t(`reviewInformation.onboardingTandCTitle`) : $t(`reviewInformation.accountTandCTitle`) }}
          <v-btn color="black" rounded text class="text-none" :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="onboardingTandC ? closepopUP('PARTY') : closepopUP('ACCOUNT')">
            <BaseIcon name="close" size="xs" />
          </v-btn>
        </p>
        <div class="ml-4">
          <p class="title-class word-wrap">{{$t(`reviewInformation.importantDialog`)}}</p>
          <p class="terms-and-conditions-helper word-wrap"> {{currentEntityType === 'PARTY' ? $t(`reviewInformation.onboardingTermsHelper`) : $t(`reviewInformation.accountOpeningTermsHelper`)}}</p>
        </div>
        <v-card  flat class="pa-4 mx-lg-auto">
          <div
          v-if="onboardingTandC"
          class="card-text"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            color: customCSS['onboarding-sectionContentColor']
          }"
          >
          <div
          class="kyc-description"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            color: customCSS['onboarding-sectionContentColor']
          }"
          v-for="(data, index) in partyConsents" :key="index" style="direction: ltr !important;"
          >
          <v-divider v-if="index !== 0"></v-divider>
          <p class="d-flex flex-row justify-space-between mt-4 align-center word-wrap"> {{data.tcTypeDescription}}
            <v-btn
            rounded
            text
            @click="getActiveConsentInformation(data.tcTypeCode, index), consentCodeDescription = data.tcTypeDescription"
            :color="consentAccepted[index] === true ? customCSS['success'] : customCSS['primary']"
            :class="{'active': consentAccepted[index]}"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
            class="toggle-button text-none"
            >
            <BaseIcon name="check" size="xs" :color="consentAccepted[index] === true ? customCSS['success'] : customCSS['primary']" v-if="consentAccepted[index]  === true" />
            {{ consentAccepted[index] === true ? $t(`reviewInformation.accepted`) : $t(`reviewInformation.readBtn`) }}
            <BaseIcon name="chevron_right" size="xs" :color="consentAccepted[index] === true ? customCSS['success'] : customCSS['primary']" />
            </v-btn>
          </p>
          </div>
          </div>
          <div v-else-if="accountTandC"
          class="card-text"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            color: customCSS['onboarding-sectionContentColor']
          }"
          >
          <div
          class="kyc-description"
          :style="{
            'font-family': customCSS && customCSS['formSubtitle-fontFamily'],
            color: customCSS['onboarding-sectionContentColor']
          }"
          v-for="(data, index) in accountConsents" :key="index" style="direction: ltr !important;">
          <v-divider v-if="index !== 0"></v-divider>
          <p class="d-flex flex-row justify-space-between mt-4 align-center word-wrap">{{data.tcTypeDescription}}
            <v-btn
            rounded
            text
            @click="getActiveConsentInformation(data.tcTypeCode, index), consentCodeDescription = data.tcTypeDescription"
            :color="accountConsentAccepted[index] === true ? customCSS['success'] : customCSS['primary']"
            :class="{'active': accountConsentAccepted[index]}"
            class="toggle-button text-none"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
            >
            <BaseIcon name="check" size="xs" :color="accountConsentAccepted[index] ? customCSS['success'] : customCSS['primary']" v-if="accountConsentAccepted[index]" />
            {{ accountConsentAccepted[index] ? $t(`reviewInformation.accepted`) : $t(`reviewInformation.readBtn`) }}
            <BaseIcon name="chevron_right" size="xs" :color="accountConsentAccepted[index] === true ? customCSS['success'] : customCSS['primary']" />
            </v-btn>
          </p>
          </div>
          </div>
        </v-card>
      </v-card>
    </div>
  </v-dialog>
  <!-- Terms and Conditions End Pop up -->
  <!-- Exit Button pop up start -->
  <v-dialog v-model="reviewExitButton" width="550">
    <v-card class="pt-3 pb-5 d-flex flex-column flex-gap-3 justify-center align-center">
      <v-card-actions style="display: flex; justify-content: flex-end; align-self: flex-end">
        <v-spacer></v-spacer>
        <v-btn
        color="Balck"
        rounded
        text
        class="text-none"
        :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
        @click="reviewExitButton = false"
        >
        <BaseIcon name="close" size="xs" />
        </v-btn>
      </v-card-actions>
      <v-card-title class="text-h5 font-weight-bold">
        <p
        :style="{
          'font-family': customCSS && customCSS['popupTitle-fontFamily'],
          'word-break': 'normal'
        }"
        >{{ $t(`component.wizard.exitConfirmation`) }}
        </p>
      </v-card-title>
      <v-img height="250" src="@/assets/dco/Finastra_Exit_Logo.png"></v-img>
      <v-card-text>
        <p
        :style="{
          'font-family': customCSS && customCSS['popupSubtitle-fontFamily'],
          'word-break': 'break-word'
        }"
        >
        {{ $te(`component.wizard.helperText`) ? $t(`component.wizard.helperText`) : '' }} <br/>
        <span v-if="$appSettings?.dcoConfigurations?.displayApplicationNumber">
        {{ $te(`component.wizard.additionalHelperText`) ? $t(`component.wizard.additionalHelperText`) : '' }} <span class="font-weight-bold">{{applicationNumber}}</span>
        </span>
        </p>
      </v-card-text>
      <v-card-actions class="mt-2">
        <v-row>
          <v-col class="mobile-view">
            <v-btn
            :color="customCSS['primary']"
            rounded
            variant="tonal"
            class="mr-2 pr-5 pl-5 no-uppercase mb-2 white--text"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
            @click="lastSave()"
            >
            {{ $t(`component.wizard.exitPositiveFlow`) }}
            </v-btn>
            <v-btn
            rounded
            outlined
            :color="customCSS['primary']"
            variant="tonal"
            class="mr-2 pr-5 pl-5 no-uppercase mb-2 float-left"
            :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
            @click="finalDelete()"
            >
            {{ $t(`component.wizard.exitNegativeFlow`) }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <!-- Exit Button pop up end -->
  <!-- Pop up for Identification Enabled -->
  <v-dialog v-model="identityVerificationQuery" width="525">
    <v-card class="pt-3 pb-5 d-flex flex-column flex-gap-3 justify-center align-center">
      <v-card-actions style="display: flex; justify-content: flex-end; align-self: flex-end">
        <v-spacer></v-spacer>
        <v-btn
        color="black"
        rounded
        text
        class="text-none"
        :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
        @click="identityVerificationQuery = false"
        >
        <BaseIcon name="close" size="xs" />
        </v-btn>
      </v-card-actions>
      <p class="pt-4 pb-2 pl-6 pr-6 lisa-card-title"
      :style="{
        'font-family': customCSS && customCSS['popupTitle-fontFamily'],
        'word-break': 'break-word'
      }"
      >{{ $t(`reviewInformation.identityVerificationHeader`) }}
      </p>
      <v-img height="250" src="@/assets/dco/Finastra_Exit_Logo.png"></v-img>
      <v-card-text class="reviewInformation-editSectionTitle"
      :style="{
        'font-family': customCSS && customCSS['popupSubtitle-fontFamily'],
        color: customCSS && customCSS['onboarding-sectionHelperTextColor'],
        'word-break': 'break-word'
      }"
      >
      {{ $te(`reviewInformation.identityVerificationHelper`) ? $t(`reviewInformation.identityVerificationHelper`) : '' }} <br/>
      </v-card-text>
      <div class="card-actionBtn">
        <v-card-actions class="mt-2">
          <v-row>
            <v-col class="mobile-view">
              <v-spacer></v-spacer>
              <v-btn
              :color="customCSS['primary']"
              rounded
              variant="tonal"
              class="mr-2 pr-5 pl-5 no-uppercase mb-2 white--text"
              :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              @click="finalSubmit()"
              >
              {{ $t(`reviewInformation.yesBtn`) }}
              </v-btn>
              <v-btn
              rounded
              outlined
              :color="customCSS['primary']"
              variant="tonal"
              class="mr-2 pr-5 pl-5 no-uppercase mb-2 float-left"
              :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              @click="identityVerificationQuery = false"
              >
              {{ $t(`reviewInformation.noBtn`) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
  <!-- Pop up for Identification Enabled End -->
  <!-- Pop up for dedup check start -->
  <v-dialog v-model="dedupCheckFailed" width="500">
    <v-card outlined width="510px">
      <v-card class="ma-4" flat>
        <v-row>
          <v-col cols="10" style="padding-left: 25px; padding-bottom: 0px;" class="d-flex align-center">
            <p class="lisa-card-title text-none word-wrap">{{ $t('popUp.customerExists') }}</p>
          </v-col>
          <v-col cols="2" class="d-flex justify-end">
            <v-btn rounded text :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="dedupCheckFailed = false">  <BaseIcon name="close" size="xs" /> </v-btn>
          </v-col>
        </v-row>
        <v-card-text class="pa-4 pl-3 pt-2 card-content">
          <slot name="modalContent" />
          <span class="lisa-card-content word-wrap">{{ $t('popUp.contentHelper') }}<br/></span>
          <span class="lisa-card-content word-wrap">{{ $t('popUp.contentHelper1') }}</span>
          <p class="lisa-card-content word-wrap pt-4">{{ $t('popUp.contentHelper2') }}<span class="font-weight-bold"> {{$t(`onboardStatus.helplineNumber`)}}</span> {{$t(`onboardStatus.or`)}} <span class="font-weight-bold">{{$t(`onboardStatus.helplineEmail`)}}.</span></p>
        </v-card-text>
        <v-card-actions class="pa-2 pt-6 d-flex justify-end">
          <v-row class="d-flex justify-center">
            <v-col class="mobile-view-review">
              <v-btn
              rounded
              medium
              :color="customCSS['primary']"
              class="text-none white--text"
              :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              @click="logIn()"
              >
              {{ $t('popUp.logIn') }}
              </v-btn>
              <v-btn
              rounded
              medium
              outlined
              :color="customCSS['primary']"
              class="text-none float-left"
              :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}"
              @click="dedupCheckFailed = false"
              >
              {{ $t('popUp.retry') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
  <!-- Address Lookup Popup start -->
  <v-dialog v-model="addressLookup" width="auto" height="100%">
    <v-card outlined>
      <v-card class="ma-4 pa-4" flat>
        <div style="display: flex; flex-direction: column; gap: 20px;">
          <v-row>
            <v-col cols="10" class="d-flex align-center">
              <p class="lisa-card-title word-wrap text-none">{{ $t(`reviewInformation.addressSearch`)}}</p>
            </v-col>
            <v-col cols="2" class="d-flex justify-end">
              <v-btn rounded text :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="addressLookup = false, addressData = []"> <BaseIcon name="close" size="xs" /> </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-data-table
            :headers="headers"
            :items="addressData"
            item-key="addressText"
            :item-class="getRowClass"
            :options.sync="options"
            :server-items-length="totalLength"
            :items-per-page="Number(itemsPerPage)"
            @update:items-per-page="handlePagination($event, key = 'itemsPerPage')"
            @update:page="handlePagination($event)"
            :footer-props="{'items-per-page-options':sizeItems}"
            :loading="loading"
            loading-text="Loading items..."
            single-select
            @click:row="rowClick"
            :no-data-text="$t(`reviewInformation.noData`)"
            :mobile-breakpoint="0"
            :style="{
              '--table-row-highlightTextColor': customCSS['formContent-datatable-content-highlightRowTextColor'],
              '--table-row-highlightBackgroundColor': customCSS['formContent-datatable-content-highlightRowBackgroundColor']
            }"
            >
            </v-data-table>
          </v-row>
        </div>
        <v-card-actions class="pa-2 pt-6 d-flex justify-end mobile-view-buttons">
          <v-row class="d-flex justify-center">
            <v-col class="mobile-view-buttons">
              <v-btn rounded medium text :color="customCSS['primary']" class="text-none" :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="addressLookup = false, addressData = []">
                {{ $t('common.cancel') }}
              </v-btn>
              <v-btn rounded medium :color="customCSS['primary']" class="text-none white--text" :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" :disabled="!enableOkButton" @click="retriveAddressDetails()">
                {{ $t('reviewInformation.confirmSearch') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
  <!-- Address Lookup Popup end -->
  <!-- Account Information Modal (Joint Account) Start -->
  <v-dialog v-model="accountOwnershipModal" width="500">
    <v-card outlined width="510px">
      <v-card class="ma-4" flat>
        <v-row>
          <v-col cols="10" style="padding-left: 25px; padding-bottom: 0px;" class="d-flex align-center">
            <p class="lisa-card-title word-wrap text-none">{{ secondaryCustomerOnboard ?  $t('popUp.secondaryCustomerMustBeOnboarded') :  $t('popUp.secondaryCustomerMustBeDeleted')}}</p>
          </v-col>
          <v-col cols="2" class="d-flex justify-end">
            <v-btn rounded text :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="accountOwnershipModal = false">  <BaseIcon name="close" size="xs" /> </v-btn>
          </v-col>
        </v-row>
        <v-card-text class="pa-4 pl-3 pt-2 card-content">
          <slot name="modalContent" />
          <span class="lisa-card-content word-wrap">{{ secondaryCustomerOnboard ?  $t('popUp.secondaryCustomerMustBeOnboardedContent') : $t('popUp.secondaryCustomerMustBeDeletedContent') }}</span>
        </v-card-text>
        <v-card-actions class="pa-2 pt-6 d-flex justify-end">
          <v-row class="d-flex justify-center">
            <v-col class="mobile-view-review">
              <v-btn rounded medium :color="customCSS['primary']" class="text-none white--text" :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="secondaryCustomerOnboard ? redirectToEligibilityCheck() : deleteSecondaryApplicantData()">
                {{secondaryCustomerOnboard ?  $t('popUp.secondaryCustomerMustBeOnboardedBtn') : $t('popUp.secondaryCustomerMustBeDeletedBtn') }}
              </v-btn>
              <v-btn rounded text medium :color="customCSS['primary']" class="text-none float-left" :style="{'font-family': customCSS['onboardingBtn-fontFamily'],}" @click="accountOwnershipModal = false">
                {{ $t('popUp.cancel') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-card>
  </v-dialog>
  <!-- Account Information Modal (Joint Account) End -->
</v-container>
<!-- Onboard Status final screen. -->
<v-container class="review-screen overflow-hidden">
  <OnboardStatus />
</v-container>
<!-- Onboard Status final screen. -->
<Modal :config="modalConfig">
  <span slot="modalContent" class="card-content">{{ $t('common.idleTimeoutContent') }}</span>
</Modal>
</v-container>
</template>

<script>
import '@/styles/components/reviewInformation.scss';
import CommonService from '@/_core/service/commonService';
import routeMixin from '@/_core/mixins/routeMixin.js';
import appCommonMixin from '@/_core/mixins/appCommonMixin.js';
import rendererMixin from '@/_core/mixins/rendererMixin.js';
import toastMixin from '@/_core/mixins/toastMixin';
import appSettings from '@/plugins/appSettings';
import store from '@/store';
import urlObj from '@/../_config/_app/apiConfiguration.json';
import router from '@/router';
import '@/styles/components/page.scss';
import componentType from '@/components/common/map.json';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import { VTextField, VRadioGroup, VBtnToggle } from 'vuetify/lib';
import moment from 'moment';
import * as colors from '@/_core/util/themeUtility';
import reviewInformationDataMixin from '@/_core/mixins/reviewInformationDataMixin.js';
import BaseIcon from './BaseIcon.vue';
import OnboardStatus from '@/components/common/onboardStatus.vue';

export default {
  name: 'ReviewInformation',
  mixins: [routeMixin, appCommonMixin, rendererMixin, toastMixin, reviewInformationDataMixin],
  components: {
    router,
    VTextField,
    BaseIcon,
    OnboardStatus,
    Modal: () => import('@/components/Modal.vue'),
    toast: () => import('@/components/ErrorHandler/ErrorHandler.vue'),
    VuePdfEmbed,
  },
  mounted() {
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  created() {
    this.getJsonpData();
    const localeSelected = localStorage.getItem('localeSelected');

    this.language = localeSelected === 'ar' ? localeSelected : '';
    this.customCSS = colors.colors;
  },
  data() {
    return this.getInitialData();
  },
  beforeMount() {
    this.partyConsents.forEach((item, index) => this.$set(this.clicked, index, false));
  },
  computed: {
    label() {
      return this.readOnlyContactDetails && this.expandAddressSection && this.expandPersonalDetailsSection && this.expandTaxDetailsSection && this.expandAccountDetailsSection &&
      this.readOnlyIdentityDetails && this.expandEmploymentDetailsSection && this.expandAccountDetailsSection ? this.$t('reviewInformation.collapse') : this.$t('reviewInformation.expand');
    },
    secondaryLabel() {
      return this.secondaryApplicantsData.readOnlyContactDetails && this.secondaryApplicantsData.expandAddressSection && this.secondaryApplicantsData.expandPersonalDetailsSection && this.secondaryApplicantsData.expandTaxDetailsSection &&
        this.secondaryApplicantsData.expandAccountDetailsSection && this.secondaryApplicantsData.readOnlyIdentityDetails &&
        this.secondaryApplicantsData.expandEmploymentDetailsSection && this.secondaryApplicantsData.expandAccountDetailsSection ? this.$t('reviewInformation.collapse') : this.$t('reviewInformation.expand');
    },
  },
  methods: {
    getInitialData() {
      return {
        formData: {
          primaryAddress: {},
          correspondenceAddress: {},
          previousResidentialAddress: {},
        },
        secondaryFormData: {
          primaryAddress: {},
          correspondenceAddress: {},
          previousResidentialAddress: {},
        },
        VTextField,
        VRadioGroup,
        VBtnToggle,
        componentType,
        primary: null,
        reviewInformation: '',
        toggleEnabled: false,
        dataNotFound: false,
        dialog: false,
        isToggled: false,
        bankSite: this.$t('onboardStatus.urlOne'),
        bankSiteLink: this.$t('onboardStatus.urlTwo'),
        identityVerification: false,
        bankNameandBranchDisable: false,
        productData: {
          data: {
            productDescription: '',
            productName: '',
          },
          status: '',
        },
        modalConfig: {
          enabled: false,
          icon: 'mdi-timer',
          persistent: true,
          saveButton: 'OK',
          title: this.$t('common.idleTimeoutTitle'),
          width: 450,
        },
        blobData: '',
        reviewExitButton: false,
        mobileNumber: '',
        editCheck: false,
        primaryAddress: null,
        correspondingAddress: null,
        previousAddress: null,
        on: '',
        dateOfBirth: '',
        mobilenumber: '',
        emailId: '',
        ukResident: '',
        previousReview: '',
        correspondenceReview: '',
        sortCodeSearch: '',
        primaryReview: '',
        base64String: '',
        pdfsrc: '',
        selectedtToggleValue: false,
        taxValue: '',
        ibanValue: false,
        sortCode: '',
        selected: [],
        sortResults: '',
        prevAddressresponse: '',
        secondaryPrevAddressresponse: '',
        corrAddressresponse: '',
        secondaryCorrAddressresponse: '',
        reviewCorresponding: false,
        reviewCheckNationality: false,
        reviewMiddleName: '',
        reviewMiddleNameCheckbox: false,
        reviewAnotherNationality: false,
        reviewResponseCountry: '',
        bicCode: '',
        accountNumber: '',
        sortCodeFinal: '',
        finalBankName: '',
        finalCurrency: '',
        reviewBankName: '',
        reviewBranchName: '',
        ibanNumber: '',
        filename: 'Upload Statement Proof',
        fileSize: '',
        fileStatus: '',
        mainAddressresponse: '',
        secondaryMainAddressresponse: '',
        productBankName: '',
        productBranchName: '',
        productSortCode: '',
        productOnboardSearch: false,
        activateEmailNotificationsFlag: false,
        activateMarketingCommunicationsFlag: false,
        activatePushNotificationsFlag: false,
        activateSMSNotificationsFlag: true,
        activatePostNotificationsFlag: false,
        consentAcceptedFlag: false,
        finalScreenData: '',
        verifyAccount: '',
        index: -1,
        selectedFile: null,
        defaultButtonText: 'Upload Statement Proof',
        count: 0,
        saveExit: false,
        deleteExit: false,
        minValue: 8,
        maxValue: 10,
        rules: [
          (v) => (v.length >= 8) || 'Minimum length should be 8',
        ],
        personalRules: [
          (v) => new RegExp(this.reviewInformation.regxPattern[0].personalRegxPattern).test(v) || 'Invalid Input',
        ],
        secondaryPersonalRules: [
          (v) => new RegExp(this.reviewInformation.regxPattern[0].personalRegxPattern).test(v) || 'Invalid Input',
        ],
        taxRules: [
          (v) => (/^(?!BG)(?!GB)(?!NK)(?!KN)(?!TN)(?!NT)(?!ZZ)(?:[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z])\d{6}([A-D])$/.test(v)) || 'Invalid Format. Please ensure the value follows the correct format.',
        ],
        addressRules: [
          (v) => (/^[A-Za-z0-9\s]*$/.test(v)) || 'Invalid Input',
        ],
        requiredRules: [
          (v) => !!v || 'This field is Required',
        ],
        employerNameRule: [(v) => (/^[A-Za-z\s,.-]*$/.test(v)) || 'Invalid Input'],
        addressLookupRule: [(v) => (v?.length >= this.reviewInformation?.addressLookup[0]?.minLength) || this.reviewInformation?.addressLookup[0]?.errorMessage],
        addressLookupRegex: [
          (v) => (/^[a-zA-Z0-9,.*#"'&()/\s-]*$]*$/.test(v)) || 'Invalid Input',
        ],
        cityRules: [
          (v) => (/^[A-Za-z][A-Za-z\s,.]*$/.test(v)) || 'Invalid Input',
          (v) => (v?.length <= this.reviewInformation?.manualInputOfAddress[5]?.city[0]?.cityMaxLength) || this.reviewInformation?.manualInputOfAddress[5]?.city[0]?.cityMaxLengthErrorMessage,
        ],
        complianceRules: [
          (v) => {
            if (!v) return true;
            return (/^\d+(\.\d{1,2})?$/.test(v)) || 'Invalid Input';
          },
        ],
        purposeOfAccountRules: [
          (v) => (/^[a-zA-Z0-9,."'\s-]*$]*$/.test(v)) || 'Invalid Input',
        ],
        postCodeLengthRule: [(v) => (v?.length <= this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeMaxLength) || this.reviewInformation?.manualInputOfAddress[4]?.postCode[0]?.postCodeErrorMessage],
        customRules: {},
        fromDate: '',
        toDate: '',
        fromMenu: '',
        toMenu: '',
        secondaryFromDate: '',
        secondaryToDate: '',
        isAddressLookUpEnabled: 'false',
        manualInputCorresponding: false,
        reviewReadOnlyGender: '',
        response: {
          entityId: '',
        },
        isAddressLookupEnabled: 'false',
        residenceAddress: [
          {
            label: 'Yes',
            value: true,
          },
          {
            label: 'No',
            value: false,
          },
        ],
        prevManualAddress: false,
        consentDocuments: '',
        clicked: [],
        consents: '',
        communicationFlag: [
          {
            label: 'Residential Address',
            value: true,
          },
          {
            label: 'Correspondence Address',
            value: false,
          },
        ],
        isDefault: false,
        isDefaultManual: false,
        useForCommunication: '',
        fileComponent: true,
        language: '',
        entityId: '',
        productType: '',
        additionalNominatedData: false,
        validation: [true],
        formatFromDate: '',
        formatToDate: '',
        formatSecondaryFromDate: '',
        formatSecondatyToDate: '',
        usResident: '',
        taxResidentInOtherCountry: false,
        areYouUSResident: false,
        productsAllowedWithAccountDetails: false,
        apiProductType: '',
        productTypes: this.$appSettings.dcoConfigurations.productTypes,
        employmentDetails: {
          employmentStatusList: undefined,
          employmentTypeList: undefined,
          nameOfTheEmployer: '',
          businessTypeList: undefined,
          jobTitleList: undefined,
          paymentFrequencyList: undefined,
          paymentMethodList: undefined,
          employmentStatus: '',
          employmentType: '',
          businessType: '',
          jobTitle: '',
          paymentFrequency: '',
          paymentMethod: '',
        },
        updatedEmploymentStatus: '',
        image: '',
        identityData: [],
        pictures: [],
        accountCreateFailed: false,
        identityVerificationQuery: false,
        customCSS: {},
        document: '',
        partyCreationFailed: '',
        applicationNumber: '',
        isLisa: false,
        isLisaError: '',
        customerID: '',
        reviewNationalIdType: '',
        reviewNationalIdNumber: '',
        reviewCurrency: undefined,
        nationalIdentities: '',
        dedupCheckFailed: false,
        readOnlyIbanValue: false,
        lisaEligibilityPassed: false,
        readOnlyContactDetails: false,
        readOnlyAddressDetails: false,
        readOnlyPersonalDetails: false,
        readOnlyTaxDetails: false,
        readOnlyEmploymentDetails: false,
        readOnlyAccountDetails: false,
        readOnlyIdentityDetails: false,
        readOnlyComplianceDetails: false,
        readOnlyUdfProductDetails: false,
        expandAddressSection: true,
        expandPersonalDetailsSection: true,
        expandTaxDetailsSection: true,
        expandEmploymentDetailsSection: true,
        expandAccountDetailsSection: true,
        expandComplianceDetailsSection: true,
        expandUdfProductDetailsSection: true,
        contactDetails: '',
        sameAsResidential: false,
        personalReviewData: '',
        taxReviewData: '',
        accountInfoData: '',
        otherInformation: '',
        readOnlyFromDate: '',
        readOnlyToDate: '',
        enableAccountSave: false,
        enableAddressSave: false,
        enablePersonalSave: false,
        enableTaxSave: false,
        enableEmploymentSave: false,
        residentialAddress: '',
        correspondenceAddress: '',
        previousResidentialAddress: '',
        addressLookup: '',
        updatedPageSize: undefined,
        options: '',
        itemsPerPage: 5,
        sizeItems: [5, 10, 15, 20],
        pageSize: 1,
        totalLength: 1,
        addressData: [],
        headers: [
          {
            text: 'Address',
            align: 'start',
            value: 'addressText',
            sortable: true,
          },
        ],
        selectedRow: '',
        addressAddedManually: false,
        secondaryAddressAddedManually: false,
        enableOkButton: false,
        loading: false,
        tandC: false,
        onboardingTandC: false,
        accountTandC: false,
        partyConsents: [],
        accountConsents: [],
        consentCodeDescription: '',
        partyDocumentRead: [],
        accountDocumentRead: [],
        consentAccepted: [],
        accountConsentAccepted: [],
        specificConsentIndex: 0,
        onBoardingConsentsAccepted: false,
        accountOpeningConsentAccepted: false,
        currentEntityType: '',
        zoom: window.innerWidth < 600 ? 1.5 : 1.0,
        applicationDown: false,
        accountOwnershipModal: false,
        items: undefined,
        reviewNationality: undefined,
        reviewCountry: undefined,
        primaryStatesDropdown: undefined,
        corrStatesDropdown: undefined,
        prevStatesDropdown: undefined,
        corrCountry: undefined,
        previousCountry: undefined,
        taxExemptionDropDown: undefined,
        yearsDropdown: undefined,
        monthsDropdown: undefined,
        daysDropdown: undefined,
        sourceCountryOfFunds: undefined,
        expectedUsageDropdown: undefined,
        purposeOfAccountDropdown: undefined,
        purposeOfAccount: '',
        expectedUsage: '',
        expectedTurnover: '',
        sourceOfFunds: '',
        jobReadOnly: '',
        jobDropDown: undefined,
        jobDescription: '',
        udfBusinessTypeReadOnly: '',
        udfBusinessTypeDropdown: undefined,
        udfBusinessTypeDescription: '',
        relationshipTypeDropDown: undefined,
        purposeOfAccountOthers: '',
        sourceCountryOfFundsDescription: '',
        purposeOfAccountDescription: '',
        expectedUsageDescription: '',
        editAccountDetailsCheck: false,
        secondaryEditCheck: false,
        accountOwnership: '',
        tab: 0,
        secondaryApplicantsData: {
          readOnlyContactDetails: false,
          readOnlyAddressDetails: false,
          readOnlyPersonalDetails: false,
          readOnlyTaxDetails: false,
          readOnlyIdentityDetails: false,
          readOnlyEmploymentDetails: false,
          readOnlyAccountDetails: false,
          readOnlyComplianceDetails: false,
          readOnlyUdfProductDetails: false,
          readOnlyRelationshipTypeDetails: false,
          expandAddressSection: true,
          expandPersonalDetailsSection: true,
          expandTaxDetailsSection: true,
          expandEmploymentDetailsSection: true,
          expandAccountDetailsSection: true,
          expandComplianceDetailsSection: true,
          expandUdfProductDetailsSection: true,
          expandRelationshipDetailsSection: true,
          primaryStatesDropdown: undefined,
          corrStatesDropdown: undefined,
          prevStatesDropdown: undefined,
        },
        secondaryApplicantsPictures: [],
        secondaryApplicantsImage: [],
        secondaryDataErase: false,
        secondaryCustomerOnboard: false,
        productInformation: '',
        applicationType: 'primary',
        secondaryPreviousResidentialAddress: '',
        secondaryCorrespondenceAddress: '',
        secondaryResidentialAddress: '',
        secondaryResidential: '',
        secondaryCorrespondence: '',
        addressSameAsPrimary: false,
        secondaryManualInputCorresponding: '',
        secondaryPrevManualAddress: false,
        isDefaultManualSecondary: '',
        isDefaultSecondary: '',
        secondaryReviewCorresponding: '',
        secondarySelected: '',
        secondaryTaxValue: false,
        secondaryTaxResidentInOtherCountry: false,
        secondaryEmploymentDetails: {},
        primaryCustomerId: '',
        secondaryPartyFailed: '',
        updatedPurposeOfAccountOther: false,
        expectedTurnOver: '',
        readOnlyTaxValueSecondary: false,
        readOnlyTaxValue: false,
        today: new Date().toISOString().substring(0, 10),
        secondarySave: true,
        secondaryApplicantsPicturesEntityId: [],
        readOnlyModeOfOperation: '',
        readOnlyAccountOwnership: '',
        secondaryAreYouUSResident: false,
        readOnlyAccountOwnershipDetails: false,
        isScreenInReadonlyMode: false,
        codeDescription: '',
        codeReference: '',
        consentCode: '',
        b2bSessionId: '',
      };
    },
    hanleClicked(index) {
      this.$set(this.clicked, index, !this.clicked[index]);
    },
    capital(name) {
      const test = name?.toLowerCase();
      return test;
    },
    createBlobUrl(base64String) {
      const binaryString = window.atob(base64String);
      const uint8Array = new Uint8Array(binaryString.length);

      for (let i = 0; i < binaryString.length; i++) {
        uint8Array[i] = binaryString.charCodeAt(i);
      }
      const blob = new Blob([uint8Array], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);

      this.pdfsrc = url;
      return url;
    },
    downloadPdf(arg, entityType) {
      const link = document.createElement('a');

      let documentName = entityType === 'PARTY' ? this.$appSettings?.dcoConfigurations?.onboardingConsentDocumentName ? this.$appSettings.dcoConfigurations.onboardingConsentDocumentName : 'OnboardingConsent_' : entityType === 'ACCOUNT' ? this.$appSettings?.dcoConfigurations?.accountOpeningConsentDocumentName ? this.$appSettings.dcoConfigurations.accountOpeningConsentDocumentName : 'AccountopeningConsent_' : 'Consent_Document_';
      documentName = documentName + this.consentCode;
      link.href = arg;
      link.target = '_blank';
      link.download = documentName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      this.displaySnackBar({
        title: `${this.$t('messages.save.downloadSuccess')}`,
        content: this.$t('messages.save.downloadDocument'),
        type: 'success',
      });
    },
    findSortCode() {
      this.sortCode = true;
      this.sortResults = '';
      this.sortCodeSearch = '';
      this.reviewBankName = '';
      this.reviewBranchName = '';
    },
    async searchBicCode() {
      if (this.sortCodeSearch !== '') {
        this.sortResults = await CommonService.validateSortCode(`${urlObj.validateSortCode}`, {
          sortCode: this.sortCodeSearch,
          b2bSessionId: this.b2bSessionId,
        });
      } else if (this.reviewBankName !== '' && this.reviewBranchName !== '') {
        this.sortResults = await CommonService.validateSortCode(`${urlObj.validateSortCode}`, {
          bankName: this.reviewBankName,
          branchName: this.reviewBranchName,
          b2bSessionId: this.b2bSessionId,
        });
      }
      if (this.sortResults.data?.status === 400) {
        this.sortCodeSearch = '';
      } else {
        this.sortCodeSearch = this.sortResults[0]?.sortCode;
        this.reviewBankName = this.sortResults[0]?.bankName;
        this.reviewBranchName = this.sortResults[0]?.branchName;
        this.bicCode = '';
        this.ibanNumber = '';
      }
    },
    async ibanValidation() {
      this.ibanResults = await CommonService.validateIban(
        `${urlObj.validateIban}/${this.ibanNumber}`,
      );
      this.bicCode = this.ibanResults.data.bicCode;
      this.finalBankName = this.ibanResults.data.bankName;
      if (this.ibanResults.data.valid === true) {
        this.accountNumber = '';
        this.sortCodeFinal = '';
      } else if (this.ibanResults.data.valid === false) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`,
          content: this.ibanResults.data.errorMessage,
          type: 'error' });
      }
      this.enableSaveButton('accountDetails');
    },
    sortCodedisable() {
      if (this.sortCodeSearch !== '') {
        this.bankNameandBranchDisable = true;
      }
    },
    closeBicCode() {
      this.sortCode = false;
      this.sortCodeFinal = this.sortCodeSearch;
      this.finalBankName = this.reviewBankName;
      this.bicCode = '';
      this.ibanNumber = '';
      this.enableSaveButton('accountDetails');
    },
    accountValidationRules() {
      if (this.finalCurrency === '') {
        this.validation = ['This field is required'];
      } else if ((this.ibanValue === true && this.finalCurrency !== '' && this.finalCurrency === 'EUR') || (this.ibanValue === false && this.finalCurrency !== '' && this.finalCurrency === 'GBP')) {
        this.validation = [];
      } else {
        this.validation = ['Invalid Currency - Please enter valid currency'];
      }
    },
    async enableToggle() {
      this.privacyConsentCode = 'DATAPRIVACY';
      this.toggleEnabled = true;
    },
    async enableConsentDailog(entityType) {
      let entityBasedConsentList = '';
      this.currentEntityType = entityType;
      if (entityType === 'PARTY') {
        entityBasedConsentList = await CommonService.getConsentTypes(`${urlObj.consentTypes}/${entityType}`, { b2bSessionId: this.b2bSessionId });
      } else if (entityType === 'ACCOUNT') {
        entityBasedConsentList = await CommonService.getConsentTypes(`${urlObj.consentTypes}/${entityType}/${this.productData?.data?.productName}/${this.productData?.data?.productCode}`, { b2bSessionId: this.b2bSessionId });
      }
      if (entityBasedConsentList !== '' && entityBasedConsentList !== null && entityBasedConsentList?.data.length > 0 && entityBasedConsentList?.status === 200) {
        if (entityType === 'PARTY') {
          this.partyConsents = entityBasedConsentList?.data;
          this.onboardingTandC = true;
          this.accountTandC = false;
        } else if (entityType === 'ACCOUNT') {
          this.accountConsents = entityBasedConsentList?.data;
          this.accountTandC = true;
          this.onboardingTandC = false;
        }
        this.tandC = true;
      } else {
        let messageProperties = [];
        if (entityBasedConsentList?.data.length === 0 && entityBasedConsentList?.status === 200) {
          messageProperties = [
            {
              messageDisplayType: 'popUp',
              messageStatusCode: 400,
              popUpImage: false,
              messageType: 'error',
              messageColor: '',
              messageIcon: '',
              messageInfoType: 'static',
              messageTitle: this.$t('messages.save.consentListNotAvailable'),
              messageContent: this.$t('messages.save.consentListNotAvailableHelper'),
              messageTitleKey: '',
              messageContentKey: '',
            },
          ];
        } else {
          messageProperties = [
            {
              messageDisplayType: 'popUp',
              messageStatusCode: 400,
              popUpImage: false,
              messageType: 'error',
              messageColor: '',
              messageIcon: '',
              messageInfoType: 'static',
              messageTitle: this.$t('messages.save.applicationUnavailable'),
              messageContent: this.$t('messages.save.applicationUnavailableHelper'),
              messageTitleKey: '',
              messageContentKey: '',
            },
          ];
        }
        const saveResponse = {
          data: {},
          status: 400,
        };

        this.handleUserMessage(messageProperties, saveResponse);
      }
    },
    async getActiveConsentInformation(consentCode, index) {
      this.blobData = await CommonService.getTermsAndConditions(`${urlObj.termsAndConditions}/${consentCode}`, { b2bSessionId: this.b2bSessionId }, false);
      if (this.blobData && this.blobData.status !== 200) {
        let messageProperties = [];
        messageProperties = [
          {
            messageDisplayType: 'popUp',
            messageStatusCode: 400,
            popUpImage: false,
            messageType: 'error',
            messageColor: '',
            messageIcon: '',
            messageInfoType: 'static',
            messageTitle: this.$t('messages.save.consentDocumentNotAvailable'),
            messageContent: this.$t('messages.save.consentDocumentNotAvailableHelper'),
            messageTitleKey: '',
            messageContentKey: '',
          },
        ];
        const saveResponse = {
          data: {},
          status: 400,
        };

        this.handleUserMessage(messageProperties, saveResponse);
      }
      this.base64String = this.blobData?.data?.contents;
      this.consentDocuments = this.createBlobUrl(this.base64String);
      this.consentCode = this.blobData?.data?.consentCode;
      this.tandC = false;
      this.toggleEnabled = true;
      this.specificConsentIndex = index;
      this.$set(this.clicked, index, !this.clicked[index]);
    },
    async datePickerLoader(arg, arg1) {
      const yearsAllowed = this.$appSettings.dcoConfigurations.maximumAgeLimit[this.getProductType];

      if (arg1 === 'year') {
        const monthData = this.getProductType === 'lifetimeISA' ? await CommonService.getMonth(`${yearsAllowed}/${arg}/${'LISA'}`) : await CommonService.getMonth(`${yearsAllowed}/${arg}`);
        this.monthsDropdown = monthData.data;
        if (this.tab === 1) {
          this.secondaryFormData.month = '';
          this.secondaryFormData.date = '';
        } else {
          this.formData.month = '';
          this.formData.date = '';
        }
        this.secondaryApplicantsData.month = '';
        this.secondaryApplicantsData.data = '';
      } else if (arg1 === 'month') {
        const dayData = this.getProductType === 'lifetimeISA' ? await CommonService.getDate(`${yearsAllowed}/${this.formData.year}/${arg}/${'LISA'}`) : this.tab === 0 ? await CommonService.getDate(`${yearsAllowed}/${this.formData.year}/${arg}`) : await CommonService.getDate(`${yearsAllowed}/${this.secondaryFormData.year}/${arg}`);
        this.daysDropdown = dayData.data;
        if (this.tab === 1) {
          this.secondaryFormData.date = '';
        } else {
          this.formData.date = '';
        }
        this.secondaryApplicantsData.date = '';
        this.editedMonth = arg;
      } else if (arg1 === 'date') {
        this.formData.date = arg;
        this.secondaryApplicantsData.date = '';
        this.editedDate = arg;
      }
    },
    onCancel(applicantType) {
      if (applicantType === 'primary') {
        this.editCheck = false;
        this.taxValue = this.readOnlyIbanValue;
      } else {
        this.secondaryEditCheck = false;
        this.secondaryTaxValue = this.readOnlyIbanValue;
      }
      this.showUnsavedSnackbar();
      window.scrollTo(0, 0);
    },
    async salutationValue() {
      this.salutation = await CommonService.getSalutationDropDown(urlObj.salutation, { b2bSessionId: this.b2bSessionId });
      const rNationality = await CommonService.getSalutationDropDown(urlObj.nationality, { b2bSessionId: this.b2bSessionId });
      const rCountry = await CommonService.getSalutationDropDown(urlObj.country, { b2bSessionId: this.b2bSessionId });

      this.items = this.salutation.data;
      this.reviewNationality = rNationality.data;
      this.reviewCountry = rCountry.data;
    },
    toggleButton(value, key) {
      this.formData[key] = value;
      this.selectedtToggleValue = value;
    },
    async onFileChanged(e) {
      if (e.size > 512000) {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.save.fileSize'), type: 'error' });
      } else {
        const form = new FormData();

        this.selectedFile = e.name;
        const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;

        form.append('applicationId', reviewMappingData.entityId);
        form.append('document', e);
        form.append(
          'documentCategoryId',
          this.$appSettings.documentCategoryId.FECO_PROOF_CATEGORY_ACCOUNT,
        );
        form.append(
          'documentSubCategoryId',
          this.$appSettings.documentSubCategoryId.FECO_PROOF_CATEGORY_ACCOUNT,
        );
        form.append('version', this.fileStatus.version);
        form.append('applicantType', 'Primary');
        if (this.count > 0) {
          form.append('entityId', this.fileStatus[0].entityId);
        }
        this.fileStatus = await CommonService.documentUpload(urlObj.upload, form, { b2bSessionId: this.b2bSessionId });
        this.filename = this.fileStatus.documentName || this.fileStatus.data[0].documentName;
        this.fileComponent = this.fileName === 'Upload Statement Proof';
        if (this.fileStatus) {
          this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.uploadDocument'), type: 'success' });
        }
      }
    },
    async getUploadedDocuments(reviewMappingData, applicantType) {
      const profileImage = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${reviewMappingData.entityId}/${'FECO_PROOF_CATEGORY_PHOTO'}/${applicantType}`, { b2bSessionId: this.b2bSessionId });
      const identityDocuments = await CommonService.getDocumentUpload(`${urlObj.getUpload}/${reviewMappingData.entityId}/${'FECO_PROOF_CATEGORY_IDENTITY'}/${applicantType}`, { b2bSessionId: this.b2bSessionId });

      if (applicantType === 'Primary') {
        this.image = profileImage?.data[0]?.documentData;
        if (this.image !== undefined) {
          this.image = {
            size:
              Math.round(window.atob(profileImage?.data[0]?.documentData).length / 1024) + ' Kb',
            documentName: profileImage?.data[0]?.documentName,
          };
        }
        if (identityDocuments && identityDocuments.data.length > 0) {
          for (let i = 0; i < 3; i++) {
            this.pictures[i] = {
              size:
                Math.round(window.atob(identityDocuments?.data[i]?.documentData).length / 1024) +
                ' Kb',
              documentName: identityDocuments.data[i].documentName,
            };
          }
        }
      } else if (applicantType === 'Secondary') {
        this.secondaryApplicantsImage = profileImage?.data[0]?.documentData;
        if (this.secondaryApplicantsImage !== undefined) {
          this.secondaryApplicantsImage = {
            size:
              Math.round(window.atob(profileImage?.data[0]?.documentData).length / 1024) + ' Kb',
            documentName: profileImage?.data[0]?.documentName,
          };
        }
        if (identityDocuments && identityDocuments.data.length > 0) {
          for (let i = 0; i < 3; i++) {
            this.secondaryApplicantsPictures[i] = {
              size:
                Math.round(window.atob(identityDocuments?.data[i]?.documentData).length / 1024) +
                ' Kb',
              documentName: identityDocuments.data[i].documentName,
            };
          }
        }
      }
    },
    mobileView() {
      if (window.innerWidth < 600) {
        return false;
      } else if (window.innerWidth > 600) {
        return true;
      }
    },
    async statesloader(arg) {
      if (arg !== '' && arg !== null && arg !== undefined) {
        const primaryState = await CommonService.getStatesDropDown(`${urlObj.states}/${arg}`, { b2bSessionId: this.b2bSessionId }, false);
        if (primaryState && primaryState?.status !== 200) {
          if (this.tab === 0) {
            this.primaryStatesDropdown = [];
          } else {
            this.secondaryApplicantsData.primaryStatesDropdown = [];
          }
        } else {
          if (this.tab === 0) {
            this.primaryStatesDropdown = primaryState.data;
          } else {
            this.secondaryApplicantsData.primaryStatesDropdown = primaryState.data;
          }
        }
        this.loaderEnabled = false;
        store.dispatch('appStore/setAppData', {
          inProgress: false,
        });
      } else {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.countryRequired'), type: 'error' });
      }
    },
    async corrstatesloader(arg) {
      if (arg !== '' && arg !== null && arg !== undefined) {
        const corrState = await CommonService.getStatesDropDown(`${urlObj.states}/${arg}`, { b2bSessionId: this.b2bSessionId }, false);
        if (corrState && corrState?.status !== 200) {
          if (this.tab === 0) {
            this.corrStatesDropdown = [];
          } else {
            this.secondaryApplicantsData.corrStatesDropdown = [];
          }
        } else {
          if (this.tab === 0) {
            this.corrStatesDropdown = corrState.data;
          } else {
            this.secondaryApplicantsData.corrStatesDropdown = corrState.data;
          }
        }
        this.loaderEnabled = false;
        store.dispatch('appStore/setAppData', {
          inProgress: false,
        });
      } else {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.countryRequired'), type: 'error' });
      }
    },
    async prevstatesloader(arg) {
      if (arg !== '' && arg !== null && arg !== undefined) {
        const prevState = await CommonService.getStatesDropDown(`${urlObj.states}/${arg}`, { b2bSessionId: this.b2bSessionId }, false);
        if (prevState && prevState?.status !== 200) {
          if (this.tab === 0) {
            this.prevStatesDropdown = [];
          } else {
            this.secondaryApplicantsData.prevStatesDropdown = [];
          }
        } else {
          if (this.tab === 0) {
            this.prevStatesDropdown = prevState.data;
          } else {
            this.secondaryApplicantsData.prevStatesDropdown = prevState.data;
          }
        }
        this.loaderEnabled = false;
        store.dispatch('appStore/setAppData', {
          inProgress: false,
        });
      } else {
        this.displaySnackBar({ title: `${this.$t('messages.error')}`, content: this.$t('messages.countryRequired'), type: 'error' });
      }
    },
    async retriveAddressDetails() {
      this.applicationType = this.tab === 0 ? 'primary' : 'secondary';
      const retrivedAddressDetails = await CommonService.residentialAddress(`${urlObj.residentialAddress}/${this.selectedRow.addressId}`);

      if (this.applicationType === 'primary') {
        if (this.residential) {
          this.mainAddressresponse = retrivedAddressDetails;
          this.residentialAddress = this.selectedRow.addressText;
        } else if (this.correspondence) {
          this.corrAddressresponse = retrivedAddressDetails;
          this.correspondenceAddress = this.selectedRow.addressText;
        } else {
          this.prevAddressresponse = retrivedAddressDetails;
          this.previousResidentialAddress = this.selectedRow.addressText;
        }
        this.enableSaveButton('addressDetails');
      } else {
        if (this.secondaryResidential) {
          this.secondaryMainAddressresponse = retrivedAddressDetails;
          this.secondaryResidentialAddress = this.selectedRow.addressText;
        } else if (this.secondaryCorrespondence) {
          this.secondaryCorrAddressresponse = retrivedAddressDetails;
          this.secondaryCorrespondenceAddress = this.selectedRow.addressText;
        } else {
          this.secondaryPrevAddressresponse = retrivedAddressDetails;
          this.secondaryPreviousResidentialAddress = this.selectedRow.addressText;
        }
        this.enableSaveButton('addressDetails');
      }
      this.addressLookup = false;
      this.enableOkButton = false;
      this.addressData = [];
    },
    rowClick(item) {
      this.selectedRow = item;
      this.enableOkButton = true;
    },
    enableAddressLookup(key, value) {
      this.selectedRow = '';
      this.addressLookup = true;
      this.addressData = [];
      this.addressText = value;
      if (this.tab === 0) {
        if (key === 'residential') {
          this.residential = true;
          this.correspondence = false;
          this.previousResidential = false;
        } else if (key === 'correspondence') {
          this.residential = false;
          this.correspondence = true;
          this.previousResidential = false;
        } else if (key === 'previousResidential') {
          this.residential = false;
          this.correspondence = false;
          this.previousResidential = true;
        }
      } else if (this.tab === 1) {
        if (key === 'residential') {
          this.secondaryResidential = true;
          this.secondaryCorrespondence = false;
          this.secondaryPreviousResidential = false;
        } else if (key === 'correspondence') {
          this.secondaryResidential = false;
          this.secondaryCorrespondence = true;
          this.secondaryPreviousResidential = false;
        } else if (key === 'previousResidential') {
          this.secondaryResidential = false;
          this.secondaryCorrespondence = false;
          this.secondaryPreviousResidential = true;
        }
      }
      this.loading = true;
      this.addressLookupFunc();
    },
    async addressLookupFunc() {
      this.addressText = this.addressText && this.addressText !== null && this.addressText !== '' && this.addressText.includes('&') ? this.addressText.replaceAll('&', '') : this.addressText;
      const status = await CommonService.addressLookup(`${urlObj.addressLookup}/${'paginationRequired=true'}/${0}/${this.itemsPerPage}&review`, {
        postCode: this.addressText,
        b2bSessionId: this.b2bSessionId,
      }, true);

      this.loading = status?.status === '';
      if (status.status === 400) {
        if (status && status.data && status.data.causes[0] && status.data.causes[0].message.includes('Minimum')) {
          this.displaySnackBar({
            title: status.data.causes[0].message.split('.')[0],
            content: status.data.causes[0].message.split('.')[1],
            type: 'error',
          });
        } else {
          this.displaySnackBar({
            title: `${this.$t('snackbar.additionalInformation')}`,
            content: status.data.causes[0].message,
            type: 'error',
          });
        }
        this.addressData = [];
      } else if (status.status === 200) {
        this.totalLength = Number(status.headers['x-total-count']);
        this.addressData = status.data;
      }
    },
    async handlePagination() {
      this.loading = true;
      this.itemsPerPage = this.options.itemsPerPage;

      const page = this.options.page - 1;

      this.addressText = this.addressText && this.addressText !== null && this.addressText !== '' && this.addressText.includes('&') ? this.addressText.replaceAll('&', '') : this.addressText;
      const status = await CommonService.addressLookup(`${urlObj.addressLookup}/${'paginationRequired=true'}/${page}/${this.itemsPerPage}&review`, {
        postCode: this.addressText,
        b2bSessionId: this.b2bSessionId,
      }, true);

      this.addressData = status && status?.status === 200 ? status?.data : [];
      this.loading = status?.status === '';
    },
    getRowClass(item) {
      if (item.addressId === this.selectedRow.addressId) {
        return 'highlight-table-row';
      }
    },
    clearAddressData(key) {
      const applicantType = this.tab === 0 ? 'formData' : 'secondaryFormData';

      if (key === 'correspondence') {
        this[applicantType].correspondenceAddress = {
          postCode: '',
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
          stateOrprovince: '',
          country: '',
        };
      } else if (key === 'previousResidential') {
        this[applicantType].previousResidentialAddress = {
          postCode: '',
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
          stateOrprovince: '',
          country: '',
        };
        if (this.tab === 0) {
          this.formatFromDate = '';
          this.formatToDate = '';
          this.previousResidentialAddress = '';
        } else if (this.tab === 1) {
          this.formatSecondaryFromDate = '';
          this.formatSecondaryToDate = '';
          this.secondaryPreviousResidentialAddress = '';
        }
      }
      this.enableSaveButton('addressDetails');
    },
    clearAddressValues(data) {
      const applicantType = this.tab === 0 ? 'formData' : 'secondaryFormData';
      if (data === true) {
        if (this.tab === 0) {
          this.residentialAddress = '';
          this.correspondenceAddress = '';
          this.previousResidentialAddress = '';
          this.manualInputCorresponding = true;
          this.prevManualAddress = true;
          this.fromDate = '';
          this.toDate = '';
        } else {
          this.secondaryResidentialAddress = '';
          this.secondaryCorrespondenceAddress = '';
          this.secondaryPreviousResidentialAddress = '';
          this.secondaryManualInputCorresponding = true;
          this.secondaryPrevManualAddress = true;
          this.secondaryFromDate = '';
          this.secondaryToDate = '';
        }
      } else if (data === false) {
        if (this.tab === 0) {
          this.reviewCorresponding = true;
          this.selected = true;
          this.fromDate = '';
          this.toDate = '';
        } else {
          this.secondaryReviewCorresponding = true;
          this.secondarySelected = true;
          this.secondaryFromDate = '';
          this.secondaryToDate = '';
        }
        this[applicantType].primaryAddress = {
          postCode: '',
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
          stateOrprovince: '',
          country: '',
        };
        this[applicantType].correspondenceAddress = {
          postCode: '',
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
          stateOrprovince: '',
          country: '',
        };
        this[applicantType].previousResidentialAddress = {
          postCode: '',
          addressLine1: '',
          addressLine2: '',
          addressLine3: '',
          addressLine4: '',
          city: '',
          stateOrprovince: '',
          country: '',
          fromDate: '',
          toDate: '',
        };
      }
      this.enableSaveButton('addressDetails');
    },
    logIn() {
      const logIn = appSettings.dco.logIn;
      window.location.href = logIn;
    },
    async getJsonpData() {
      this.reviewInformation = await CommonService.getFormSchemaFromLocal('reviewInformation');
    },
    async deleteUploadedFile() {
      const id = this.fileStatus && this.fileStatus.data ? this.fileStatus.data[0].entityId : this.fileStatus.entityId;
      const response = await CommonService.deleteUploadedFile(`${urlObj.upload}/${id}`);

      if (response.status === 200) {
        this.filename = 'Upload Statement Proof';
        this.fileComponent = true;
        this.displaySnackBar({ title: `${this.$t('messages.save.success')}`, content: this.$t('messages.save.deleteDocument'), type: 'success' });
      }
    },
    clearValues(ibanValue) {
      this.finalBankName = '';
      if (ibanValue) {
        this.finalCurrency = '';
        this.ibanNumber = '';
        this.bicCode = '';
      } else if (!ibanValue) {
        this.finalCurrency = 'GBP';
        this.accountNumber = '';
        this.sortCodeFinal = '';
      }
      this.enableSaveButton('addressDetails');
    },
    lisaValidationChecks() {
      window.scrollTo(0, 0);
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const personalInfo = JSON.parse(reviewMappingData.personalInformation);
      const taxInfo = JSON.parse(reviewMappingData.taxInformation);
      const otherInfo = JSON.parse(reviewMappingData.otherInformation);
      const ageValidationCheck = otherInfo && otherInfo?.lisaTransferInWithAgeValidation !== undefined && otherInfo?.lisaTransferInWithAgeValidation !== null ? otherInfo?.lisaTransferInWithAgeValidation === true || otherInfo?.lisaTransferInWithAgeValidation === 'true' : localStorage.getItem('isLisaTransferInWithAgeCheck') === 'true';
      const [year, month, day] = personalInfo?.dateOfBirth.split('-');
      const lisaYears = new Date().getFullYear() - Number(year);

      this.lisaEligibilityPassed = lisaYears > 39 ? false : lisaYears === 39 ? Number(month) - 1 > new Date().getMonth() ? false : Number(month) - 1 === new Date().getMonth() ? !(Number(day) > new Date().getDate()) : true : true;
      if (ageValidationCheck) {
        if (this.lisaEligibilityPassed && taxInfo.taxIdentificationNumber !== '') {
          if (this.image !== undefined) {
            this.finalSubmit();
          } else {
            this.identityVerificationQuery = true;
          }
        } else {
          if (!this.lisaEligibilityPassed && taxInfo && taxInfo.taxIdentificationNumber === '') {
            this.onBoardingConsentsAccepted = false;
            this.accountConsentsAccepted = false;
            this.displaySnackBar({
              title: `${this.$t('messages.lisaValidationError.lisaValidationTitle')}`,
              content: `${this.$t('messages.lisaValidationError.dobAndNinoError')}`,
              type: 'error',
            });
          } else if (!this.lisaEligibilityPassed) {
            this.displaySnackBar({
              title: `${this.$t('messages.lisaValidationError.lisaValidationTitle')}`,
              content: `${this.$t('messages.lisaValidationError.dobError')}`,
              type: 'error',
            });
          } else if (taxInfo && taxInfo.taxIdentificationNumber === '') {
            this.displaySnackBar({
              title: `${this.$t('messages.lisaValidationError.lisaValidationTitle')}`,
              content: `${this.$t('messages.lisaValidationError.ninoError')}`,
              type: 'error',
            });
          }
        }
      } else {
        if (!ageValidationCheck && taxInfo.taxIdentificationNumber !== '') {
          if (this.image !== undefined) {
            this.finalSubmit();
          } else {
            this.identityVerificationQuery = true;
          }
        } else {
          this.displaySnackBar({
            content: this.$t('messages.lisaValidationError.lisaValidationTitle') + '\n' + this.$t('messages.lisaValidationError.ninoError'),
            type: 'error',
          });
        }
      }
    },
    mobileViewScreen() {
      if (window.innerWidth > 424) {
        return true;
      } else {
        return false;
      }
    },
    handleScroll(index, entityType) {
      const el = this.$refs.scrollBox?.$el || this.$refs.scrollBox;
      if (!el) return;
      const atBottom = el.scrollHeight - el.scrollTop - el.clientHeight <= 3;
      const noScroll = el.scrollHeight <= el.clientHeight;
      if (atBottom || noScroll) {
        if (entityType === 'PARTY') {
          this.$set(this.partyDocumentRead, index, true);
        } else if (entityType === 'ACCOUNT') {
          this.$set(this.accountDocumentRead, index, true);
        }
      }
    },
    scrollBack(index, entityType) {
      if (entityType === 'PARTY' && this.consentAccepted.length > 0 && this.consentAccepted[index] !== undefined && this.consentAccepted[index] !== '' && this.consentAccepted[index] !== false) {
        this.tandC = true;
        this.toggleEnabled = false;
        this.$refs.scrollBox.scrollTop = 0;
      // this.$refs.scrollBox.$el.scrollTop = 0;
      } else if (entityType === 'ACCOUNT' && this.accountConsentAccepted.length > 0 && this.accountConsentAccepted[index] !== undefined && this.accountConsentAccepted[index] !== '' && this.accountConsentAccepted[index] !== false) {
        this.tandC = true;
        this.toggleEnabled = false;
        this.$refs.scrollBox.scrollTop = 0;
        // this.$refs.scrollBox.$el.scrollTop = 0;
      } else {
        this.displaySnackBar({
          title: `${this.$t('messages.save.termsAndConditionsTitle')}`,
          content: this.$t('messages.save.termsAndConditions'),
          type: 'error',
        });
        this.tandC = true;
        this.toggleEnabled = false;
        this.$refs.scrollBox.scrollTop = 0;
        // this if loop is added because if the document is read and is not accepted and is closed, if the document is fetched again force read should be applied when enabled.
        if (entityType === 'PARTY') {
          this.$set(this.partyDocumentRead, index, false);
        } else if (entityType === 'ACCOUNT') {
          this.$set(this.accountDocumentRead, index, false);
        }
      }
    },
    handleClick(index, entityType) {
      if (entityType === 'PARTY') {
        this.$set(this.consentAccepted, index, true);
      } else if (entityType === 'ACCOUNT') {
        this.$set(this.accountConsentAccepted, index, true);
      }
      this.tandC = true;
      this.toggleEnabled = false;
      if (this.$refs.scrollBox) {
        this.$refs.scrollBox.scrollTop = 0;
      }
    },
    closepopUP(string) {
      if (string === 'PARTY') {
        for (let i = 0; i < this.partyConsents.length; i++) {
          if (this.consentAccepted[i] === true) {
            this.clickedConfirm = true;
          } else {
            this.displaySnackBar({
              title: `${this.$t('messages.save.termsAndConditionsTitle')}`,
              content: this.$t('messages.save.termsAndConditions'),
              type: 'error',
            });
            this.clickedConfirm = false;
            this.tandC = false;
            return;
          }
        }
        if (this.clickedConfirm) {
          this.tandC = false;
          this.onBoardingConsentsAccepted = true;
        }
      } else if (string === 'ACCOUNT') {
        for (let i = 0; i < this.accountConsents.length; i++) {
          if (this.accountConsentAccepted[i] === true) {
            this.clickedConfirm = true;
          } else {
            this.displaySnackBar({
              title: `${this.$t('messages.save.termsAndConditionsTitle')}`,
              content: this.$t('messages.save.termsAndConditions'),
              type: 'error',
            });
            this.clickedConfirm = false;
            this.tandC = false;
            return;
          }
        }
        if (this.clickedConfirm) {
          this.tandC = false;
          this.accountOpeningConsentAccepted = true;
        }
      }
    },
    async redirectToEligibilityCheck() {
      const accountOwnershipUpdate = await this.saveAccountOwnerShipDetails();
      if (accountOwnershipUpdate) {
        localStorage.setItem('additionalInfoData', JSON.stringify(accountOwnershipUpdate));
        this.secondaryCustomerOnboard = false;
        this.accountOwnershipModal = false;
        this.tab = 0;
        if (this.image !== undefined && this.image !== '') {
          this.IDVForSecondaryApplicant = false;
          localStorage.setItem('IDVEnabled', this.IDVForSecondaryApplicant);
        }
        this.showUnsavedSnackbar();
        this.$router.push({ params: { action: 'secondaryEligibilityCheck' } });
      }
    },
    async genericCodeList(genericCode) {
      let data;
      if (genericCode === 'sourceCountryOfFunds') {
        data = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.sourceCountryOfFunds}`, false);
        this.sourceCountryOfFunds = data.data;
      } else if (genericCode === 'purposeOfAccount') {
        data = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.purposeOfAccount}`, false);
        this.purposeOfAccount = data.data;
      } else if (genericCode === 'expectedUsage') {
        data = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.expectedUsage}`, false);
        this.purposeOfAccount = data.data;
      } else if (genericCode === 'job') {
        data = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.job}`, false);
        this.jobDropDown = data.data;
      } else if (genericCode === 'udfBusinessType') {
        data = await CommonService.getGenericCodeList(`${urlObj.genericCode}/${this.$appSettings.dcoConfigurations.genericCodes.job}`, false);
        this.udfBusinessTypeDropdown = data.data;
      }
    },
    editAccountDetails() {
      this.editAccountDetailsCheck = true;
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const productInformation = JSON.parse(reviewMappingData?.productInformation);

      this.accountOwnership = this.productData?.data?.applicableAccountOperationType === 'SINGLE' ? 'SOLE' : this.productData?.data?.applicableAccountOperationType === 'JOINT' ? 'JOINT' : productInformation?.accountOwnership;
      this.modeOfOperation = productInformation?.modeOfOperation;
      this.formData.modeOfOperation = productInformation?.modeOfOperation;
      this.secondaryApplicantOnboarding = false;
      this.displaySnackBar({ title: `${this.$t('messages.unsavedChangesTitle')}`, content: this.$t('messages.unsavedChangesHelper'), type: 'info' });
    },
    accountOwnerShipData() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const productInformation = JSON.parse(reviewMappingData?.productInformation);
      const modeOfOperationItems = this.getProductType === 'termDeposit' ? this.$appSettings.dcoConfigurations.modeOfOperationFD.data : this.$appSettings.dcoConfigurations.modeOfOperationSavings.data;
      const readOnlyModeOfOperation = modeOfOperationItems.find((item) => item.codeReference === productInformation?.modeOfOperation);

      this.modeOfOperation = productInformation?.modeOfOperation ? (productInformation?.modeOfOperation) : '';
      this.readOnlyModeOfOperation = readOnlyModeOfOperation ? readOnlyModeOfOperation?.codeDescription : productInformation?.modeOfOperation;
      this.accountOwnership = this.productInformation.accountOwnership;
      this.readOnlyAccountOwnership = this.productInformation.accountOwnership;
      this.secondaryApplicantOnboarding = this.accountOwnership === 'JOINT';
      this.editAccountDetailsCheck = false;
    },
    resetAccountInformation() {
      const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;
      const productInformation = JSON.parse(reviewMappingData?.productInformation);

      this.accountOwnership = productInformation?.accountOwnership;
      this.formData.modeOfOperation = productInformation?.modeOfOperation;
      this.editAccountDetailsCheck = false;
      this.showUnsavedSnackbar();
    },
    enableConfirmDetailsButton() {
      const accountOpeningConsentsEnabled = this.$appSettings.dcoConfigurations.isAccountOpeningConsentsEnabled;
      const productsEnabledWithAccountConsents = this.$appSettings.dcoConfigurations.accountOpeningConsentsEnabledProducts;
      const accountOpeningConsentsAccepted = !accountOpeningConsentsEnabled || (!accountOpeningConsentsEnabled && !productsEnabledWithAccountConsents.includes(this.getProductType)) ||
      (accountOpeningConsentsEnabled && !productsEnabledWithAccountConsents.includes(this.getProductType)) || (accountOpeningConsentsEnabled && productsEnabledWithAccountConsents.includes(this.getProductType) &&
      this.accountOpeningConsentAccepted);
      const primaryEditTabs = [this.readOnlyAddressDetails, this.readOnlyPersonalDetails, this.readOnlyTaxDetails, this.readOnlyEmploymentDetails,
        this.readOnlyAccountDetails, this.readOnlyComplianceDetails, this.readOnlyUdfProductDetails];
      const secondaryEditTabs = [this.secondaryApplicantsData.readOnlyAddressDetails, this.secondaryApplicantsData.readOnlyPersonalDetails, this.secondaryApplicantsData.readOnlyTaxDetails,
        this.secondaryApplicantsData.readOnlyEmploymentDetails, this.secondaryApplicantsData.readOnlyAccountDetails, this.secondaryApplicantsData.readOnlyComplianceDetails,
        this.secondaryApplicantsData.readOnlyUdfProductDetails, this.secondaryApplicantsData.readOnlyRelationshipTypeDetails];
      const isScreenInReadonlyMode = primaryEditTabs.every((value) => value === true) && secondaryEditTabs.every((value) => value === true) && !this.editAccountDetailsCheck;
      if (this.consentAcceptedFlag && this.onBoardingConsentsAccepted && accountOpeningConsentsAccepted && isScreenInReadonlyMode && !this.editAccountDetailsCheck) {
        return false;
      } else {
        return true;
      }
    },
    showUnsavedSnackbar(readOnlyKey, data, applicantType) {
      if (applicantType) {
        this.secondaryApplicantsData[readOnlyKey] = data;
      } else {
        this[readOnlyKey] = data;
      }
      const primaryEditTabs = [this.readOnlyAddressDetails, this.readOnlyPersonalDetails, this.readOnlyTaxDetails, this.readOnlyEmploymentDetails,
        this.readOnlyAccountDetails, this.readOnlyComplianceDetails, this.readOnlyUdfProductDetails];
      const secondaryEditTabs = [this.secondaryApplicantsData.readOnlyAddressDetails, this.secondaryApplicantsData.readOnlyPersonalDetails, this.secondaryApplicantsData.readOnlyTaxDetails,
        this.secondaryApplicantsData.readOnlyEmploymentDetails, this.secondaryApplicantsData.readOnlyAccountDetails, this.secondaryApplicantsData.readOnlyComplianceDetails,
        this.secondaryApplicantsData.readOnlyUdfProductDetails, this.secondaryApplicantsData.readOnlyRelationshipTypeDetails];
      const isScreenInReadonlyMode = primaryEditTabs.every((value) => value === true) && secondaryEditTabs.every((value) => value === true) && !this.editAccountDetailsCheck;
      this.isScreenInReadonlyMode = isScreenInReadonlyMode;
      if (isScreenInReadonlyMode) {
        this.displaySnackBar({
          title: `${this.$t('messages.save.defaultSuccess')}`,
          content: this.$t('messages.save.defaultSuccess'),
          type: 'success',
        });
      } else {
        this.displaySnackBar({
          title: `${this.$t('messages.unsavedChangesTitle')}`,
          content: this.$t('messages.unsavedChangesHelper'),
          type: 'info',
        });
      }
    },
    expandCollapseDetails(tab, label) {
      if (tab === 0) {
        if (label === this.$t('reviewInformation.collapse')) {
          this.expandAddressSection = false;
          this.expandPersonalDetailsSection = false;
          this.expandTaxDetailsSection = false;
          this.expandEmploymentDetailsSection = false;
          this.expandAccountDetailsSection = false;
          this.expandComplianceDetailsSection = false;
          this.expandUdfProductDetailsSection = false;
          this.readOnlyContactDetails = false;
          this.readOnlyIdentityDetails = false;
        } else if (label === this.$t('reviewInformation.expand')) {
          this.expandAddressSection = true;
          this.expandPersonalDetailsSection = true;
          this.expandTaxDetailsSection = true;
          this.expandEmploymentDetailsSection = true;
          this.expandAccountDetailsSection = true;
          this.expandComplianceDetailsSection = true;
          this.expandUdfProductDetailsSection = true;
          this.readOnlyContactDetails = true;
          this.readOnlyIdentityDetails = true;
        }
      } else {
        if (label === this.$t('reviewInformation.collapse')) {
          this.secondaryApplicantsData = Object.assign(
            {},
            {
              ...this.secondaryApplicantsData,
              ...{
                expandAddressSection: false,
                expandPersonalDetailsSection: false,
                expandTaxDetailsSection: false,
                expandEmploymentDetailsSection: false,
                expandAccountDetailsSection: false,
                expandComplianceDetailsSection: false,
                expandRelationshipDetailsSection: false,
                readOnlyContactDetails: false,
                readOnlyIdentityDetails: false,
              },
            },
          );
        } else if (label === this.$t('reviewInformation.expand')) {
          this.secondaryApplicantsData = Object.assign(
            {},
            {
              ...this.secondaryApplicantsData,
              ...{
                expandAddressSection: true,
                expandPersonalDetailsSection: true,
                expandTaxDetailsSection: true,
                expandEmploymentDetailsSection: true,
                expandAccountDetailsSection: true,
                expandComplianceDetailsSection: true,
                expandRelationshipDetailsSection: true,
                readOnlyContactDetails: true,
                readOnlyIdentityDetails: true,
              },
            },
          );
        }
      }
    },
  },
  watch: {
    async $route(to, from) {
      if (this.currentActionRoute === 'ReviewInformation') {
        window.scrollTo(0, 0);
        this.localeSelected = localStorage.getItem('localeSelected');
        this.language = this.localeSelected === 'ar' ? this.localeSelected : '';

        const reviewMappingData = store.getters['userStore/userData']?.additionalInfoData;

        if (reviewMappingData.applicationStatus === 'STARTED') {
          this.b2bSessionId = reviewMappingData.b2bSessionId;
          this.reviewScreenData();
          this.loadDropdowns();
        } else {
          const otherInformation = reviewMappingData && reviewMappingData.otherInformation ? JSON.parse(reviewMappingData.otherInformation) : null;

          this.finalScreenData = {
            accountNumber:
            otherInformation && otherInformation.accountId != null ? otherInformation.accountId : null,
            message: reviewMappingData?.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_PENDING' || reviewMappingData?.applicationStatus === 'IDENTITY_VERIFICATION_PENDING'
              ? 'PENDING' : reviewMappingData?.applicationStatus === 'IDENTITY_VERIFICATION_FAILURE' || reviewMappingData?.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_FAILURE'
                ? 'NONCOMPLIANT' : reviewMappingData?.applicationStatus !== 'CUSTOMER_CREATE_FAILED' ? otherInformation?.identityVerificationDetails?.kycStatus : null,
            url: reviewMappingData && reviewMappingData.documentUploadLinkRN ? reviewMappingData.documentUploadLinkRN : reviewMappingData?.applicationStatus === 'IDENTITY_VERIFICATION_PENDING' ||
            reviewMappingData.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_IDV_PEDNING' ? otherInformation && otherInformation.identityVerificationDetails && otherInformation.identityVerificationDetails.documentUploadLinkRN
                ? otherInformation.identityVerificationDetails.documentUploadLinkRN : null : null,
            partyId: reviewMappingData?.customerId,
            applicationStatus: reviewMappingData?.applicationStatus,
          };
          this.isLisaError = reviewMappingData && reviewMappingData.applicationStatus && reviewMappingData.applicationStatus === 'CUSTOMER_CREATE_SUCCESS_LISA_REJECTED' ? 'badRequest' : '';
          this.applicationNumber = reviewMappingData.applicationNumber;
          this.partyCreationFailed = reviewMappingData && (reviewMappingData.applicationStatus === 'CUSTOMER_CREATE_FAILED' || (reviewMappingData.applicationStatus === 'CUSTOMER_CREATE_SUBMITTED' &&
          reviewMappingData.customerId === null && reviewMappingData.customerId === undefined));
          this.$router.push({ params: { action: 'onboardStatus' } });
        }
        this.readOnlyContactDetails = true;
        this.readOnlyAddressDetails = true;
        this.readOnlyPersonalDetails = true;
        this.readOnlyTaxDetails = true;
        this.readOnlyIdentityDetails = true;
        this.readOnlyEmploymentDetails = true;
        this.readOnlyAccountDetails = true;
        this.readOnlyAccountOwnershipDetails = true;
        this.readOnlyComplianceDetails = true;
        this.readOnlyUdfProductDetails = true;
        this.secondaryApplicantsData = Object.assign(
          {},
          {
            ...this.secondaryApplicantsData,
            ...{
              readOnlyContactDetails: true,
              readOnlyAddressDetails: true,
              readOnlyPersonalDetails: true,
              readOnlyTaxDetails: true,
              readOnlyIdentityDetails: true,
              readOnlyEmploymentDetails: true,
              readOnlyAccountDetails: true,
              readOnlyComplianceDetails: true,
              readOnlyUdfProductDetails: true,
              readOnlyRelationshipTypeDetails: true,
            },
          },
        );
      }
    },
    fromDate(val) {
      if (this.tab === 0) {
        this.formData.previousResidentialAddress.fromDate = val;
        this.formatFromDate = val ? moment(val).format('DD-MM-YYYY') : '';
      }
    },
    toDate(val) {
      if (this.tab === 0) {
        this.formData.previousResidentialAddress.toDate = val;
        this.formatToDate = val ? moment(val).format('DD-MM-YYYY') : '';
      }
    },
    secondaryFromDate(val) {
      this.secondaryFormData.previousResidentialAddress.fromDate = val;
      this.formatSecondaryFromDate = val ? moment(val).format('DD-MM-YYYY') : '';
    },
    secondaryToDate(val) {
      this.secondaryFormData.previousResidentialAddress.toDate = val;
      this.formatSecondaryToDate = val ? moment(val).format('DD-MM-YYYY') : '';
    },
  },
};
</script>
<style scoped>
.v-menu__content.theme--light.menuable__content__active {
  width: 300px !important;
}
.v-input--radio-group.v-input--radio-group--row .v-radio {
  margin-right: 36px !important;
}
@media only screen and (min-width: 320px) and (max-width: 600px) {
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
    > .v-input__control
    > .v-input__slot,
  .v-text-field.v-text-field--enclosed .v-text-field__detail {
    padding-left: 6px !important;
    padding-right: 0px !important;
  }
}
</style>
